import { defineComponent as li, onMounted as Hf, onUnmounted as $f, openBlock as oi, createElementBlock as Af, mergeProps as Wf, unref as sl, renderSlot as ii, resolveComponent as hc, createBlock as gc, normalizeProps as vc, guardReactiveProps as bc, withCtx as yc } from "vue";
const Bf = "composition-loading", Df = "composition-loaded", Uf = "composition-load-error", Yf = "item-change", Zf = "extend-mode-on", Qf = "extend-mode-off", Xf = "hotspots-on", Kf = "hotspots-off", qf = "gallery-open", Jf = "gallery-close", Gf = "cc-webplayer:", cl = "cc-webplayer", si = "cc-webplayer-custom-media", ui = "cc-webplayer-icon", ep = "composition-loading", tp = "composition-loaded", np = "composition-load-error", rp = "item-change", ap = "extend-mode-on", lp = "extend-mode-off", op = "hotspots-on", ip = "hotspots-off", sp = "gallery-open", up = "gallery-close", cp = "quality", dp = "cc-webplayer:";
function Xm(i, m) {
  return `https://cdn.car-cutter.com/gallery/${i}/${m}/composition_v3.json`;
}
function fp(i, m) {
  const s = i.split("/"), y = s.pop();
  return [s.join("/"), m, y].join("/");
}
function pp(i) {
  return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i;
}
var wc = { exports: {} }, be = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ec;
function mp() {
  if (ec) return be;
  ec = 1;
  var i = Symbol.for("react.element"), m = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), y = Symbol.for("react.strict_mode"), C = Symbol.for("react.profiler"), _ = Symbol.for("react.provider"), O = Symbol.for("react.context"), M = Symbol.for("react.forward_ref"), E = Symbol.for("react.suspense"), U = Symbol.for("react.memo"), R = Symbol.for("react.lazy"), L = Symbol.iterator;
  function V(p) {
    return p === null || typeof p != "object" ? null : (p = L && p[L] || p["@@iterator"], typeof p == "function" ? p : null);
  }
  var W = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, x = Object.assign, N = {};
  function z(p, k, oe) {
    this.props = p, this.context = k, this.refs = N, this.updater = oe || W;
  }
  z.prototype.isReactComponent = {}, z.prototype.setState = function(p, k) {
    if (typeof p != "object" && typeof p != "function" && p != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, p, k, "setState");
  }, z.prototype.forceUpdate = function(p) {
    this.updater.enqueueForceUpdate(this, p, "forceUpdate");
  };
  function Z() {
  }
  Z.prototype = z.prototype;
  function X(p, k, oe) {
    this.props = p, this.context = k, this.refs = N, this.updater = oe || W;
  }
  var H = X.prototype = new Z();
  H.constructor = X, x(H, z.prototype), H.isPureReactComponent = !0;
  var j = Array.isArray, Q = Object.prototype.hasOwnProperty, Y = { current: null }, q = { key: !0, ref: !0, __self: !0, __source: !0 };
  function fe(p, k, oe) {
    var ie, me = {}, ve = null, we = null;
    if (k != null) for (ie in k.ref !== void 0 && (we = k.ref), k.key !== void 0 && (ve = "" + k.key), k) Q.call(k, ie) && !q.hasOwnProperty(ie) && (me[ie] = k[ie]);
    var ye = arguments.length - 2;
    if (ye === 1) me.children = oe;
    else if (1 < ye) {
      for (var Ce = Array(ye), Be = 0; Be < ye; Be++) Ce[Be] = arguments[Be + 2];
      me.children = Ce;
    }
    if (p && p.defaultProps) for (ie in ye = p.defaultProps, ye) me[ie] === void 0 && (me[ie] = ye[ie]);
    return { $$typeof: i, type: p, key: ve, ref: we, props: me, _owner: Y.current };
  }
  function de(p, k) {
    return { $$typeof: i, type: p.type, key: k, ref: p.ref, props: p.props, _owner: p._owner };
  }
  function K(p) {
    return typeof p == "object" && p !== null && p.$$typeof === i;
  }
  function ee(p) {
    var k = { "=": "=0", ":": "=2" };
    return "$" + p.replace(/[=:]/g, function(oe) {
      return k[oe];
    });
  }
  var ae = /\/+/g;
  function ne(p, k) {
    return typeof p == "object" && p !== null && p.key != null ? ee("" + p.key) : k.toString(36);
  }
  function se(p, k, oe, ie, me) {
    var ve = typeof p;
    (ve === "undefined" || ve === "boolean") && (p = null);
    var we = !1;
    if (p === null) we = !0;
    else switch (ve) {
      case "string":
      case "number":
        we = !0;
        break;
      case "object":
        switch (p.$$typeof) {
          case i:
          case m:
            we = !0;
        }
    }
    if (we) return we = p, me = me(we), p = ie === "" ? "." + ne(we, 0) : ie, j(me) ? (oe = "", p != null && (oe = p.replace(ae, "$&/") + "/"), se(me, k, oe, "", function(Be) {
      return Be;
    })) : me != null && (K(me) && (me = de(me, oe + (!me.key || we && we.key === me.key ? "" : ("" + me.key).replace(ae, "$&/") + "/") + p)), k.push(me)), 1;
    if (we = 0, ie = ie === "" ? "." : ie + ":", j(p)) for (var ye = 0; ye < p.length; ye++) {
      ve = p[ye];
      var Ce = ie + ne(ve, ye);
      we += se(ve, k, oe, Ce, me);
    }
    else if (Ce = V(p), typeof Ce == "function") for (p = Ce.call(p), ye = 0; !(ve = p.next()).done; ) ve = ve.value, Ce = ie + ne(ve, ye++), we += se(ve, k, oe, Ce, me);
    else if (ve === "object") throw k = String(p), Error("Objects are not valid as a React child (found: " + (k === "[object Object]" ? "object with keys {" + Object.keys(p).join(", ") + "}" : k) + "). If you meant to render a collection of children, use an array instead.");
    return we;
  }
  function D(p, k, oe) {
    if (p == null) return p;
    var ie = [], me = 0;
    return se(p, ie, "", "", function(ve) {
      return k.call(oe, ve, me++);
    }), ie;
  }
  function S(p) {
    if (p._status === -1) {
      var k = p._result;
      k = k(), k.then(function(oe) {
        (p._status === 0 || p._status === -1) && (p._status = 1, p._result = oe);
      }, function(oe) {
        (p._status === 0 || p._status === -1) && (p._status = 2, p._result = oe);
      }), p._status === -1 && (p._status = 0, p._result = k);
    }
    if (p._status === 1) return p._result.default;
    throw p._result;
  }
  var B = { current: null }, w = { transition: null }, $ = { ReactCurrentDispatcher: B, ReactCurrentBatchConfig: w, ReactCurrentOwner: Y };
  function F() {
    throw Error("act(...) is not supported in production builds of React.");
  }
  return be.Children = { map: D, forEach: function(p, k, oe) {
    D(p, function() {
      k.apply(this, arguments);
    }, oe);
  }, count: function(p) {
    var k = 0;
    return D(p, function() {
      k++;
    }), k;
  }, toArray: function(p) {
    return D(p, function(k) {
      return k;
    }) || [];
  }, only: function(p) {
    if (!K(p)) throw Error("React.Children.only expected to receive a single React element child.");
    return p;
  } }, be.Component = z, be.Fragment = s, be.Profiler = C, be.PureComponent = X, be.StrictMode = y, be.Suspense = E, be.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = $, be.act = F, be.cloneElement = function(p, k, oe) {
    if (p == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + p + ".");
    var ie = x({}, p.props), me = p.key, ve = p.ref, we = p._owner;
    if (k != null) {
      if (k.ref !== void 0 && (ve = k.ref, we = Y.current), k.key !== void 0 && (me = "" + k.key), p.type && p.type.defaultProps) var ye = p.type.defaultProps;
      for (Ce in k) Q.call(k, Ce) && !q.hasOwnProperty(Ce) && (ie[Ce] = k[Ce] === void 0 && ye !== void 0 ? ye[Ce] : k[Ce]);
    }
    var Ce = arguments.length - 2;
    if (Ce === 1) ie.children = oe;
    else if (1 < Ce) {
      ye = Array(Ce);
      for (var Be = 0; Be < Ce; Be++) ye[Be] = arguments[Be + 2];
      ie.children = ye;
    }
    return { $$typeof: i, type: p.type, key: me, ref: ve, props: ie, _owner: we };
  }, be.createContext = function(p) {
    return p = { $$typeof: O, _currentValue: p, _currentValue2: p, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, p.Provider = { $$typeof: _, _context: p }, p.Consumer = p;
  }, be.createElement = fe, be.createFactory = function(p) {
    var k = fe.bind(null, p);
    return k.type = p, k;
  }, be.createRef = function() {
    return { current: null };
  }, be.forwardRef = function(p) {
    return { $$typeof: M, render: p };
  }, be.isValidElement = K, be.lazy = function(p) {
    return { $$typeof: R, _payload: { _status: -1, _result: p }, _init: S };
  }, be.memo = function(p, k) {
    return { $$typeof: U, type: p, compare: k === void 0 ? null : k };
  }, be.startTransition = function(p) {
    var k = w.transition;
    w.transition = {};
    try {
      p();
    } finally {
      w.transition = k;
    }
  }, be.unstable_act = F, be.useCallback = function(p, k) {
    return B.current.useCallback(p, k);
  }, be.useContext = function(p) {
    return B.current.useContext(p);
  }, be.useDebugValue = function() {
  }, be.useDeferredValue = function(p) {
    return B.current.useDeferredValue(p);
  }, be.useEffect = function(p, k) {
    return B.current.useEffect(p, k);
  }, be.useId = function() {
    return B.current.useId();
  }, be.useImperativeHandle = function(p, k, oe) {
    return B.current.useImperativeHandle(p, k, oe);
  }, be.useInsertionEffect = function(p, k) {
    return B.current.useInsertionEffect(p, k);
  }, be.useLayoutEffect = function(p, k) {
    return B.current.useLayoutEffect(p, k);
  }, be.useMemo = function(p, k) {
    return B.current.useMemo(p, k);
  }, be.useReducer = function(p, k, oe) {
    return B.current.useReducer(p, k, oe);
  }, be.useRef = function(p) {
    return B.current.useRef(p);
  }, be.useState = function(p) {
    return B.current.useState(p);
  }, be.useSyncExternalStore = function(p, k, oe) {
    return B.current.useSyncExternalStore(p, k, oe);
  }, be.useTransition = function() {
    return B.current.useTransition();
  }, be.version = "18.3.1", be;
}
wc.exports = mp();
var h = wc.exports;
const dl = /* @__PURE__ */ pp(h);
var xc = { exports: {} }, at = {}, tc = { exports: {} }, nc = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rc;
function hp() {
  return rc || (rc = 1, function(i) {
    function m(w, $) {
      var F = w.length;
      w.push($);
      e: for (; 0 < F; ) {
        var p = F - 1 >>> 1, k = w[p];
        if (0 < C(k, $)) w[p] = $, w[F] = k, F = p;
        else break e;
      }
    }
    function s(w) {
      return w.length === 0 ? null : w[0];
    }
    function y(w) {
      if (w.length === 0) return null;
      var $ = w[0], F = w.pop();
      if (F !== $) {
        w[0] = F;
        e: for (var p = 0, k = w.length, oe = k >>> 1; p < oe; ) {
          var ie = 2 * (p + 1) - 1, me = w[ie], ve = ie + 1, we = w[ve];
          if (0 > C(me, F)) ve < k && 0 > C(we, me) ? (w[p] = we, w[ve] = F, p = ve) : (w[p] = me, w[ie] = F, p = ie);
          else if (ve < k && 0 > C(we, F)) w[p] = we, w[ve] = F, p = ve;
          else break e;
        }
      }
      return $;
    }
    function C(w, $) {
      var F = w.sortIndex - $.sortIndex;
      return F !== 0 ? F : w.id - $.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var _ = performance;
      i.unstable_now = function() {
        return _.now();
      };
    } else {
      var O = Date, M = O.now();
      i.unstable_now = function() {
        return O.now() - M;
      };
    }
    var E = [], U = [], R = 1, L = null, V = 3, W = !1, x = !1, N = !1, z = typeof setTimeout == "function" ? setTimeout : null, Z = typeof clearTimeout == "function" ? clearTimeout : null, X = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function H(w) {
      for (var $ = s(U); $ !== null; ) {
        if ($.callback === null) y(U);
        else if ($.startTime <= w) y(U), $.sortIndex = $.expirationTime, m(E, $);
        else break;
        $ = s(U);
      }
    }
    function j(w) {
      if (N = !1, H(w), !x) if (s(E) !== null) x = !0, S(Q);
      else {
        var $ = s(U);
        $ !== null && B(j, $.startTime - w);
      }
    }
    function Q(w, $) {
      x = !1, N && (N = !1, Z(fe), fe = -1), W = !0;
      var F = V;
      try {
        for (H($), L = s(E); L !== null && (!(L.expirationTime > $) || w && !ee()); ) {
          var p = L.callback;
          if (typeof p == "function") {
            L.callback = null, V = L.priorityLevel;
            var k = p(L.expirationTime <= $);
            $ = i.unstable_now(), typeof k == "function" ? L.callback = k : L === s(E) && y(E), H($);
          } else y(E);
          L = s(E);
        }
        if (L !== null) var oe = !0;
        else {
          var ie = s(U);
          ie !== null && B(j, ie.startTime - $), oe = !1;
        }
        return oe;
      } finally {
        L = null, V = F, W = !1;
      }
    }
    var Y = !1, q = null, fe = -1, de = 5, K = -1;
    function ee() {
      return !(i.unstable_now() - K < de);
    }
    function ae() {
      if (q !== null) {
        var w = i.unstable_now();
        K = w;
        var $ = !0;
        try {
          $ = q(!0, w);
        } finally {
          $ ? ne() : (Y = !1, q = null);
        }
      } else Y = !1;
    }
    var ne;
    if (typeof X == "function") ne = function() {
      X(ae);
    };
    else if (typeof MessageChannel < "u") {
      var se = new MessageChannel(), D = se.port2;
      se.port1.onmessage = ae, ne = function() {
        D.postMessage(null);
      };
    } else ne = function() {
      z(ae, 0);
    };
    function S(w) {
      q = w, Y || (Y = !0, ne());
    }
    function B(w, $) {
      fe = z(function() {
        w(i.unstable_now());
      }, $);
    }
    i.unstable_IdlePriority = 5, i.unstable_ImmediatePriority = 1, i.unstable_LowPriority = 4, i.unstable_NormalPriority = 3, i.unstable_Profiling = null, i.unstable_UserBlockingPriority = 2, i.unstable_cancelCallback = function(w) {
      w.callback = null;
    }, i.unstable_continueExecution = function() {
      x || W || (x = !0, S(Q));
    }, i.unstable_forceFrameRate = function(w) {
      0 > w || 125 < w ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : de = 0 < w ? Math.floor(1e3 / w) : 5;
    }, i.unstable_getCurrentPriorityLevel = function() {
      return V;
    }, i.unstable_getFirstCallbackNode = function() {
      return s(E);
    }, i.unstable_next = function(w) {
      switch (V) {
        case 1:
        case 2:
        case 3:
          var $ = 3;
          break;
        default:
          $ = V;
      }
      var F = V;
      V = $;
      try {
        return w();
      } finally {
        V = F;
      }
    }, i.unstable_pauseExecution = function() {
    }, i.unstable_requestPaint = function() {
    }, i.unstable_runWithPriority = function(w, $) {
      switch (w) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          w = 3;
      }
      var F = V;
      V = w;
      try {
        return $();
      } finally {
        V = F;
      }
    }, i.unstable_scheduleCallback = function(w, $, F) {
      var p = i.unstable_now();
      switch (typeof F == "object" && F !== null ? (F = F.delay, F = typeof F == "number" && 0 < F ? p + F : p) : F = p, w) {
        case 1:
          var k = -1;
          break;
        case 2:
          k = 250;
          break;
        case 5:
          k = 1073741823;
          break;
        case 4:
          k = 1e4;
          break;
        default:
          k = 5e3;
      }
      return k = F + k, w = { id: R++, callback: $, priorityLevel: w, startTime: F, expirationTime: k, sortIndex: -1 }, F > p ? (w.sortIndex = F, m(U, w), s(E) === null && w === s(U) && (N ? (Z(fe), fe = -1) : N = !0, B(j, F - p))) : (w.sortIndex = k, m(E, w), x || W || (x = !0, S(Q))), w;
    }, i.unstable_shouldYield = ee, i.unstable_wrapCallback = function(w) {
      var $ = V;
      return function() {
        var F = V;
        V = $;
        try {
          return w.apply(this, arguments);
        } finally {
          V = F;
        }
      };
    };
  }(nc)), nc;
}
var ac;
function gp() {
  return ac || (ac = 1, tc.exports = hp()), tc.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lc;
function vp() {
  if (lc) return at;
  lc = 1;
  var i = h, m = gp();
  function s(e) {
    for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
    return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var y = /* @__PURE__ */ new Set(), C = {};
  function _(e, t) {
    O(e, t), O(e + "Capture", t);
  }
  function O(e, t) {
    for (C[e] = t, e = 0; e < t.length; e++) y.add(t[e]);
  }
  var M = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), E = Object.prototype.hasOwnProperty, U = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, R = {}, L = {};
  function V(e) {
    return E.call(L, e) ? !0 : E.call(R, e) ? !1 : U.test(e) ? L[e] = !0 : (R[e] = !0, !1);
  }
  function W(e, t, n, r) {
    if (n !== null && n.type === 0) return !1;
    switch (typeof t) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return r ? !1 : n !== null ? !n.acceptsBooleans : (e = e.toLowerCase().slice(0, 5), e !== "data-" && e !== "aria-");
      default:
        return !1;
    }
  }
  function x(e, t, n, r) {
    if (t === null || typeof t > "u" || W(e, t, n, r)) return !0;
    if (r) return !1;
    if (n !== null) switch (n.type) {
      case 3:
        return !t;
      case 4:
        return t === !1;
      case 5:
        return isNaN(t);
      case 6:
        return isNaN(t) || 1 > t;
    }
    return !1;
  }
  function N(e, t, n, r, a, l, o) {
    this.acceptsBooleans = t === 2 || t === 3 || t === 4, this.attributeName = r, this.attributeNamespace = a, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = l, this.removeEmptyString = o;
  }
  var z = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e) {
    z[e] = new N(e, 0, !1, e, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
    var t = e[0];
    z[t] = new N(t, 1, !1, e[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
    z[e] = new N(e, 2, !1, e.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e) {
    z[e] = new N(e, 2, !1, e, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e) {
    z[e] = new N(e, 3, !1, e.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(e) {
    z[e] = new N(e, 3, !0, e, null, !1, !1);
  }), ["capture", "download"].forEach(function(e) {
    z[e] = new N(e, 4, !1, e, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(e) {
    z[e] = new N(e, 6, !1, e, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(e) {
    z[e] = new N(e, 5, !1, e.toLowerCase(), null, !1, !1);
  });
  var Z = /[\-:]([a-z])/g;
  function X(e) {
    return e[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e) {
    var t = e.replace(
      Z,
      X
    );
    z[t] = new N(t, 1, !1, e, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e) {
    var t = e.replace(Z, X);
    z[t] = new N(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(e) {
    var t = e.replace(Z, X);
    z[t] = new N(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(e) {
    z[e] = new N(e, 1, !1, e.toLowerCase(), null, !1, !1);
  }), z.xlinkHref = new N("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(e) {
    z[e] = new N(e, 1, !1, e.toLowerCase(), null, !0, !0);
  });
  function H(e, t, n, r) {
    var a = z.hasOwnProperty(t) ? z[t] : null;
    (a !== null ? a.type !== 0 : r || !(2 < t.length) || t[0] !== "o" && t[0] !== "O" || t[1] !== "n" && t[1] !== "N") && (x(t, n, a, r) && (n = null), r || a === null ? V(t) && (n === null ? e.removeAttribute(t) : e.setAttribute(t, "" + n)) : a.mustUseProperty ? e[a.propertyName] = n === null ? a.type === 3 ? !1 : "" : n : (t = a.attributeName, r = a.attributeNamespace, n === null ? e.removeAttribute(t) : (a = a.type, n = a === 3 || a === 4 && n === !0 ? "" : "" + n, r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
  }
  var j = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, Q = Symbol.for("react.element"), Y = Symbol.for("react.portal"), q = Symbol.for("react.fragment"), fe = Symbol.for("react.strict_mode"), de = Symbol.for("react.profiler"), K = Symbol.for("react.provider"), ee = Symbol.for("react.context"), ae = Symbol.for("react.forward_ref"), ne = Symbol.for("react.suspense"), se = Symbol.for("react.suspense_list"), D = Symbol.for("react.memo"), S = Symbol.for("react.lazy"), B = Symbol.for("react.offscreen"), w = Symbol.iterator;
  function $(e) {
    return e === null || typeof e != "object" ? null : (e = w && e[w] || e["@@iterator"], typeof e == "function" ? e : null);
  }
  var F = Object.assign, p;
  function k(e) {
    if (p === void 0) try {
      throw Error();
    } catch (n) {
      var t = n.stack.trim().match(/\n( *(at )?)/);
      p = t && t[1] || "";
    }
    return `
` + p + e;
  }
  var oe = !1;
  function ie(e, t) {
    if (!e || oe) return "";
    oe = !0;
    var n = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (t) if (t = function() {
        throw Error();
      }, Object.defineProperty(t.prototype, "props", { set: function() {
        throw Error();
      } }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(t, []);
        } catch (b) {
          var r = b;
        }
        Reflect.construct(e, [], t);
      } else {
        try {
          t.call();
        } catch (b) {
          r = b;
        }
        e.call(t.prototype);
      }
      else {
        try {
          throw Error();
        } catch (b) {
          r = b;
        }
        e();
      }
    } catch (b) {
      if (b && r && typeof b.stack == "string") {
        for (var a = b.stack.split(`
`), l = r.stack.split(`
`), o = a.length - 1, c = l.length - 1; 1 <= o && 0 <= c && a[o] !== l[c]; ) c--;
        for (; 1 <= o && 0 <= c; o--, c--) if (a[o] !== l[c]) {
          if (o !== 1 || c !== 1)
            do
              if (o--, c--, 0 > c || a[o] !== l[c]) {
                var d = `
` + a[o].replace(" at new ", " at ");
                return e.displayName && d.includes("<anonymous>") && (d = d.replace("<anonymous>", e.displayName)), d;
              }
            while (1 <= o && 0 <= c);
          break;
        }
      }
    } finally {
      oe = !1, Error.prepareStackTrace = n;
    }
    return (e = e ? e.displayName || e.name : "") ? k(e) : "";
  }
  function me(e) {
    switch (e.tag) {
      case 5:
        return k(e.type);
      case 16:
        return k("Lazy");
      case 13:
        return k("Suspense");
      case 19:
        return k("SuspenseList");
      case 0:
      case 2:
      case 15:
        return e = ie(e.type, !1), e;
      case 11:
        return e = ie(e.type.render, !1), e;
      case 1:
        return e = ie(e.type, !0), e;
      default:
        return "";
    }
  }
  function ve(e) {
    if (e == null) return null;
    if (typeof e == "function") return e.displayName || e.name || null;
    if (typeof e == "string") return e;
    switch (e) {
      case q:
        return "Fragment";
      case Y:
        return "Portal";
      case de:
        return "Profiler";
      case fe:
        return "StrictMode";
      case ne:
        return "Suspense";
      case se:
        return "SuspenseList";
    }
    if (typeof e == "object") switch (e.$$typeof) {
      case ee:
        return (e.displayName || "Context") + ".Consumer";
      case K:
        return (e._context.displayName || "Context") + ".Provider";
      case ae:
        var t = e.render;
        return e = e.displayName, e || (e = t.displayName || t.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
      case D:
        return t = e.displayName || null, t !== null ? t : ve(e.type) || "Memo";
      case S:
        t = e._payload, e = e._init;
        try {
          return ve(e(t));
        } catch {
        }
    }
    return null;
  }
  function we(e) {
    var t = e.type;
    switch (e.tag) {
      case 24:
        return "Cache";
      case 9:
        return (t.displayName || "Context") + ".Consumer";
      case 10:
        return (t._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return e = t.render, e = e.displayName || e.name || "", t.displayName || (e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return t;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return ve(t);
      case 8:
        return t === fe ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof t == "function") return t.displayName || t.name || null;
        if (typeof t == "string") return t;
    }
    return null;
  }
  function ye(e) {
    switch (typeof e) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return e;
      case "object":
        return e;
      default:
        return "";
    }
  }
  function Ce(e) {
    var t = e.type;
    return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
  }
  function Be(e) {
    var t = Ce(e) ? "checked" : "value", n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t), r = "" + e[t];
    if (!e.hasOwnProperty(t) && typeof n < "u" && typeof n.get == "function" && typeof n.set == "function") {
      var a = n.get, l = n.set;
      return Object.defineProperty(e, t, { configurable: !0, get: function() {
        return a.call(this);
      }, set: function(o) {
        r = "" + o, l.call(this, o);
      } }), Object.defineProperty(e, t, { enumerable: n.enumerable }), { getValue: function() {
        return r;
      }, setValue: function(o) {
        r = "" + o;
      }, stopTracking: function() {
        e._valueTracker = null, delete e[t];
      } };
    }
  }
  function Bt(e) {
    e._valueTracker || (e._valueTracker = Be(e));
  }
  function jt(e) {
    if (!e) return !1;
    var t = e._valueTracker;
    if (!t) return !0;
    var n = t.getValue(), r = "";
    return e && (r = Ce(e) ? e.checked ? "true" : "false" : e.value), e = r, e !== n ? (t.setValue(e), !0) : !1;
  }
  function Dt(e) {
    if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u") return null;
    try {
      return e.activeElement || e.body;
    } catch {
      return e.body;
    }
  }
  function or(e, t) {
    var n = t.checked;
    return F({}, t, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: n ?? e._wrapperState.initialChecked });
  }
  function Qr(e, t) {
    var n = t.defaultValue == null ? "" : t.defaultValue, r = t.checked != null ? t.checked : t.defaultChecked;
    n = ye(t.value != null ? t.value : n), e._wrapperState = { initialChecked: r, initialValue: n, controlled: t.type === "checkbox" || t.type === "radio" ? t.checked != null : t.value != null };
  }
  function Mn(e, t) {
    t = t.checked, t != null && H(e, "checked", t, !1);
  }
  function Et(e, t) {
    Mn(e, t);
    var n = ye(t.value), r = t.type;
    if (n != null) r === "number" ? (n === 0 && e.value === "" || e.value != n) && (e.value = "" + n) : e.value !== "" + n && (e.value = "" + n);
    else if (r === "submit" || r === "reset") {
      e.removeAttribute("value");
      return;
    }
    t.hasOwnProperty("value") ? mn(e, t.type, n) : t.hasOwnProperty("defaultValue") && mn(e, t.type, ye(t.defaultValue)), t.checked == null && t.defaultChecked != null && (e.defaultChecked = !!t.defaultChecked);
  }
  function Xr(e, t, n) {
    if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
      var r = t.type;
      if (!(r !== "submit" && r !== "reset" || t.value !== void 0 && t.value !== null)) return;
      t = "" + e._wrapperState.initialValue, n || t === e.value || (e.value = t), e.defaultValue = t;
    }
    n = e.name, n !== "" && (e.name = ""), e.defaultChecked = !!e._wrapperState.initialChecked, n !== "" && (e.name = n);
  }
  function mn(e, t, n) {
    (t !== "number" || Dt(e.ownerDocument) !== e) && (n == null ? e.defaultValue = "" + e._wrapperState.initialValue : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
  }
  var Ut = Array.isArray;
  function Nt(e, t, n, r) {
    if (e = e.options, t) {
      t = {};
      for (var a = 0; a < n.length; a++) t["$" + n[a]] = !0;
      for (n = 0; n < e.length; n++) a = t.hasOwnProperty("$" + e[n].value), e[n].selected !== a && (e[n].selected = a), a && r && (e[n].defaultSelected = !0);
    } else {
      for (n = "" + ye(n), t = null, a = 0; a < e.length; a++) {
        if (e[a].value === n) {
          e[a].selected = !0, r && (e[a].defaultSelected = !0);
          return;
        }
        t !== null || e[a].disabled || (t = e[a]);
      }
      t !== null && (t.selected = !0);
    }
  }
  function Pn(e, t) {
    if (t.dangerouslySetInnerHTML != null) throw Error(s(91));
    return F({}, t, { value: void 0, defaultValue: void 0, children: "" + e._wrapperState.initialValue });
  }
  function It(e, t) {
    var n = t.value;
    if (n == null) {
      if (n = t.children, t = t.defaultValue, n != null) {
        if (t != null) throw Error(s(92));
        if (Ut(n)) {
          if (1 < n.length) throw Error(s(93));
          n = n[0];
        }
        t = n;
      }
      t == null && (t = ""), n = t;
    }
    e._wrapperState = { initialValue: ye(n) };
  }
  function Rt(e, t) {
    var n = ye(t.value), r = ye(t.defaultValue);
    n != null && (n = "" + n, n !== e.value && (e.value = n), t.defaultValue == null && e.defaultValue !== n && (e.defaultValue = n)), r != null && (e.defaultValue = "" + r);
  }
  function jn(e) {
    var t = e.textContent;
    t === e._wrapperState.initialValue && t !== "" && t !== null && (e.value = t);
  }
  function In(e) {
    switch (e) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function ir(e, t) {
    return e == null || e === "http://www.w3.org/1999/xhtml" ? In(t) : e === "http://www.w3.org/2000/svg" && t === "foreignObject" ? "http://www.w3.org/1999/xhtml" : e;
  }
  var he, Fe = function(e) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(t, n, r, a) {
      MSApp.execUnsafeLocalFunction(function() {
        return e(t, n, r, a);
      });
    } : e;
  }(function(e, t) {
    if (e.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in e) e.innerHTML = t;
    else {
      for (he = he || document.createElement("div"), he.innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = he.firstChild; e.firstChild; ) e.removeChild(e.firstChild);
      for (; t.firstChild; ) e.appendChild(t.firstChild);
    }
  });
  function ze(e, t) {
    if (t) {
      var n = e.firstChild;
      if (n && n === e.lastChild && n.nodeType === 3) {
        n.nodeValue = t;
        return;
      }
    }
    e.textContent = t;
  }
  var Me = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, fl = ["Webkit", "ms", "Moz", "O"];
  Object.keys(Me).forEach(function(e) {
    fl.forEach(function(t) {
      t = t + e.charAt(0).toUpperCase() + e.substring(1), Me[t] = Me[e];
    });
  });
  function mi(e, t, n) {
    return t == null || typeof t == "boolean" || t === "" ? "" : n || typeof t != "number" || t === 0 || Me.hasOwnProperty(e) && Me[e] ? ("" + t).trim() : t + "px";
  }
  function hi(e, t) {
    e = e.style;
    for (var n in t) if (t.hasOwnProperty(n)) {
      var r = n.indexOf("--") === 0, a = mi(n, t[n], r);
      n === "float" && (n = "cssFloat"), r ? e.setProperty(n, a) : e[n] = a;
    }
  }
  var Bc = F({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function pl(e, t) {
    if (t) {
      if (Bc[e] && (t.children != null || t.dangerouslySetInnerHTML != null)) throw Error(s(137, e));
      if (t.dangerouslySetInnerHTML != null) {
        if (t.children != null) throw Error(s(60));
        if (typeof t.dangerouslySetInnerHTML != "object" || !("__html" in t.dangerouslySetInnerHTML)) throw Error(s(61));
      }
      if (t.style != null && typeof t.style != "object") throw Error(s(62));
    }
  }
  function ml(e, t) {
    if (e.indexOf("-") === -1) return typeof t.is == "string";
    switch (e) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var hl = null;
  function gl(e) {
    return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
  }
  var vl = null, Rn = null, Tn = null;
  function gi(e) {
    if (e = zr(e)) {
      if (typeof vl != "function") throw Error(s(280));
      var t = e.stateNode;
      t && (t = ba(t), vl(e.stateNode, e.type, t));
    }
  }
  function vi(e) {
    Rn ? Tn ? Tn.push(e) : Tn = [e] : Rn = e;
  }
  function bi() {
    if (Rn) {
      var e = Rn, t = Tn;
      if (Tn = Rn = null, gi(e), t) for (e = 0; e < t.length; e++) gi(t[e]);
    }
  }
  function yi(e, t) {
    return e(t);
  }
  function wi() {
  }
  var bl = !1;
  function xi(e, t, n) {
    if (bl) return e(t, n);
    bl = !0;
    try {
      return yi(e, t, n);
    } finally {
      bl = !1, (Rn !== null || Tn !== null) && (wi(), bi());
    }
  }
  function sr(e, t) {
    var n = e.stateNode;
    if (n === null) return null;
    var r = ba(n);
    if (r === null) return null;
    n = r[t];
    e: switch (t) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (r = !r.disabled) || (e = e.type, r = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !r;
        break e;
      default:
        e = !1;
    }
    if (e) return null;
    if (n && typeof n != "function") throw Error(s(231, t, typeof n));
    return n;
  }
  var yl = !1;
  if (M) try {
    var ur = {};
    Object.defineProperty(ur, "passive", { get: function() {
      yl = !0;
    } }), window.addEventListener("test", ur, ur), window.removeEventListener("test", ur, ur);
  } catch {
    yl = !1;
  }
  function Dc(e, t, n, r, a, l, o, c, d) {
    var b = Array.prototype.slice.call(arguments, 3);
    try {
      t.apply(n, b);
    } catch (I) {
      this.onError(I);
    }
  }
  var cr = !1, Kr = null, qr = !1, wl = null, Uc = { onError: function(e) {
    cr = !0, Kr = e;
  } };
  function Yc(e, t, n, r, a, l, o, c, d) {
    cr = !1, Kr = null, Dc.apply(Uc, arguments);
  }
  function Zc(e, t, n, r, a, l, o, c, d) {
    if (Yc.apply(this, arguments), cr) {
      if (cr) {
        var b = Kr;
        cr = !1, Kr = null;
      } else throw Error(s(198));
      qr || (qr = !0, wl = b);
    }
  }
  function hn(e) {
    var t = e, n = e;
    if (e.alternate) for (; t.return; ) t = t.return;
    else {
      e = t;
      do
        t = e, t.flags & 4098 && (n = t.return), e = t.return;
      while (e);
    }
    return t.tag === 3 ? n : null;
  }
  function ki(e) {
    if (e.tag === 13) {
      var t = e.memoizedState;
      if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
    }
    return null;
  }
  function Ci(e) {
    if (hn(e) !== e) throw Error(s(188));
  }
  function Qc(e) {
    var t = e.alternate;
    if (!t) {
      if (t = hn(e), t === null) throw Error(s(188));
      return t !== e ? null : e;
    }
    for (var n = e, r = t; ; ) {
      var a = n.return;
      if (a === null) break;
      var l = a.alternate;
      if (l === null) {
        if (r = a.return, r !== null) {
          n = r;
          continue;
        }
        break;
      }
      if (a.child === l.child) {
        for (l = a.child; l; ) {
          if (l === n) return Ci(a), e;
          if (l === r) return Ci(a), t;
          l = l.sibling;
        }
        throw Error(s(188));
      }
      if (n.return !== r.return) n = a, r = l;
      else {
        for (var o = !1, c = a.child; c; ) {
          if (c === n) {
            o = !0, n = a, r = l;
            break;
          }
          if (c === r) {
            o = !0, r = a, n = l;
            break;
          }
          c = c.sibling;
        }
        if (!o) {
          for (c = l.child; c; ) {
            if (c === n) {
              o = !0, n = l, r = a;
              break;
            }
            if (c === r) {
              o = !0, r = l, n = a;
              break;
            }
            c = c.sibling;
          }
          if (!o) throw Error(s(189));
        }
      }
      if (n.alternate !== r) throw Error(s(190));
    }
    if (n.tag !== 3) throw Error(s(188));
    return n.stateNode.current === n ? e : t;
  }
  function Si(e) {
    return e = Qc(e), e !== null ? Ei(e) : null;
  }
  function Ei(e) {
    if (e.tag === 5 || e.tag === 6) return e;
    for (e = e.child; e !== null; ) {
      var t = Ei(e);
      if (t !== null) return t;
      e = e.sibling;
    }
    return null;
  }
  var Ni = m.unstable_scheduleCallback, _i = m.unstable_cancelCallback, Xc = m.unstable_shouldYield, Kc = m.unstable_requestPaint, Re = m.unstable_now, qc = m.unstable_getCurrentPriorityLevel, xl = m.unstable_ImmediatePriority, Li = m.unstable_UserBlockingPriority, Jr = m.unstable_NormalPriority, Jc = m.unstable_LowPriority, zi = m.unstable_IdlePriority, Gr = null, _t = null;
  function Gc(e) {
    if (_t && typeof _t.onCommitFiberRoot == "function") try {
      _t.onCommitFiberRoot(Gr, e, void 0, (e.current.flags & 128) === 128);
    } catch {
    }
  }
  var vt = Math.clz32 ? Math.clz32 : nd, ed = Math.log, td = Math.LN2;
  function nd(e) {
    return e >>>= 0, e === 0 ? 32 : 31 - (ed(e) / td | 0) | 0;
  }
  var ea = 64, ta = 4194304;
  function dr(e) {
    switch (e & -e) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return e & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return e & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return e;
    }
  }
  function na(e, t) {
    var n = e.pendingLanes;
    if (n === 0) return 0;
    var r = 0, a = e.suspendedLanes, l = e.pingedLanes, o = n & 268435455;
    if (o !== 0) {
      var c = o & ~a;
      c !== 0 ? r = dr(c) : (l &= o, l !== 0 && (r = dr(l)));
    } else o = n & ~a, o !== 0 ? r = dr(o) : l !== 0 && (r = dr(l));
    if (r === 0) return 0;
    if (t !== 0 && t !== r && !(t & a) && (a = r & -r, l = t & -t, a >= l || a === 16 && (l & 4194240) !== 0)) return t;
    if (r & 4 && (r |= n & 16), t = e.entangledLanes, t !== 0) for (e = e.entanglements, t &= r; 0 < t; ) n = 31 - vt(t), a = 1 << n, r |= e[n], t &= ~a;
    return r;
  }
  function rd(e, t) {
    switch (e) {
      case 1:
      case 2:
      case 4:
        return t + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function ad(e, t) {
    for (var n = e.suspendedLanes, r = e.pingedLanes, a = e.expirationTimes, l = e.pendingLanes; 0 < l; ) {
      var o = 31 - vt(l), c = 1 << o, d = a[o];
      d === -1 ? (!(c & n) || c & r) && (a[o] = rd(c, t)) : d <= t && (e.expiredLanes |= c), l &= ~c;
    }
  }
  function kl(e) {
    return e = e.pendingLanes & -1073741825, e !== 0 ? e : e & 1073741824 ? 1073741824 : 0;
  }
  function Mi() {
    var e = ea;
    return ea <<= 1, !(ea & 4194240) && (ea = 64), e;
  }
  function Cl(e) {
    for (var t = [], n = 0; 31 > n; n++) t.push(e);
    return t;
  }
  function fr(e, t, n) {
    e.pendingLanes |= t, t !== 536870912 && (e.suspendedLanes = 0, e.pingedLanes = 0), e = e.eventTimes, t = 31 - vt(t), e[t] = n;
  }
  function ld(e, t) {
    var n = e.pendingLanes & ~t;
    e.pendingLanes = t, e.suspendedLanes = 0, e.pingedLanes = 0, e.expiredLanes &= t, e.mutableReadLanes &= t, e.entangledLanes &= t, t = e.entanglements;
    var r = e.eventTimes;
    for (e = e.expirationTimes; 0 < n; ) {
      var a = 31 - vt(n), l = 1 << a;
      t[a] = 0, r[a] = -1, e[a] = -1, n &= ~l;
    }
  }
  function Sl(e, t) {
    var n = e.entangledLanes |= t;
    for (e = e.entanglements; n; ) {
      var r = 31 - vt(n), a = 1 << r;
      a & t | e[r] & t && (e[r] |= t), n &= ~a;
    }
  }
  var Se = 0;
  function Pi(e) {
    return e &= -e, 1 < e ? 4 < e ? e & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var ji, El, Ii, Ri, Ti, Nl = !1, ra = [], Yt = null, Zt = null, Qt = null, pr = /* @__PURE__ */ new Map(), mr = /* @__PURE__ */ new Map(), Xt = [], od = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function Oi(e, t) {
    switch (e) {
      case "focusin":
      case "focusout":
        Yt = null;
        break;
      case "dragenter":
      case "dragleave":
        Zt = null;
        break;
      case "mouseover":
      case "mouseout":
        Qt = null;
        break;
      case "pointerover":
      case "pointerout":
        pr.delete(t.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        mr.delete(t.pointerId);
    }
  }
  function hr(e, t, n, r, a, l) {
    return e === null || e.nativeEvent !== l ? (e = { blockedOn: t, domEventName: n, eventSystemFlags: r, nativeEvent: l, targetContainers: [a] }, t !== null && (t = zr(t), t !== null && El(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, a !== null && t.indexOf(a) === -1 && t.push(a), e);
  }
  function id(e, t, n, r, a) {
    switch (t) {
      case "focusin":
        return Yt = hr(Yt, e, t, n, r, a), !0;
      case "dragenter":
        return Zt = hr(Zt, e, t, n, r, a), !0;
      case "mouseover":
        return Qt = hr(Qt, e, t, n, r, a), !0;
      case "pointerover":
        var l = a.pointerId;
        return pr.set(l, hr(pr.get(l) || null, e, t, n, r, a)), !0;
      case "gotpointercapture":
        return l = a.pointerId, mr.set(l, hr(mr.get(l) || null, e, t, n, r, a)), !0;
    }
    return !1;
  }
  function Fi(e) {
    var t = gn(e.target);
    if (t !== null) {
      var n = hn(t);
      if (n !== null) {
        if (t = n.tag, t === 13) {
          if (t = ki(n), t !== null) {
            e.blockedOn = t, Ti(e.priority, function() {
              Ii(n);
            });
            return;
          }
        } else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
          e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
          return;
        }
      }
    }
    e.blockedOn = null;
  }
  function aa(e) {
    if (e.blockedOn !== null) return !1;
    for (var t = e.targetContainers; 0 < t.length; ) {
      var n = Ll(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
      if (n === null) {
        n = e.nativeEvent;
        var r = new n.constructor(n.type, n);
        hl = r, n.target.dispatchEvent(r), hl = null;
      } else return t = zr(n), t !== null && El(t), e.blockedOn = n, !1;
      t.shift();
    }
    return !0;
  }
  function Vi(e, t, n) {
    aa(e) && n.delete(t);
  }
  function sd() {
    Nl = !1, Yt !== null && aa(Yt) && (Yt = null), Zt !== null && aa(Zt) && (Zt = null), Qt !== null && aa(Qt) && (Qt = null), pr.forEach(Vi), mr.forEach(Vi);
  }
  function gr(e, t) {
    e.blockedOn === t && (e.blockedOn = null, Nl || (Nl = !0, m.unstable_scheduleCallback(m.unstable_NormalPriority, sd)));
  }
  function vr(e) {
    function t(a) {
      return gr(a, e);
    }
    if (0 < ra.length) {
      gr(ra[0], e);
      for (var n = 1; n < ra.length; n++) {
        var r = ra[n];
        r.blockedOn === e && (r.blockedOn = null);
      }
    }
    for (Yt !== null && gr(Yt, e), Zt !== null && gr(Zt, e), Qt !== null && gr(Qt, e), pr.forEach(t), mr.forEach(t), n = 0; n < Xt.length; n++) r = Xt[n], r.blockedOn === e && (r.blockedOn = null);
    for (; 0 < Xt.length && (n = Xt[0], n.blockedOn === null); ) Fi(n), n.blockedOn === null && Xt.shift();
  }
  var On = j.ReactCurrentBatchConfig, la = !0;
  function ud(e, t, n, r) {
    var a = Se, l = On.transition;
    On.transition = null;
    try {
      Se = 1, _l(e, t, n, r);
    } finally {
      Se = a, On.transition = l;
    }
  }
  function cd(e, t, n, r) {
    var a = Se, l = On.transition;
    On.transition = null;
    try {
      Se = 4, _l(e, t, n, r);
    } finally {
      Se = a, On.transition = l;
    }
  }
  function _l(e, t, n, r) {
    if (la) {
      var a = Ll(e, t, n, r);
      if (a === null) Ul(e, t, r, oa, n), Oi(e, r);
      else if (id(a, e, t, n, r)) r.stopPropagation();
      else if (Oi(e, r), t & 4 && -1 < od.indexOf(e)) {
        for (; a !== null; ) {
          var l = zr(a);
          if (l !== null && ji(l), l = Ll(e, t, n, r), l === null && Ul(e, t, r, oa, n), l === a) break;
          a = l;
        }
        a !== null && r.stopPropagation();
      } else Ul(e, t, r, null, n);
    }
  }
  var oa = null;
  function Ll(e, t, n, r) {
    if (oa = null, e = gl(r), e = gn(e), e !== null) if (t = hn(e), t === null) e = null;
    else if (n = t.tag, n === 13) {
      if (e = ki(t), e !== null) return e;
      e = null;
    } else if (n === 3) {
      if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
      e = null;
    } else t !== e && (e = null);
    return oa = e, null;
  }
  function Hi(e) {
    switch (e) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (qc()) {
          case xl:
            return 1;
          case Li:
            return 4;
          case Jr:
          case Jc:
            return 16;
          case zi:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var Kt = null, zl = null, ia = null;
  function $i() {
    if (ia) return ia;
    var e, t = zl, n = t.length, r, a = "value" in Kt ? Kt.value : Kt.textContent, l = a.length;
    for (e = 0; e < n && t[e] === a[e]; e++) ;
    var o = n - e;
    for (r = 1; r <= o && t[n - r] === a[l - r]; r++) ;
    return ia = a.slice(e, 1 < r ? 1 - r : void 0);
  }
  function sa(e) {
    var t = e.keyCode;
    return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
  }
  function ua() {
    return !0;
  }
  function Ai() {
    return !1;
  }
  function lt(e) {
    function t(n, r, a, l, o) {
      this._reactName = n, this._targetInst = a, this.type = r, this.nativeEvent = l, this.target = o, this.currentTarget = null;
      for (var c in e) e.hasOwnProperty(c) && (n = e[c], this[c] = n ? n(l) : l[c]);
      return this.isDefaultPrevented = (l.defaultPrevented != null ? l.defaultPrevented : l.returnValue === !1) ? ua : Ai, this.isPropagationStopped = Ai, this;
    }
    return F(t.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var n = this.nativeEvent;
      n && (n.preventDefault ? n.preventDefault() : typeof n.returnValue != "unknown" && (n.returnValue = !1), this.isDefaultPrevented = ua);
    }, stopPropagation: function() {
      var n = this.nativeEvent;
      n && (n.stopPropagation ? n.stopPropagation() : typeof n.cancelBubble != "unknown" && (n.cancelBubble = !0), this.isPropagationStopped = ua);
    }, persist: function() {
    }, isPersistent: ua }), t;
  }
  var Fn = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(e) {
    return e.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, Ml = lt(Fn), br = F({}, Fn, { view: 0, detail: 0 }), dd = lt(br), Pl, jl, yr, ca = F({}, br, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: Rl, button: 0, buttons: 0, relatedTarget: function(e) {
    return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
  }, movementX: function(e) {
    return "movementX" in e ? e.movementX : (e !== yr && (yr && e.type === "mousemove" ? (Pl = e.screenX - yr.screenX, jl = e.screenY - yr.screenY) : jl = Pl = 0, yr = e), Pl);
  }, movementY: function(e) {
    return "movementY" in e ? e.movementY : jl;
  } }), Wi = lt(ca), fd = F({}, ca, { dataTransfer: 0 }), pd = lt(fd), md = F({}, br, { relatedTarget: 0 }), Il = lt(md), hd = F({}, Fn, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), gd = lt(hd), vd = F({}, Fn, { clipboardData: function(e) {
    return "clipboardData" in e ? e.clipboardData : window.clipboardData;
  } }), bd = lt(vd), yd = F({}, Fn, { data: 0 }), Bi = lt(yd), wd = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, xd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, kd = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function Cd(e) {
    var t = this.nativeEvent;
    return t.getModifierState ? t.getModifierState(e) : (e = kd[e]) ? !!t[e] : !1;
  }
  function Rl() {
    return Cd;
  }
  var Sd = F({}, br, { key: function(e) {
    if (e.key) {
      var t = wd[e.key] || e.key;
      if (t !== "Unidentified") return t;
    }
    return e.type === "keypress" ? (e = sa(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? xd[e.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: Rl, charCode: function(e) {
    return e.type === "keypress" ? sa(e) : 0;
  }, keyCode: function(e) {
    return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
  }, which: function(e) {
    return e.type === "keypress" ? sa(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
  } }), Ed = lt(Sd), Nd = F({}, ca, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Di = lt(Nd), _d = F({}, br, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: Rl }), Ld = lt(_d), zd = F({}, Fn, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), Md = lt(zd), Pd = F({}, ca, {
    deltaX: function(e) {
      return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
    },
    deltaY: function(e) {
      return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), jd = lt(Pd), Id = [9, 13, 27, 32], Tl = M && "CompositionEvent" in window, wr = null;
  M && "documentMode" in document && (wr = document.documentMode);
  var Rd = M && "TextEvent" in window && !wr, Ui = M && (!Tl || wr && 8 < wr && 11 >= wr), Yi = " ", Zi = !1;
  function Qi(e, t) {
    switch (e) {
      case "keyup":
        return Id.indexOf(t.keyCode) !== -1;
      case "keydown":
        return t.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Xi(e) {
    return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
  }
  var Vn = !1;
  function Td(e, t) {
    switch (e) {
      case "compositionend":
        return Xi(t);
      case "keypress":
        return t.which !== 32 ? null : (Zi = !0, Yi);
      case "textInput":
        return e = t.data, e === Yi && Zi ? null : e;
      default:
        return null;
    }
  }
  function Od(e, t) {
    if (Vn) return e === "compositionend" || !Tl && Qi(e, t) ? (e = $i(), ia = zl = Kt = null, Vn = !1, e) : null;
    switch (e) {
      case "paste":
        return null;
      case "keypress":
        if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
          if (t.char && 1 < t.char.length) return t.char;
          if (t.which) return String.fromCharCode(t.which);
        }
        return null;
      case "compositionend":
        return Ui && t.locale !== "ko" ? null : t.data;
      default:
        return null;
    }
  }
  var Fd = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function Ki(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    return t === "input" ? !!Fd[e.type] : t === "textarea";
  }
  function qi(e, t, n, r) {
    vi(r), t = ha(t, "onChange"), 0 < t.length && (n = new Ml("onChange", "change", null, n, r), e.push({ event: n, listeners: t }));
  }
  var xr = null, kr = null;
  function Vd(e) {
    hs(e, 0);
  }
  function da(e) {
    var t = Bn(e);
    if (jt(t)) return e;
  }
  function Hd(e, t) {
    if (e === "change") return t;
  }
  var Ji = !1;
  if (M) {
    var Ol;
    if (M) {
      var Fl = "oninput" in document;
      if (!Fl) {
        var Gi = document.createElement("div");
        Gi.setAttribute("oninput", "return;"), Fl = typeof Gi.oninput == "function";
      }
      Ol = Fl;
    } else Ol = !1;
    Ji = Ol && (!document.documentMode || 9 < document.documentMode);
  }
  function es() {
    xr && (xr.detachEvent("onpropertychange", ts), kr = xr = null);
  }
  function ts(e) {
    if (e.propertyName === "value" && da(kr)) {
      var t = [];
      qi(t, kr, e, gl(e)), xi(Vd, t);
    }
  }
  function $d(e, t, n) {
    e === "focusin" ? (es(), xr = t, kr = n, xr.attachEvent("onpropertychange", ts)) : e === "focusout" && es();
  }
  function Ad(e) {
    if (e === "selectionchange" || e === "keyup" || e === "keydown") return da(kr);
  }
  function Wd(e, t) {
    if (e === "click") return da(t);
  }
  function Bd(e, t) {
    if (e === "input" || e === "change") return da(t);
  }
  function Dd(e, t) {
    return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
  }
  var bt = typeof Object.is == "function" ? Object.is : Dd;
  function Cr(e, t) {
    if (bt(e, t)) return !0;
    if (typeof e != "object" || e === null || typeof t != "object" || t === null) return !1;
    var n = Object.keys(e), r = Object.keys(t);
    if (n.length !== r.length) return !1;
    for (r = 0; r < n.length; r++) {
      var a = n[r];
      if (!E.call(t, a) || !bt(e[a], t[a])) return !1;
    }
    return !0;
  }
  function ns(e) {
    for (; e && e.firstChild; ) e = e.firstChild;
    return e;
  }
  function rs(e, t) {
    var n = ns(e);
    e = 0;
    for (var r; n; ) {
      if (n.nodeType === 3) {
        if (r = e + n.textContent.length, e <= t && r >= t) return { node: n, offset: t - e };
        e = r;
      }
      e: {
        for (; n; ) {
          if (n.nextSibling) {
            n = n.nextSibling;
            break e;
          }
          n = n.parentNode;
        }
        n = void 0;
      }
      n = ns(n);
    }
  }
  function as(e, t) {
    return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? as(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
  }
  function ls() {
    for (var e = window, t = Dt(); t instanceof e.HTMLIFrameElement; ) {
      try {
        var n = typeof t.contentWindow.location.href == "string";
      } catch {
        n = !1;
      }
      if (n) e = t.contentWindow;
      else break;
      t = Dt(e.document);
    }
    return t;
  }
  function Vl(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
  }
  function Ud(e) {
    var t = ls(), n = e.focusedElem, r = e.selectionRange;
    if (t !== n && n && n.ownerDocument && as(n.ownerDocument.documentElement, n)) {
      if (r !== null && Vl(n)) {
        if (t = r.start, e = r.end, e === void 0 && (e = t), "selectionStart" in n) n.selectionStart = t, n.selectionEnd = Math.min(e, n.value.length);
        else if (e = (t = n.ownerDocument || document) && t.defaultView || window, e.getSelection) {
          e = e.getSelection();
          var a = n.textContent.length, l = Math.min(r.start, a);
          r = r.end === void 0 ? l : Math.min(r.end, a), !e.extend && l > r && (a = r, r = l, l = a), a = rs(n, l);
          var o = rs(
            n,
            r
          );
          a && o && (e.rangeCount !== 1 || e.anchorNode !== a.node || e.anchorOffset !== a.offset || e.focusNode !== o.node || e.focusOffset !== o.offset) && (t = t.createRange(), t.setStart(a.node, a.offset), e.removeAllRanges(), l > r ? (e.addRange(t), e.extend(o.node, o.offset)) : (t.setEnd(o.node, o.offset), e.addRange(t)));
        }
      }
      for (t = [], e = n; e = e.parentNode; ) e.nodeType === 1 && t.push({ element: e, left: e.scrollLeft, top: e.scrollTop });
      for (typeof n.focus == "function" && n.focus(), n = 0; n < t.length; n++) e = t[n], e.element.scrollLeft = e.left, e.element.scrollTop = e.top;
    }
  }
  var Yd = M && "documentMode" in document && 11 >= document.documentMode, Hn = null, Hl = null, Sr = null, $l = !1;
  function os(e, t, n) {
    var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
    $l || Hn == null || Hn !== Dt(r) || (r = Hn, "selectionStart" in r && Vl(r) ? r = { start: r.selectionStart, end: r.selectionEnd } : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = { anchorNode: r.anchorNode, anchorOffset: r.anchorOffset, focusNode: r.focusNode, focusOffset: r.focusOffset }), Sr && Cr(Sr, r) || (Sr = r, r = ha(Hl, "onSelect"), 0 < r.length && (t = new Ml("onSelect", "select", null, t, n), e.push({ event: t, listeners: r }), t.target = Hn)));
  }
  function fa(e, t) {
    var n = {};
    return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
  }
  var $n = { animationend: fa("Animation", "AnimationEnd"), animationiteration: fa("Animation", "AnimationIteration"), animationstart: fa("Animation", "AnimationStart"), transitionend: fa("Transition", "TransitionEnd") }, Al = {}, is = {};
  M && (is = document.createElement("div").style, "AnimationEvent" in window || (delete $n.animationend.animation, delete $n.animationiteration.animation, delete $n.animationstart.animation), "TransitionEvent" in window || delete $n.transitionend.transition);
  function pa(e) {
    if (Al[e]) return Al[e];
    if (!$n[e]) return e;
    var t = $n[e], n;
    for (n in t) if (t.hasOwnProperty(n) && n in is) return Al[e] = t[n];
    return e;
  }
  var ss = pa("animationend"), us = pa("animationiteration"), cs = pa("animationstart"), ds = pa("transitionend"), fs = /* @__PURE__ */ new Map(), ps = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function qt(e, t) {
    fs.set(e, t), _(t, [e]);
  }
  for (var Wl = 0; Wl < ps.length; Wl++) {
    var Bl = ps[Wl], Zd = Bl.toLowerCase(), Qd = Bl[0].toUpperCase() + Bl.slice(1);
    qt(Zd, "on" + Qd);
  }
  qt(ss, "onAnimationEnd"), qt(us, "onAnimationIteration"), qt(cs, "onAnimationStart"), qt("dblclick", "onDoubleClick"), qt("focusin", "onFocus"), qt("focusout", "onBlur"), qt(ds, "onTransitionEnd"), O("onMouseEnter", ["mouseout", "mouseover"]), O("onMouseLeave", ["mouseout", "mouseover"]), O("onPointerEnter", ["pointerout", "pointerover"]), O("onPointerLeave", ["pointerout", "pointerover"]), _("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), _("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), _("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), _("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), _("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), _("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var Er = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Xd = new Set("cancel close invalid load scroll toggle".split(" ").concat(Er));
  function ms(e, t, n) {
    var r = e.type || "unknown-event";
    e.currentTarget = n, Zc(r, t, void 0, e), e.currentTarget = null;
  }
  function hs(e, t) {
    t = (t & 4) !== 0;
    for (var n = 0; n < e.length; n++) {
      var r = e[n], a = r.event;
      r = r.listeners;
      e: {
        var l = void 0;
        if (t) for (var o = r.length - 1; 0 <= o; o--) {
          var c = r[o], d = c.instance, b = c.currentTarget;
          if (c = c.listener, d !== l && a.isPropagationStopped()) break e;
          ms(a, c, b), l = d;
        }
        else for (o = 0; o < r.length; o++) {
          if (c = r[o], d = c.instance, b = c.currentTarget, c = c.listener, d !== l && a.isPropagationStopped()) break e;
          ms(a, c, b), l = d;
        }
      }
    }
    if (qr) throw e = wl, qr = !1, wl = null, e;
  }
  function Ne(e, t) {
    var n = t[ql];
    n === void 0 && (n = t[ql] = /* @__PURE__ */ new Set());
    var r = e + "__bubble";
    n.has(r) || (gs(t, e, 2, !1), n.add(r));
  }
  function Dl(e, t, n) {
    var r = 0;
    t && (r |= 4), gs(n, e, r, t);
  }
  var ma = "_reactListening" + Math.random().toString(36).slice(2);
  function Nr(e) {
    if (!e[ma]) {
      e[ma] = !0, y.forEach(function(n) {
        n !== "selectionchange" && (Xd.has(n) || Dl(n, !1, e), Dl(n, !0, e));
      });
      var t = e.nodeType === 9 ? e : e.ownerDocument;
      t === null || t[ma] || (t[ma] = !0, Dl("selectionchange", !1, t));
    }
  }
  function gs(e, t, n, r) {
    switch (Hi(t)) {
      case 1:
        var a = ud;
        break;
      case 4:
        a = cd;
        break;
      default:
        a = _l;
    }
    n = a.bind(null, t, n, e), a = void 0, !yl || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (a = !0), r ? a !== void 0 ? e.addEventListener(t, n, { capture: !0, passive: a }) : e.addEventListener(t, n, !0) : a !== void 0 ? e.addEventListener(t, n, { passive: a }) : e.addEventListener(t, n, !1);
  }
  function Ul(e, t, n, r, a) {
    var l = r;
    if (!(t & 1) && !(t & 2) && r !== null) e: for (; ; ) {
      if (r === null) return;
      var o = r.tag;
      if (o === 3 || o === 4) {
        var c = r.stateNode.containerInfo;
        if (c === a || c.nodeType === 8 && c.parentNode === a) break;
        if (o === 4) for (o = r.return; o !== null; ) {
          var d = o.tag;
          if ((d === 3 || d === 4) && (d = o.stateNode.containerInfo, d === a || d.nodeType === 8 && d.parentNode === a)) return;
          o = o.return;
        }
        for (; c !== null; ) {
          if (o = gn(c), o === null) return;
          if (d = o.tag, d === 5 || d === 6) {
            r = l = o;
            continue e;
          }
          c = c.parentNode;
        }
      }
      r = r.return;
    }
    xi(function() {
      var b = l, I = gl(n), T = [];
      e: {
        var P = fs.get(e);
        if (P !== void 0) {
          var J = Ml, te = e;
          switch (e) {
            case "keypress":
              if (sa(n) === 0) break e;
            case "keydown":
            case "keyup":
              J = Ed;
              break;
            case "focusin":
              te = "focus", J = Il;
              break;
            case "focusout":
              te = "blur", J = Il;
              break;
            case "beforeblur":
            case "afterblur":
              J = Il;
              break;
            case "click":
              if (n.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              J = Wi;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              J = pd;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              J = Ld;
              break;
            case ss:
            case us:
            case cs:
              J = gd;
              break;
            case ds:
              J = Md;
              break;
            case "scroll":
              J = dd;
              break;
            case "wheel":
              J = jd;
              break;
            case "copy":
            case "cut":
            case "paste":
              J = bd;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              J = Di;
          }
          var re = (t & 4) !== 0, Te = !re && e === "scroll", g = re ? P !== null ? P + "Capture" : null : P;
          re = [];
          for (var f = b, v; f !== null; ) {
            v = f;
            var A = v.stateNode;
            if (v.tag === 5 && A !== null && (v = A, g !== null && (A = sr(f, g), A != null && re.push(_r(f, A, v)))), Te) break;
            f = f.return;
          }
          0 < re.length && (P = new J(P, te, null, n, I), T.push({ event: P, listeners: re }));
        }
      }
      if (!(t & 7)) {
        e: {
          if (P = e === "mouseover" || e === "pointerover", J = e === "mouseout" || e === "pointerout", P && n !== hl && (te = n.relatedTarget || n.fromElement) && (gn(te) || te[Tt])) break e;
          if ((J || P) && (P = I.window === I ? I : (P = I.ownerDocument) ? P.defaultView || P.parentWindow : window, J ? (te = n.relatedTarget || n.toElement, J = b, te = te ? gn(te) : null, te !== null && (Te = hn(te), te !== Te || te.tag !== 5 && te.tag !== 6) && (te = null)) : (J = null, te = b), J !== te)) {
            if (re = Wi, A = "onMouseLeave", g = "onMouseEnter", f = "mouse", (e === "pointerout" || e === "pointerover") && (re = Di, A = "onPointerLeave", g = "onPointerEnter", f = "pointer"), Te = J == null ? P : Bn(J), v = te == null ? P : Bn(te), P = new re(A, f + "leave", J, n, I), P.target = Te, P.relatedTarget = v, A = null, gn(I) === b && (re = new re(g, f + "enter", te, n, I), re.target = v, re.relatedTarget = Te, A = re), Te = A, J && te) t: {
              for (re = J, g = te, f = 0, v = re; v; v = An(v)) f++;
              for (v = 0, A = g; A; A = An(A)) v++;
              for (; 0 < f - v; ) re = An(re), f--;
              for (; 0 < v - f; ) g = An(g), v--;
              for (; f--; ) {
                if (re === g || g !== null && re === g.alternate) break t;
                re = An(re), g = An(g);
              }
              re = null;
            }
            else re = null;
            J !== null && vs(T, P, J, re, !1), te !== null && Te !== null && vs(T, Te, te, re, !0);
          }
        }
        e: {
          if (P = b ? Bn(b) : window, J = P.nodeName && P.nodeName.toLowerCase(), J === "select" || J === "input" && P.type === "file") var le = Hd;
          else if (Ki(P)) if (Ji) le = Bd;
          else {
            le = Ad;
            var ue = $d;
          }
          else (J = P.nodeName) && J.toLowerCase() === "input" && (P.type === "checkbox" || P.type === "radio") && (le = Wd);
          if (le && (le = le(e, b))) {
            qi(T, le, n, I);
            break e;
          }
          ue && ue(e, P, b), e === "focusout" && (ue = P._wrapperState) && ue.controlled && P.type === "number" && mn(P, "number", P.value);
        }
        switch (ue = b ? Bn(b) : window, e) {
          case "focusin":
            (Ki(ue) || ue.contentEditable === "true") && (Hn = ue, Hl = b, Sr = null);
            break;
          case "focusout":
            Sr = Hl = Hn = null;
            break;
          case "mousedown":
            $l = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            $l = !1, os(T, n, I);
            break;
          case "selectionchange":
            if (Yd) break;
          case "keydown":
          case "keyup":
            os(T, n, I);
        }
        var ce;
        if (Tl) e: {
          switch (e) {
            case "compositionstart":
              var pe = "onCompositionStart";
              break e;
            case "compositionend":
              pe = "onCompositionEnd";
              break e;
            case "compositionupdate":
              pe = "onCompositionUpdate";
              break e;
          }
          pe = void 0;
        }
        else Vn ? Qi(e, n) && (pe = "onCompositionEnd") : e === "keydown" && n.keyCode === 229 && (pe = "onCompositionStart");
        pe && (Ui && n.locale !== "ko" && (Vn || pe !== "onCompositionStart" ? pe === "onCompositionEnd" && Vn && (ce = $i()) : (Kt = I, zl = "value" in Kt ? Kt.value : Kt.textContent, Vn = !0)), ue = ha(b, pe), 0 < ue.length && (pe = new Bi(pe, e, null, n, I), T.push({ event: pe, listeners: ue }), ce ? pe.data = ce : (ce = Xi(n), ce !== null && (pe.data = ce)))), (ce = Rd ? Td(e, n) : Od(e, n)) && (b = ha(b, "onBeforeInput"), 0 < b.length && (I = new Bi("onBeforeInput", "beforeinput", null, n, I), T.push({ event: I, listeners: b }), I.data = ce));
      }
      hs(T, t);
    });
  }
  function _r(e, t, n) {
    return { instance: e, listener: t, currentTarget: n };
  }
  function ha(e, t) {
    for (var n = t + "Capture", r = []; e !== null; ) {
      var a = e, l = a.stateNode;
      a.tag === 5 && l !== null && (a = l, l = sr(e, n), l != null && r.unshift(_r(e, l, a)), l = sr(e, t), l != null && r.push(_r(e, l, a))), e = e.return;
    }
    return r;
  }
  function An(e) {
    if (e === null) return null;
    do
      e = e.return;
    while (e && e.tag !== 5);
    return e || null;
  }
  function vs(e, t, n, r, a) {
    for (var l = t._reactName, o = []; n !== null && n !== r; ) {
      var c = n, d = c.alternate, b = c.stateNode;
      if (d !== null && d === r) break;
      c.tag === 5 && b !== null && (c = b, a ? (d = sr(n, l), d != null && o.unshift(_r(n, d, c))) : a || (d = sr(n, l), d != null && o.push(_r(n, d, c)))), n = n.return;
    }
    o.length !== 0 && e.push({ event: t, listeners: o });
  }
  var Kd = /\r\n?/g, qd = /\u0000|\uFFFD/g;
  function bs(e) {
    return (typeof e == "string" ? e : "" + e).replace(Kd, `
`).replace(qd, "");
  }
  function ga(e, t, n) {
    if (t = bs(t), bs(e) !== t && n) throw Error(s(425));
  }
  function va() {
  }
  var Yl = null, Zl = null;
  function Ql(e, t) {
    return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
  }
  var Xl = typeof setTimeout == "function" ? setTimeout : void 0, Jd = typeof clearTimeout == "function" ? clearTimeout : void 0, ys = typeof Promise == "function" ? Promise : void 0, Gd = typeof queueMicrotask == "function" ? queueMicrotask : typeof ys < "u" ? function(e) {
    return ys.resolve(null).then(e).catch(ef);
  } : Xl;
  function ef(e) {
    setTimeout(function() {
      throw e;
    });
  }
  function Kl(e, t) {
    var n = t, r = 0;
    do {
      var a = n.nextSibling;
      if (e.removeChild(n), a && a.nodeType === 8) if (n = a.data, n === "/$") {
        if (r === 0) {
          e.removeChild(a), vr(t);
          return;
        }
        r--;
      } else n !== "$" && n !== "$?" && n !== "$!" || r++;
      n = a;
    } while (n);
    vr(t);
  }
  function Jt(e) {
    for (; e != null; e = e.nextSibling) {
      var t = e.nodeType;
      if (t === 1 || t === 3) break;
      if (t === 8) {
        if (t = e.data, t === "$" || t === "$!" || t === "$?") break;
        if (t === "/$") return null;
      }
    }
    return e;
  }
  function ws(e) {
    e = e.previousSibling;
    for (var t = 0; e; ) {
      if (e.nodeType === 8) {
        var n = e.data;
        if (n === "$" || n === "$!" || n === "$?") {
          if (t === 0) return e;
          t--;
        } else n === "/$" && t++;
      }
      e = e.previousSibling;
    }
    return null;
  }
  var Wn = Math.random().toString(36).slice(2), Lt = "__reactFiber$" + Wn, Lr = "__reactProps$" + Wn, Tt = "__reactContainer$" + Wn, ql = "__reactEvents$" + Wn, tf = "__reactListeners$" + Wn, nf = "__reactHandles$" + Wn;
  function gn(e) {
    var t = e[Lt];
    if (t) return t;
    for (var n = e.parentNode; n; ) {
      if (t = n[Tt] || n[Lt]) {
        if (n = t.alternate, t.child !== null || n !== null && n.child !== null) for (e = ws(e); e !== null; ) {
          if (n = e[Lt]) return n;
          e = ws(e);
        }
        return t;
      }
      e = n, n = e.parentNode;
    }
    return null;
  }
  function zr(e) {
    return e = e[Lt] || e[Tt], !e || e.tag !== 5 && e.tag !== 6 && e.tag !== 13 && e.tag !== 3 ? null : e;
  }
  function Bn(e) {
    if (e.tag === 5 || e.tag === 6) return e.stateNode;
    throw Error(s(33));
  }
  function ba(e) {
    return e[Lr] || null;
  }
  var Jl = [], Dn = -1;
  function Gt(e) {
    return { current: e };
  }
  function _e(e) {
    0 > Dn || (e.current = Jl[Dn], Jl[Dn] = null, Dn--);
  }
  function Ee(e, t) {
    Dn++, Jl[Dn] = e.current, e.current = t;
  }
  var en = {}, Ze = Gt(en), Ge = Gt(!1), vn = en;
  function Un(e, t) {
    var n = e.type.contextTypes;
    if (!n) return en;
    var r = e.stateNode;
    if (r && r.__reactInternalMemoizedUnmaskedChildContext === t) return r.__reactInternalMemoizedMaskedChildContext;
    var a = {}, l;
    for (l in n) a[l] = t[l];
    return r && (e = e.stateNode, e.__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = a), a;
  }
  function et(e) {
    return e = e.childContextTypes, e != null;
  }
  function ya() {
    _e(Ge), _e(Ze);
  }
  function xs(e, t, n) {
    if (Ze.current !== en) throw Error(s(168));
    Ee(Ze, t), Ee(Ge, n);
  }
  function ks(e, t, n) {
    var r = e.stateNode;
    if (t = t.childContextTypes, typeof r.getChildContext != "function") return n;
    r = r.getChildContext();
    for (var a in r) if (!(a in t)) throw Error(s(108, we(e) || "Unknown", a));
    return F({}, n, r);
  }
  function wa(e) {
    return e = (e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext || en, vn = Ze.current, Ee(Ze, e), Ee(Ge, Ge.current), !0;
  }
  function Cs(e, t, n) {
    var r = e.stateNode;
    if (!r) throw Error(s(169));
    n ? (e = ks(e, t, vn), r.__reactInternalMemoizedMergedChildContext = e, _e(Ge), _e(Ze), Ee(Ze, e)) : _e(Ge), Ee(Ge, n);
  }
  var Ot = null, xa = !1, Gl = !1;
  function Ss(e) {
    Ot === null ? Ot = [e] : Ot.push(e);
  }
  function rf(e) {
    xa = !0, Ss(e);
  }
  function tn() {
    if (!Gl && Ot !== null) {
      Gl = !0;
      var e = 0, t = Se;
      try {
        var n = Ot;
        for (Se = 1; e < n.length; e++) {
          var r = n[e];
          do
            r = r(!0);
          while (r !== null);
        }
        Ot = null, xa = !1;
      } catch (a) {
        throw Ot !== null && (Ot = Ot.slice(e + 1)), Ni(xl, tn), a;
      } finally {
        Se = t, Gl = !1;
      }
    }
    return null;
  }
  var Yn = [], Zn = 0, ka = null, Ca = 0, ct = [], dt = 0, bn = null, Ft = 1, Vt = "";
  function yn(e, t) {
    Yn[Zn++] = Ca, Yn[Zn++] = ka, ka = e, Ca = t;
  }
  function Es(e, t, n) {
    ct[dt++] = Ft, ct[dt++] = Vt, ct[dt++] = bn, bn = e;
    var r = Ft;
    e = Vt;
    var a = 32 - vt(r) - 1;
    r &= ~(1 << a), n += 1;
    var l = 32 - vt(t) + a;
    if (30 < l) {
      var o = a - a % 5;
      l = (r & (1 << o) - 1).toString(32), r >>= o, a -= o, Ft = 1 << 32 - vt(t) + a | n << a | r, Vt = l + e;
    } else Ft = 1 << l | n << a | r, Vt = e;
  }
  function eo(e) {
    e.return !== null && (yn(e, 1), Es(e, 1, 0));
  }
  function to(e) {
    for (; e === ka; ) ka = Yn[--Zn], Yn[Zn] = null, Ca = Yn[--Zn], Yn[Zn] = null;
    for (; e === bn; ) bn = ct[--dt], ct[dt] = null, Vt = ct[--dt], ct[dt] = null, Ft = ct[--dt], ct[dt] = null;
  }
  var ot = null, it = null, Le = !1, yt = null;
  function Ns(e, t) {
    var n = ht(5, null, null, 0);
    n.elementType = "DELETED", n.stateNode = t, n.return = e, t = e.deletions, t === null ? (e.deletions = [n], e.flags |= 16) : t.push(n);
  }
  function _s(e, t) {
    switch (e.tag) {
      case 5:
        var n = e.type;
        return t = t.nodeType !== 1 || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t, t !== null ? (e.stateNode = t, ot = e, it = Jt(t.firstChild), !0) : !1;
      case 6:
        return t = e.pendingProps === "" || t.nodeType !== 3 ? null : t, t !== null ? (e.stateNode = t, ot = e, it = null, !0) : !1;
      case 13:
        return t = t.nodeType !== 8 ? null : t, t !== null ? (n = bn !== null ? { id: Ft, overflow: Vt } : null, e.memoizedState = { dehydrated: t, treeContext: n, retryLane: 1073741824 }, n = ht(18, null, null, 0), n.stateNode = t, n.return = e, e.child = n, ot = e, it = null, !0) : !1;
      default:
        return !1;
    }
  }
  function no(e) {
    return (e.mode & 1) !== 0 && (e.flags & 128) === 0;
  }
  function ro(e) {
    if (Le) {
      var t = it;
      if (t) {
        var n = t;
        if (!_s(e, t)) {
          if (no(e)) throw Error(s(418));
          t = Jt(n.nextSibling);
          var r = ot;
          t && _s(e, t) ? Ns(r, n) : (e.flags = e.flags & -4097 | 2, Le = !1, ot = e);
        }
      } else {
        if (no(e)) throw Error(s(418));
        e.flags = e.flags & -4097 | 2, Le = !1, ot = e;
      }
    }
  }
  function Ls(e) {
    for (e = e.return; e !== null && e.tag !== 5 && e.tag !== 3 && e.tag !== 13; ) e = e.return;
    ot = e;
  }
  function Sa(e) {
    if (e !== ot) return !1;
    if (!Le) return Ls(e), Le = !0, !1;
    var t;
    if ((t = e.tag !== 3) && !(t = e.tag !== 5) && (t = e.type, t = t !== "head" && t !== "body" && !Ql(e.type, e.memoizedProps)), t && (t = it)) {
      if (no(e)) throw zs(), Error(s(418));
      for (; t; ) Ns(e, t), t = Jt(t.nextSibling);
    }
    if (Ls(e), e.tag === 13) {
      if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(s(317));
      e: {
        for (e = e.nextSibling, t = 0; e; ) {
          if (e.nodeType === 8) {
            var n = e.data;
            if (n === "/$") {
              if (t === 0) {
                it = Jt(e.nextSibling);
                break e;
              }
              t--;
            } else n !== "$" && n !== "$!" && n !== "$?" || t++;
          }
          e = e.nextSibling;
        }
        it = null;
      }
    } else it = ot ? Jt(e.stateNode.nextSibling) : null;
    return !0;
  }
  function zs() {
    for (var e = it; e; ) e = Jt(e.nextSibling);
  }
  function Qn() {
    it = ot = null, Le = !1;
  }
  function ao(e) {
    yt === null ? yt = [e] : yt.push(e);
  }
  var af = j.ReactCurrentBatchConfig;
  function Mr(e, t, n) {
    if (e = n.ref, e !== null && typeof e != "function" && typeof e != "object") {
      if (n._owner) {
        if (n = n._owner, n) {
          if (n.tag !== 1) throw Error(s(309));
          var r = n.stateNode;
        }
        if (!r) throw Error(s(147, e));
        var a = r, l = "" + e;
        return t !== null && t.ref !== null && typeof t.ref == "function" && t.ref._stringRef === l ? t.ref : (t = function(o) {
          var c = a.refs;
          o === null ? delete c[l] : c[l] = o;
        }, t._stringRef = l, t);
      }
      if (typeof e != "string") throw Error(s(284));
      if (!n._owner) throw Error(s(290, e));
    }
    return e;
  }
  function Ea(e, t) {
    throw e = Object.prototype.toString.call(t), Error(s(31, e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e));
  }
  function Ms(e) {
    var t = e._init;
    return t(e._payload);
  }
  function Ps(e) {
    function t(g, f) {
      if (e) {
        var v = g.deletions;
        v === null ? (g.deletions = [f], g.flags |= 16) : v.push(f);
      }
    }
    function n(g, f) {
      if (!e) return null;
      for (; f !== null; ) t(g, f), f = f.sibling;
      return null;
    }
    function r(g, f) {
      for (g = /* @__PURE__ */ new Map(); f !== null; ) f.key !== null ? g.set(f.key, f) : g.set(f.index, f), f = f.sibling;
      return g;
    }
    function a(g, f) {
      return g = cn(g, f), g.index = 0, g.sibling = null, g;
    }
    function l(g, f, v) {
      return g.index = v, e ? (v = g.alternate, v !== null ? (v = v.index, v < f ? (g.flags |= 2, f) : v) : (g.flags |= 2, f)) : (g.flags |= 1048576, f);
    }
    function o(g) {
      return e && g.alternate === null && (g.flags |= 2), g;
    }
    function c(g, f, v, A) {
      return f === null || f.tag !== 6 ? (f = Xo(v, g.mode, A), f.return = g, f) : (f = a(f, v), f.return = g, f);
    }
    function d(g, f, v, A) {
      var le = v.type;
      return le === q ? I(g, f, v.props.children, A, v.key) : f !== null && (f.elementType === le || typeof le == "object" && le !== null && le.$$typeof === S && Ms(le) === f.type) ? (A = a(f, v.props), A.ref = Mr(g, f, v), A.return = g, A) : (A = Xa(v.type, v.key, v.props, null, g.mode, A), A.ref = Mr(g, f, v), A.return = g, A);
    }
    function b(g, f, v, A) {
      return f === null || f.tag !== 4 || f.stateNode.containerInfo !== v.containerInfo || f.stateNode.implementation !== v.implementation ? (f = Ko(v, g.mode, A), f.return = g, f) : (f = a(f, v.children || []), f.return = g, f);
    }
    function I(g, f, v, A, le) {
      return f === null || f.tag !== 7 ? (f = _n(v, g.mode, A, le), f.return = g, f) : (f = a(f, v), f.return = g, f);
    }
    function T(g, f, v) {
      if (typeof f == "string" && f !== "" || typeof f == "number") return f = Xo("" + f, g.mode, v), f.return = g, f;
      if (typeof f == "object" && f !== null) {
        switch (f.$$typeof) {
          case Q:
            return v = Xa(f.type, f.key, f.props, null, g.mode, v), v.ref = Mr(g, null, f), v.return = g, v;
          case Y:
            return f = Ko(f, g.mode, v), f.return = g, f;
          case S:
            var A = f._init;
            return T(g, A(f._payload), v);
        }
        if (Ut(f) || $(f)) return f = _n(f, g.mode, v, null), f.return = g, f;
        Ea(g, f);
      }
      return null;
    }
    function P(g, f, v, A) {
      var le = f !== null ? f.key : null;
      if (typeof v == "string" && v !== "" || typeof v == "number") return le !== null ? null : c(g, f, "" + v, A);
      if (typeof v == "object" && v !== null) {
        switch (v.$$typeof) {
          case Q:
            return v.key === le ? d(g, f, v, A) : null;
          case Y:
            return v.key === le ? b(g, f, v, A) : null;
          case S:
            return le = v._init, P(
              g,
              f,
              le(v._payload),
              A
            );
        }
        if (Ut(v) || $(v)) return le !== null ? null : I(g, f, v, A, null);
        Ea(g, v);
      }
      return null;
    }
    function J(g, f, v, A, le) {
      if (typeof A == "string" && A !== "" || typeof A == "number") return g = g.get(v) || null, c(f, g, "" + A, le);
      if (typeof A == "object" && A !== null) {
        switch (A.$$typeof) {
          case Q:
            return g = g.get(A.key === null ? v : A.key) || null, d(f, g, A, le);
          case Y:
            return g = g.get(A.key === null ? v : A.key) || null, b(f, g, A, le);
          case S:
            var ue = A._init;
            return J(g, f, v, ue(A._payload), le);
        }
        if (Ut(A) || $(A)) return g = g.get(v) || null, I(f, g, A, le, null);
        Ea(f, A);
      }
      return null;
    }
    function te(g, f, v, A) {
      for (var le = null, ue = null, ce = f, pe = f = 0, We = null; ce !== null && pe < v.length; pe++) {
        ce.index > pe ? (We = ce, ce = null) : We = ce.sibling;
        var ke = P(g, ce, v[pe], A);
        if (ke === null) {
          ce === null && (ce = We);
          break;
        }
        e && ce && ke.alternate === null && t(g, ce), f = l(ke, f, pe), ue === null ? le = ke : ue.sibling = ke, ue = ke, ce = We;
      }
      if (pe === v.length) return n(g, ce), Le && yn(g, pe), le;
      if (ce === null) {
        for (; pe < v.length; pe++) ce = T(g, v[pe], A), ce !== null && (f = l(ce, f, pe), ue === null ? le = ce : ue.sibling = ce, ue = ce);
        return Le && yn(g, pe), le;
      }
      for (ce = r(g, ce); pe < v.length; pe++) We = J(ce, g, pe, v[pe], A), We !== null && (e && We.alternate !== null && ce.delete(We.key === null ? pe : We.key), f = l(We, f, pe), ue === null ? le = We : ue.sibling = We, ue = We);
      return e && ce.forEach(function(dn) {
        return t(g, dn);
      }), Le && yn(g, pe), le;
    }
    function re(g, f, v, A) {
      var le = $(v);
      if (typeof le != "function") throw Error(s(150));
      if (v = le.call(v), v == null) throw Error(s(151));
      for (var ue = le = null, ce = f, pe = f = 0, We = null, ke = v.next(); ce !== null && !ke.done; pe++, ke = v.next()) {
        ce.index > pe ? (We = ce, ce = null) : We = ce.sibling;
        var dn = P(g, ce, ke.value, A);
        if (dn === null) {
          ce === null && (ce = We);
          break;
        }
        e && ce && dn.alternate === null && t(g, ce), f = l(dn, f, pe), ue === null ? le = dn : ue.sibling = dn, ue = dn, ce = We;
      }
      if (ke.done) return n(
        g,
        ce
      ), Le && yn(g, pe), le;
      if (ce === null) {
        for (; !ke.done; pe++, ke = v.next()) ke = T(g, ke.value, A), ke !== null && (f = l(ke, f, pe), ue === null ? le = ke : ue.sibling = ke, ue = ke);
        return Le && yn(g, pe), le;
      }
      for (ce = r(g, ce); !ke.done; pe++, ke = v.next()) ke = J(ce, g, pe, ke.value, A), ke !== null && (e && ke.alternate !== null && ce.delete(ke.key === null ? pe : ke.key), f = l(ke, f, pe), ue === null ? le = ke : ue.sibling = ke, ue = ke);
      return e && ce.forEach(function(Vf) {
        return t(g, Vf);
      }), Le && yn(g, pe), le;
    }
    function Te(g, f, v, A) {
      if (typeof v == "object" && v !== null && v.type === q && v.key === null && (v = v.props.children), typeof v == "object" && v !== null) {
        switch (v.$$typeof) {
          case Q:
            e: {
              for (var le = v.key, ue = f; ue !== null; ) {
                if (ue.key === le) {
                  if (le = v.type, le === q) {
                    if (ue.tag === 7) {
                      n(g, ue.sibling), f = a(ue, v.props.children), f.return = g, g = f;
                      break e;
                    }
                  } else if (ue.elementType === le || typeof le == "object" && le !== null && le.$$typeof === S && Ms(le) === ue.type) {
                    n(g, ue.sibling), f = a(ue, v.props), f.ref = Mr(g, ue, v), f.return = g, g = f;
                    break e;
                  }
                  n(g, ue);
                  break;
                } else t(g, ue);
                ue = ue.sibling;
              }
              v.type === q ? (f = _n(v.props.children, g.mode, A, v.key), f.return = g, g = f) : (A = Xa(v.type, v.key, v.props, null, g.mode, A), A.ref = Mr(g, f, v), A.return = g, g = A);
            }
            return o(g);
          case Y:
            e: {
              for (ue = v.key; f !== null; ) {
                if (f.key === ue) if (f.tag === 4 && f.stateNode.containerInfo === v.containerInfo && f.stateNode.implementation === v.implementation) {
                  n(g, f.sibling), f = a(f, v.children || []), f.return = g, g = f;
                  break e;
                } else {
                  n(g, f);
                  break;
                }
                else t(g, f);
                f = f.sibling;
              }
              f = Ko(v, g.mode, A), f.return = g, g = f;
            }
            return o(g);
          case S:
            return ue = v._init, Te(g, f, ue(v._payload), A);
        }
        if (Ut(v)) return te(g, f, v, A);
        if ($(v)) return re(g, f, v, A);
        Ea(g, v);
      }
      return typeof v == "string" && v !== "" || typeof v == "number" ? (v = "" + v, f !== null && f.tag === 6 ? (n(g, f.sibling), f = a(f, v), f.return = g, g = f) : (n(g, f), f = Xo(v, g.mode, A), f.return = g, g = f), o(g)) : n(g, f);
    }
    return Te;
  }
  var Xn = Ps(!0), js = Ps(!1), Na = Gt(null), _a = null, Kn = null, lo = null;
  function oo() {
    lo = Kn = _a = null;
  }
  function io(e) {
    var t = Na.current;
    _e(Na), e._currentValue = t;
  }
  function so(e, t, n) {
    for (; e !== null; ) {
      var r = e.alternate;
      if ((e.childLanes & t) !== t ? (e.childLanes |= t, r !== null && (r.childLanes |= t)) : r !== null && (r.childLanes & t) !== t && (r.childLanes |= t), e === n) break;
      e = e.return;
    }
  }
  function qn(e, t) {
    _a = e, lo = Kn = null, e = e.dependencies, e !== null && e.firstContext !== null && (e.lanes & t && (tt = !0), e.firstContext = null);
  }
  function ft(e) {
    var t = e._currentValue;
    if (lo !== e) if (e = { context: e, memoizedValue: t, next: null }, Kn === null) {
      if (_a === null) throw Error(s(308));
      Kn = e, _a.dependencies = { lanes: 0, firstContext: e };
    } else Kn = Kn.next = e;
    return t;
  }
  var wn = null;
  function uo(e) {
    wn === null ? wn = [e] : wn.push(e);
  }
  function Is(e, t, n, r) {
    var a = t.interleaved;
    return a === null ? (n.next = n, uo(t)) : (n.next = a.next, a.next = n), t.interleaved = n, Ht(e, r);
  }
  function Ht(e, t) {
    e.lanes |= t;
    var n = e.alternate;
    for (n !== null && (n.lanes |= t), n = e, e = e.return; e !== null; ) e.childLanes |= t, n = e.alternate, n !== null && (n.childLanes |= t), n = e, e = e.return;
    return n.tag === 3 ? n.stateNode : null;
  }
  var nn = !1;
  function co(e) {
    e.updateQueue = { baseState: e.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function Rs(e, t) {
    e = e.updateQueue, t.updateQueue === e && (t.updateQueue = { baseState: e.baseState, firstBaseUpdate: e.firstBaseUpdate, lastBaseUpdate: e.lastBaseUpdate, shared: e.shared, effects: e.effects });
  }
  function $t(e, t) {
    return { eventTime: e, lane: t, tag: 0, payload: null, callback: null, next: null };
  }
  function rn(e, t, n) {
    var r = e.updateQueue;
    if (r === null) return null;
    if (r = r.shared, xe & 2) {
      var a = r.pending;
      return a === null ? t.next = t : (t.next = a.next, a.next = t), r.pending = t, Ht(e, n);
    }
    return a = r.interleaved, a === null ? (t.next = t, uo(r)) : (t.next = a.next, a.next = t), r.interleaved = t, Ht(e, n);
  }
  function La(e, t, n) {
    if (t = t.updateQueue, t !== null && (t = t.shared, (n & 4194240) !== 0)) {
      var r = t.lanes;
      r &= e.pendingLanes, n |= r, t.lanes = n, Sl(e, n);
    }
  }
  function Ts(e, t) {
    var n = e.updateQueue, r = e.alternate;
    if (r !== null && (r = r.updateQueue, n === r)) {
      var a = null, l = null;
      if (n = n.firstBaseUpdate, n !== null) {
        do {
          var o = { eventTime: n.eventTime, lane: n.lane, tag: n.tag, payload: n.payload, callback: n.callback, next: null };
          l === null ? a = l = o : l = l.next = o, n = n.next;
        } while (n !== null);
        l === null ? a = l = t : l = l.next = t;
      } else a = l = t;
      n = { baseState: r.baseState, firstBaseUpdate: a, lastBaseUpdate: l, shared: r.shared, effects: r.effects }, e.updateQueue = n;
      return;
    }
    e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
  }
  function za(e, t, n, r) {
    var a = e.updateQueue;
    nn = !1;
    var l = a.firstBaseUpdate, o = a.lastBaseUpdate, c = a.shared.pending;
    if (c !== null) {
      a.shared.pending = null;
      var d = c, b = d.next;
      d.next = null, o === null ? l = b : o.next = b, o = d;
      var I = e.alternate;
      I !== null && (I = I.updateQueue, c = I.lastBaseUpdate, c !== o && (c === null ? I.firstBaseUpdate = b : c.next = b, I.lastBaseUpdate = d));
    }
    if (l !== null) {
      var T = a.baseState;
      o = 0, I = b = d = null, c = l;
      do {
        var P = c.lane, J = c.eventTime;
        if ((r & P) === P) {
          I !== null && (I = I.next = {
            eventTime: J,
            lane: 0,
            tag: c.tag,
            payload: c.payload,
            callback: c.callback,
            next: null
          });
          e: {
            var te = e, re = c;
            switch (P = t, J = n, re.tag) {
              case 1:
                if (te = re.payload, typeof te == "function") {
                  T = te.call(J, T, P);
                  break e;
                }
                T = te;
                break e;
              case 3:
                te.flags = te.flags & -65537 | 128;
              case 0:
                if (te = re.payload, P = typeof te == "function" ? te.call(J, T, P) : te, P == null) break e;
                T = F({}, T, P);
                break e;
              case 2:
                nn = !0;
            }
          }
          c.callback !== null && c.lane !== 0 && (e.flags |= 64, P = a.effects, P === null ? a.effects = [c] : P.push(c));
        } else J = { eventTime: J, lane: P, tag: c.tag, payload: c.payload, callback: c.callback, next: null }, I === null ? (b = I = J, d = T) : I = I.next = J, o |= P;
        if (c = c.next, c === null) {
          if (c = a.shared.pending, c === null) break;
          P = c, c = P.next, P.next = null, a.lastBaseUpdate = P, a.shared.pending = null;
        }
      } while (!0);
      if (I === null && (d = T), a.baseState = d, a.firstBaseUpdate = b, a.lastBaseUpdate = I, t = a.shared.interleaved, t !== null) {
        a = t;
        do
          o |= a.lane, a = a.next;
        while (a !== t);
      } else l === null && (a.shared.lanes = 0);
      Cn |= o, e.lanes = o, e.memoizedState = T;
    }
  }
  function Os(e, t, n) {
    if (e = t.effects, t.effects = null, e !== null) for (t = 0; t < e.length; t++) {
      var r = e[t], a = r.callback;
      if (a !== null) {
        if (r.callback = null, r = n, typeof a != "function") throw Error(s(191, a));
        a.call(r);
      }
    }
  }
  var Pr = {}, zt = Gt(Pr), jr = Gt(Pr), Ir = Gt(Pr);
  function xn(e) {
    if (e === Pr) throw Error(s(174));
    return e;
  }
  function fo(e, t) {
    switch (Ee(Ir, t), Ee(jr, e), Ee(zt, Pr), e = t.nodeType, e) {
      case 9:
      case 11:
        t = (t = t.documentElement) ? t.namespaceURI : ir(null, "");
        break;
      default:
        e = e === 8 ? t.parentNode : t, t = e.namespaceURI || null, e = e.tagName, t = ir(t, e);
    }
    _e(zt), Ee(zt, t);
  }
  function Jn() {
    _e(zt), _e(jr), _e(Ir);
  }
  function Fs(e) {
    xn(Ir.current);
    var t = xn(zt.current), n = ir(t, e.type);
    t !== n && (Ee(jr, e), Ee(zt, n));
  }
  function po(e) {
    jr.current === e && (_e(zt), _e(jr));
  }
  var Pe = Gt(0);
  function Ma(e) {
    for (var t = e; t !== null; ) {
      if (t.tag === 13) {
        var n = t.memoizedState;
        if (n !== null && (n = n.dehydrated, n === null || n.data === "$?" || n.data === "$!")) return t;
      } else if (t.tag === 19 && t.memoizedProps.revealOrder !== void 0) {
        if (t.flags & 128) return t;
      } else if (t.child !== null) {
        t.child.return = t, t = t.child;
        continue;
      }
      if (t === e) break;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === e) return null;
        t = t.return;
      }
      t.sibling.return = t.return, t = t.sibling;
    }
    return null;
  }
  var mo = [];
  function ho() {
    for (var e = 0; e < mo.length; e++) mo[e]._workInProgressVersionPrimary = null;
    mo.length = 0;
  }
  var Pa = j.ReactCurrentDispatcher, go = j.ReactCurrentBatchConfig, kn = 0, je = null, Ve = null, $e = null, ja = !1, Rr = !1, Tr = 0, lf = 0;
  function Qe() {
    throw Error(s(321));
  }
  function vo(e, t) {
    if (t === null) return !1;
    for (var n = 0; n < t.length && n < e.length; n++) if (!bt(e[n], t[n])) return !1;
    return !0;
  }
  function bo(e, t, n, r, a, l) {
    if (kn = l, je = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, Pa.current = e === null || e.memoizedState === null ? cf : df, e = n(r, a), Rr) {
      l = 0;
      do {
        if (Rr = !1, Tr = 0, 25 <= l) throw Error(s(301));
        l += 1, $e = Ve = null, t.updateQueue = null, Pa.current = ff, e = n(r, a);
      } while (Rr);
    }
    if (Pa.current = Ta, t = Ve !== null && Ve.next !== null, kn = 0, $e = Ve = je = null, ja = !1, t) throw Error(s(300));
    return e;
  }
  function yo() {
    var e = Tr !== 0;
    return Tr = 0, e;
  }
  function Mt() {
    var e = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return $e === null ? je.memoizedState = $e = e : $e = $e.next = e, $e;
  }
  function pt() {
    if (Ve === null) {
      var e = je.alternate;
      e = e !== null ? e.memoizedState : null;
    } else e = Ve.next;
    var t = $e === null ? je.memoizedState : $e.next;
    if (t !== null) $e = t, Ve = e;
    else {
      if (e === null) throw Error(s(310));
      Ve = e, e = { memoizedState: Ve.memoizedState, baseState: Ve.baseState, baseQueue: Ve.baseQueue, queue: Ve.queue, next: null }, $e === null ? je.memoizedState = $e = e : $e = $e.next = e;
    }
    return $e;
  }
  function Or(e, t) {
    return typeof t == "function" ? t(e) : t;
  }
  function wo(e) {
    var t = pt(), n = t.queue;
    if (n === null) throw Error(s(311));
    n.lastRenderedReducer = e;
    var r = Ve, a = r.baseQueue, l = n.pending;
    if (l !== null) {
      if (a !== null) {
        var o = a.next;
        a.next = l.next, l.next = o;
      }
      r.baseQueue = a = l, n.pending = null;
    }
    if (a !== null) {
      l = a.next, r = r.baseState;
      var c = o = null, d = null, b = l;
      do {
        var I = b.lane;
        if ((kn & I) === I) d !== null && (d = d.next = { lane: 0, action: b.action, hasEagerState: b.hasEagerState, eagerState: b.eagerState, next: null }), r = b.hasEagerState ? b.eagerState : e(r, b.action);
        else {
          var T = {
            lane: I,
            action: b.action,
            hasEagerState: b.hasEagerState,
            eagerState: b.eagerState,
            next: null
          };
          d === null ? (c = d = T, o = r) : d = d.next = T, je.lanes |= I, Cn |= I;
        }
        b = b.next;
      } while (b !== null && b !== l);
      d === null ? o = r : d.next = c, bt(r, t.memoizedState) || (tt = !0), t.memoizedState = r, t.baseState = o, t.baseQueue = d, n.lastRenderedState = r;
    }
    if (e = n.interleaved, e !== null) {
      a = e;
      do
        l = a.lane, je.lanes |= l, Cn |= l, a = a.next;
      while (a !== e);
    } else a === null && (n.lanes = 0);
    return [t.memoizedState, n.dispatch];
  }
  function xo(e) {
    var t = pt(), n = t.queue;
    if (n === null) throw Error(s(311));
    n.lastRenderedReducer = e;
    var r = n.dispatch, a = n.pending, l = t.memoizedState;
    if (a !== null) {
      n.pending = null;
      var o = a = a.next;
      do
        l = e(l, o.action), o = o.next;
      while (o !== a);
      bt(l, t.memoizedState) || (tt = !0), t.memoizedState = l, t.baseQueue === null && (t.baseState = l), n.lastRenderedState = l;
    }
    return [l, r];
  }
  function Vs() {
  }
  function Hs(e, t) {
    var n = je, r = pt(), a = t(), l = !bt(r.memoizedState, a);
    if (l && (r.memoizedState = a, tt = !0), r = r.queue, ko(Ws.bind(null, n, r, e), [e]), r.getSnapshot !== t || l || $e !== null && $e.memoizedState.tag & 1) {
      if (n.flags |= 2048, Fr(9, As.bind(null, n, r, a, t), void 0, null), Ae === null) throw Error(s(349));
      kn & 30 || $s(n, t, a);
    }
    return a;
  }
  function $s(e, t, n) {
    e.flags |= 16384, e = { getSnapshot: t, value: n }, t = je.updateQueue, t === null ? (t = { lastEffect: null, stores: null }, je.updateQueue = t, t.stores = [e]) : (n = t.stores, n === null ? t.stores = [e] : n.push(e));
  }
  function As(e, t, n, r) {
    t.value = n, t.getSnapshot = r, Bs(t) && Ds(e);
  }
  function Ws(e, t, n) {
    return n(function() {
      Bs(t) && Ds(e);
    });
  }
  function Bs(e) {
    var t = e.getSnapshot;
    e = e.value;
    try {
      var n = t();
      return !bt(e, n);
    } catch {
      return !0;
    }
  }
  function Ds(e) {
    var t = Ht(e, 1);
    t !== null && Ct(t, e, 1, -1);
  }
  function Us(e) {
    var t = Mt();
    return typeof e == "function" && (e = e()), t.memoizedState = t.baseState = e, e = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Or, lastRenderedState: e }, t.queue = e, e = e.dispatch = uf.bind(null, je, e), [t.memoizedState, e];
  }
  function Fr(e, t, n, r) {
    return e = { tag: e, create: t, destroy: n, deps: r, next: null }, t = je.updateQueue, t === null ? (t = { lastEffect: null, stores: null }, je.updateQueue = t, t.lastEffect = e.next = e) : (n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e)), e;
  }
  function Ys() {
    return pt().memoizedState;
  }
  function Ia(e, t, n, r) {
    var a = Mt();
    je.flags |= e, a.memoizedState = Fr(1 | t, n, void 0, r === void 0 ? null : r);
  }
  function Ra(e, t, n, r) {
    var a = pt();
    r = r === void 0 ? null : r;
    var l = void 0;
    if (Ve !== null) {
      var o = Ve.memoizedState;
      if (l = o.destroy, r !== null && vo(r, o.deps)) {
        a.memoizedState = Fr(t, n, l, r);
        return;
      }
    }
    je.flags |= e, a.memoizedState = Fr(1 | t, n, l, r);
  }
  function Zs(e, t) {
    return Ia(8390656, 8, e, t);
  }
  function ko(e, t) {
    return Ra(2048, 8, e, t);
  }
  function Qs(e, t) {
    return Ra(4, 2, e, t);
  }
  function Xs(e, t) {
    return Ra(4, 4, e, t);
  }
  function Ks(e, t) {
    if (typeof t == "function") return e = e(), t(e), function() {
      t(null);
    };
    if (t != null) return e = e(), t.current = e, function() {
      t.current = null;
    };
  }
  function qs(e, t, n) {
    return n = n != null ? n.concat([e]) : null, Ra(4, 4, Ks.bind(null, t, e), n);
  }
  function Co() {
  }
  function Js(e, t) {
    var n = pt();
    t = t === void 0 ? null : t;
    var r = n.memoizedState;
    return r !== null && t !== null && vo(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
  }
  function Gs(e, t) {
    var n = pt();
    t = t === void 0 ? null : t;
    var r = n.memoizedState;
    return r !== null && t !== null && vo(t, r[1]) ? r[0] : (e = e(), n.memoizedState = [e, t], e);
  }
  function eu(e, t, n) {
    return kn & 21 ? (bt(n, t) || (n = Mi(), je.lanes |= n, Cn |= n, e.baseState = !0), t) : (e.baseState && (e.baseState = !1, tt = !0), e.memoizedState = n);
  }
  function of(e, t) {
    var n = Se;
    Se = n !== 0 && 4 > n ? n : 4, e(!0);
    var r = go.transition;
    go.transition = {};
    try {
      e(!1), t();
    } finally {
      Se = n, go.transition = r;
    }
  }
  function tu() {
    return pt().memoizedState;
  }
  function sf(e, t, n) {
    var r = sn(e);
    if (n = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null }, nu(e)) ru(t, n);
    else if (n = Is(e, t, n, r), n !== null) {
      var a = Je();
      Ct(n, e, r, a), au(n, t, r);
    }
  }
  function uf(e, t, n) {
    var r = sn(e), a = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null };
    if (nu(e)) ru(t, a);
    else {
      var l = e.alternate;
      if (e.lanes === 0 && (l === null || l.lanes === 0) && (l = t.lastRenderedReducer, l !== null)) try {
        var o = t.lastRenderedState, c = l(o, n);
        if (a.hasEagerState = !0, a.eagerState = c, bt(c, o)) {
          var d = t.interleaved;
          d === null ? (a.next = a, uo(t)) : (a.next = d.next, d.next = a), t.interleaved = a;
          return;
        }
      } catch {
      } finally {
      }
      n = Is(e, t, a, r), n !== null && (a = Je(), Ct(n, e, r, a), au(n, t, r));
    }
  }
  function nu(e) {
    var t = e.alternate;
    return e === je || t !== null && t === je;
  }
  function ru(e, t) {
    Rr = ja = !0;
    var n = e.pending;
    n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
  }
  function au(e, t, n) {
    if (n & 4194240) {
      var r = t.lanes;
      r &= e.pendingLanes, n |= r, t.lanes = n, Sl(e, n);
    }
  }
  var Ta = { readContext: ft, useCallback: Qe, useContext: Qe, useEffect: Qe, useImperativeHandle: Qe, useInsertionEffect: Qe, useLayoutEffect: Qe, useMemo: Qe, useReducer: Qe, useRef: Qe, useState: Qe, useDebugValue: Qe, useDeferredValue: Qe, useTransition: Qe, useMutableSource: Qe, useSyncExternalStore: Qe, useId: Qe, unstable_isNewReconciler: !1 }, cf = { readContext: ft, useCallback: function(e, t) {
    return Mt().memoizedState = [e, t === void 0 ? null : t], e;
  }, useContext: ft, useEffect: Zs, useImperativeHandle: function(e, t, n) {
    return n = n != null ? n.concat([e]) : null, Ia(
      4194308,
      4,
      Ks.bind(null, t, e),
      n
    );
  }, useLayoutEffect: function(e, t) {
    return Ia(4194308, 4, e, t);
  }, useInsertionEffect: function(e, t) {
    return Ia(4, 2, e, t);
  }, useMemo: function(e, t) {
    var n = Mt();
    return t = t === void 0 ? null : t, e = e(), n.memoizedState = [e, t], e;
  }, useReducer: function(e, t, n) {
    var r = Mt();
    return t = n !== void 0 ? n(t) : t, r.memoizedState = r.baseState = t, e = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: e, lastRenderedState: t }, r.queue = e, e = e.dispatch = sf.bind(null, je, e), [r.memoizedState, e];
  }, useRef: function(e) {
    var t = Mt();
    return e = { current: e }, t.memoizedState = e;
  }, useState: Us, useDebugValue: Co, useDeferredValue: function(e) {
    return Mt().memoizedState = e;
  }, useTransition: function() {
    var e = Us(!1), t = e[0];
    return e = of.bind(null, e[1]), Mt().memoizedState = e, [t, e];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(e, t, n) {
    var r = je, a = Mt();
    if (Le) {
      if (n === void 0) throw Error(s(407));
      n = n();
    } else {
      if (n = t(), Ae === null) throw Error(s(349));
      kn & 30 || $s(r, t, n);
    }
    a.memoizedState = n;
    var l = { value: n, getSnapshot: t };
    return a.queue = l, Zs(Ws.bind(
      null,
      r,
      l,
      e
    ), [e]), r.flags |= 2048, Fr(9, As.bind(null, r, l, n, t), void 0, null), n;
  }, useId: function() {
    var e = Mt(), t = Ae.identifierPrefix;
    if (Le) {
      var n = Vt, r = Ft;
      n = (r & ~(1 << 32 - vt(r) - 1)).toString(32) + n, t = ":" + t + "R" + n, n = Tr++, 0 < n && (t += "H" + n.toString(32)), t += ":";
    } else n = lf++, t = ":" + t + "r" + n.toString(32) + ":";
    return e.memoizedState = t;
  }, unstable_isNewReconciler: !1 }, df = {
    readContext: ft,
    useCallback: Js,
    useContext: ft,
    useEffect: ko,
    useImperativeHandle: qs,
    useInsertionEffect: Qs,
    useLayoutEffect: Xs,
    useMemo: Gs,
    useReducer: wo,
    useRef: Ys,
    useState: function() {
      return wo(Or);
    },
    useDebugValue: Co,
    useDeferredValue: function(e) {
      var t = pt();
      return eu(t, Ve.memoizedState, e);
    },
    useTransition: function() {
      var e = wo(Or)[0], t = pt().memoizedState;
      return [e, t];
    },
    useMutableSource: Vs,
    useSyncExternalStore: Hs,
    useId: tu,
    unstable_isNewReconciler: !1
  }, ff = { readContext: ft, useCallback: Js, useContext: ft, useEffect: ko, useImperativeHandle: qs, useInsertionEffect: Qs, useLayoutEffect: Xs, useMemo: Gs, useReducer: xo, useRef: Ys, useState: function() {
    return xo(Or);
  }, useDebugValue: Co, useDeferredValue: function(e) {
    var t = pt();
    return Ve === null ? t.memoizedState = e : eu(t, Ve.memoizedState, e);
  }, useTransition: function() {
    var e = xo(Or)[0], t = pt().memoizedState;
    return [e, t];
  }, useMutableSource: Vs, useSyncExternalStore: Hs, useId: tu, unstable_isNewReconciler: !1 };
  function wt(e, t) {
    if (e && e.defaultProps) {
      t = F({}, t), e = e.defaultProps;
      for (var n in e) t[n] === void 0 && (t[n] = e[n]);
      return t;
    }
    return t;
  }
  function So(e, t, n, r) {
    t = e.memoizedState, n = n(r, t), n = n == null ? t : F({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n);
  }
  var Oa = { isMounted: function(e) {
    return (e = e._reactInternals) ? hn(e) === e : !1;
  }, enqueueSetState: function(e, t, n) {
    e = e._reactInternals;
    var r = Je(), a = sn(e), l = $t(r, a);
    l.payload = t, n != null && (l.callback = n), t = rn(e, l, a), t !== null && (Ct(t, e, a, r), La(t, e, a));
  }, enqueueReplaceState: function(e, t, n) {
    e = e._reactInternals;
    var r = Je(), a = sn(e), l = $t(r, a);
    l.tag = 1, l.payload = t, n != null && (l.callback = n), t = rn(e, l, a), t !== null && (Ct(t, e, a, r), La(t, e, a));
  }, enqueueForceUpdate: function(e, t) {
    e = e._reactInternals;
    var n = Je(), r = sn(e), a = $t(n, r);
    a.tag = 2, t != null && (a.callback = t), t = rn(e, a, r), t !== null && (Ct(t, e, r, n), La(t, e, r));
  } };
  function lu(e, t, n, r, a, l, o) {
    return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(r, l, o) : t.prototype && t.prototype.isPureReactComponent ? !Cr(n, r) || !Cr(a, l) : !0;
  }
  function ou(e, t, n) {
    var r = !1, a = en, l = t.contextType;
    return typeof l == "object" && l !== null ? l = ft(l) : (a = et(t) ? vn : Ze.current, r = t.contextTypes, l = (r = r != null) ? Un(e, a) : en), t = new t(n, l), e.memoizedState = t.state !== null && t.state !== void 0 ? t.state : null, t.updater = Oa, e.stateNode = t, t._reactInternals = e, r && (e = e.stateNode, e.__reactInternalMemoizedUnmaskedChildContext = a, e.__reactInternalMemoizedMaskedChildContext = l), t;
  }
  function iu(e, t, n, r) {
    e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && Oa.enqueueReplaceState(t, t.state, null);
  }
  function Eo(e, t, n, r) {
    var a = e.stateNode;
    a.props = n, a.state = e.memoizedState, a.refs = {}, co(e);
    var l = t.contextType;
    typeof l == "object" && l !== null ? a.context = ft(l) : (l = et(t) ? vn : Ze.current, a.context = Un(e, l)), a.state = e.memoizedState, l = t.getDerivedStateFromProps, typeof l == "function" && (So(e, t, l, n), a.state = e.memoizedState), typeof t.getDerivedStateFromProps == "function" || typeof a.getSnapshotBeforeUpdate == "function" || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (t = a.state, typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount(), t !== a.state && Oa.enqueueReplaceState(a, a.state, null), za(e, n, a, r), a.state = e.memoizedState), typeof a.componentDidMount == "function" && (e.flags |= 4194308);
  }
  function Gn(e, t) {
    try {
      var n = "", r = t;
      do
        n += me(r), r = r.return;
      while (r);
      var a = n;
    } catch (l) {
      a = `
Error generating stack: ` + l.message + `
` + l.stack;
    }
    return { value: e, source: t, stack: a, digest: null };
  }
  function No(e, t, n) {
    return { value: e, source: null, stack: n ?? null, digest: t ?? null };
  }
  function _o(e, t) {
    try {
      console.error(t.value);
    } catch (n) {
      setTimeout(function() {
        throw n;
      });
    }
  }
  var pf = typeof WeakMap == "function" ? WeakMap : Map;
  function su(e, t, n) {
    n = $t(-1, n), n.tag = 3, n.payload = { element: null };
    var r = t.value;
    return n.callback = function() {
      Ba || (Ba = !0, Ao = r), _o(e, t);
    }, n;
  }
  function uu(e, t, n) {
    n = $t(-1, n), n.tag = 3;
    var r = e.type.getDerivedStateFromError;
    if (typeof r == "function") {
      var a = t.value;
      n.payload = function() {
        return r(a);
      }, n.callback = function() {
        _o(e, t);
      };
    }
    var l = e.stateNode;
    return l !== null && typeof l.componentDidCatch == "function" && (n.callback = function() {
      _o(e, t), typeof r != "function" && (ln === null ? ln = /* @__PURE__ */ new Set([this]) : ln.add(this));
      var o = t.stack;
      this.componentDidCatch(t.value, { componentStack: o !== null ? o : "" });
    }), n;
  }
  function cu(e, t, n) {
    var r = e.pingCache;
    if (r === null) {
      r = e.pingCache = new pf();
      var a = /* @__PURE__ */ new Set();
      r.set(t, a);
    } else a = r.get(t), a === void 0 && (a = /* @__PURE__ */ new Set(), r.set(t, a));
    a.has(n) || (a.add(n), e = _f.bind(null, e, t, n), t.then(e, e));
  }
  function du(e) {
    do {
      var t;
      if ((t = e.tag === 13) && (t = e.memoizedState, t = t !== null ? t.dehydrated !== null : !0), t) return e;
      e = e.return;
    } while (e !== null);
    return null;
  }
  function fu(e, t, n, r, a) {
    return e.mode & 1 ? (e.flags |= 65536, e.lanes = a, e) : (e === t ? e.flags |= 65536 : (e.flags |= 128, n.flags |= 131072, n.flags &= -52805, n.tag === 1 && (n.alternate === null ? n.tag = 17 : (t = $t(-1, 1), t.tag = 2, rn(n, t, 1))), n.lanes |= 1), e);
  }
  var mf = j.ReactCurrentOwner, tt = !1;
  function qe(e, t, n, r) {
    t.child = e === null ? js(t, null, n, r) : Xn(t, e.child, n, r);
  }
  function pu(e, t, n, r, a) {
    n = n.render;
    var l = t.ref;
    return qn(t, a), r = bo(e, t, n, r, l, a), n = yo(), e !== null && !tt ? (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~a, At(e, t, a)) : (Le && n && eo(t), t.flags |= 1, qe(e, t, r, a), t.child);
  }
  function mu(e, t, n, r, a) {
    if (e === null) {
      var l = n.type;
      return typeof l == "function" && !Qo(l) && l.defaultProps === void 0 && n.compare === null && n.defaultProps === void 0 ? (t.tag = 15, t.type = l, hu(e, t, l, r, a)) : (e = Xa(n.type, null, r, t, t.mode, a), e.ref = t.ref, e.return = t, t.child = e);
    }
    if (l = e.child, !(e.lanes & a)) {
      var o = l.memoizedProps;
      if (n = n.compare, n = n !== null ? n : Cr, n(o, r) && e.ref === t.ref) return At(e, t, a);
    }
    return t.flags |= 1, e = cn(l, r), e.ref = t.ref, e.return = t, t.child = e;
  }
  function hu(e, t, n, r, a) {
    if (e !== null) {
      var l = e.memoizedProps;
      if (Cr(l, r) && e.ref === t.ref) if (tt = !1, t.pendingProps = r = l, (e.lanes & a) !== 0) e.flags & 131072 && (tt = !0);
      else return t.lanes = e.lanes, At(e, t, a);
    }
    return Lo(e, t, n, r, a);
  }
  function gu(e, t, n) {
    var r = t.pendingProps, a = r.children, l = e !== null ? e.memoizedState : null;
    if (r.mode === "hidden") if (!(t.mode & 1)) t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, Ee(tr, st), st |= n;
    else {
      if (!(n & 1073741824)) return e = l !== null ? l.baseLanes | n : n, t.lanes = t.childLanes = 1073741824, t.memoizedState = { baseLanes: e, cachePool: null, transitions: null }, t.updateQueue = null, Ee(tr, st), st |= e, null;
      t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, r = l !== null ? l.baseLanes : n, Ee(tr, st), st |= r;
    }
    else l !== null ? (r = l.baseLanes | n, t.memoizedState = null) : r = n, Ee(tr, st), st |= r;
    return qe(e, t, a, n), t.child;
  }
  function vu(e, t) {
    var n = t.ref;
    (e === null && n !== null || e !== null && e.ref !== n) && (t.flags |= 512, t.flags |= 2097152);
  }
  function Lo(e, t, n, r, a) {
    var l = et(n) ? vn : Ze.current;
    return l = Un(t, l), qn(t, a), n = bo(e, t, n, r, l, a), r = yo(), e !== null && !tt ? (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~a, At(e, t, a)) : (Le && r && eo(t), t.flags |= 1, qe(e, t, n, a), t.child);
  }
  function bu(e, t, n, r, a) {
    if (et(n)) {
      var l = !0;
      wa(t);
    } else l = !1;
    if (qn(t, a), t.stateNode === null) Va(e, t), ou(t, n, r), Eo(t, n, r, a), r = !0;
    else if (e === null) {
      var o = t.stateNode, c = t.memoizedProps;
      o.props = c;
      var d = o.context, b = n.contextType;
      typeof b == "object" && b !== null ? b = ft(b) : (b = et(n) ? vn : Ze.current, b = Un(t, b));
      var I = n.getDerivedStateFromProps, T = typeof I == "function" || typeof o.getSnapshotBeforeUpdate == "function";
      T || typeof o.UNSAFE_componentWillReceiveProps != "function" && typeof o.componentWillReceiveProps != "function" || (c !== r || d !== b) && iu(t, o, r, b), nn = !1;
      var P = t.memoizedState;
      o.state = P, za(t, r, o, a), d = t.memoizedState, c !== r || P !== d || Ge.current || nn ? (typeof I == "function" && (So(t, n, I, r), d = t.memoizedState), (c = nn || lu(t, n, c, r, P, d, b)) ? (T || typeof o.UNSAFE_componentWillMount != "function" && typeof o.componentWillMount != "function" || (typeof o.componentWillMount == "function" && o.componentWillMount(), typeof o.UNSAFE_componentWillMount == "function" && o.UNSAFE_componentWillMount()), typeof o.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof o.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = d), o.props = r, o.state = d, o.context = b, r = c) : (typeof o.componentDidMount == "function" && (t.flags |= 4194308), r = !1);
    } else {
      o = t.stateNode, Rs(e, t), c = t.memoizedProps, b = t.type === t.elementType ? c : wt(t.type, c), o.props = b, T = t.pendingProps, P = o.context, d = n.contextType, typeof d == "object" && d !== null ? d = ft(d) : (d = et(n) ? vn : Ze.current, d = Un(t, d));
      var J = n.getDerivedStateFromProps;
      (I = typeof J == "function" || typeof o.getSnapshotBeforeUpdate == "function") || typeof o.UNSAFE_componentWillReceiveProps != "function" && typeof o.componentWillReceiveProps != "function" || (c !== T || P !== d) && iu(t, o, r, d), nn = !1, P = t.memoizedState, o.state = P, za(t, r, o, a);
      var te = t.memoizedState;
      c !== T || P !== te || Ge.current || nn ? (typeof J == "function" && (So(t, n, J, r), te = t.memoizedState), (b = nn || lu(t, n, b, r, P, te, d) || !1) ? (I || typeof o.UNSAFE_componentWillUpdate != "function" && typeof o.componentWillUpdate != "function" || (typeof o.componentWillUpdate == "function" && o.componentWillUpdate(r, te, d), typeof o.UNSAFE_componentWillUpdate == "function" && o.UNSAFE_componentWillUpdate(r, te, d)), typeof o.componentDidUpdate == "function" && (t.flags |= 4), typeof o.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof o.componentDidUpdate != "function" || c === e.memoizedProps && P === e.memoizedState || (t.flags |= 4), typeof o.getSnapshotBeforeUpdate != "function" || c === e.memoizedProps && P === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = te), o.props = r, o.state = te, o.context = d, r = b) : (typeof o.componentDidUpdate != "function" || c === e.memoizedProps && P === e.memoizedState || (t.flags |= 4), typeof o.getSnapshotBeforeUpdate != "function" || c === e.memoizedProps && P === e.memoizedState || (t.flags |= 1024), r = !1);
    }
    return zo(e, t, n, r, l, a);
  }
  function zo(e, t, n, r, a, l) {
    vu(e, t);
    var o = (t.flags & 128) !== 0;
    if (!r && !o) return a && Cs(t, n, !1), At(e, t, l);
    r = t.stateNode, mf.current = t;
    var c = o && typeof n.getDerivedStateFromError != "function" ? null : r.render();
    return t.flags |= 1, e !== null && o ? (t.child = Xn(t, e.child, null, l), t.child = Xn(t, null, c, l)) : qe(e, t, c, l), t.memoizedState = r.state, a && Cs(t, n, !0), t.child;
  }
  function yu(e) {
    var t = e.stateNode;
    t.pendingContext ? xs(e, t.pendingContext, t.pendingContext !== t.context) : t.context && xs(e, t.context, !1), fo(e, t.containerInfo);
  }
  function wu(e, t, n, r, a) {
    return Qn(), ao(a), t.flags |= 256, qe(e, t, n, r), t.child;
  }
  var Mo = { dehydrated: null, treeContext: null, retryLane: 0 };
  function Po(e) {
    return { baseLanes: e, cachePool: null, transitions: null };
  }
  function xu(e, t, n) {
    var r = t.pendingProps, a = Pe.current, l = !1, o = (t.flags & 128) !== 0, c;
    if ((c = o) || (c = e !== null && e.memoizedState === null ? !1 : (a & 2) !== 0), c ? (l = !0, t.flags &= -129) : (e === null || e.memoizedState !== null) && (a |= 1), Ee(Pe, a & 1), e === null)
      return ro(t), e = t.memoizedState, e !== null && (e = e.dehydrated, e !== null) ? (t.mode & 1 ? e.data === "$!" ? t.lanes = 8 : t.lanes = 1073741824 : t.lanes = 1, null) : (o = r.children, e = r.fallback, l ? (r = t.mode, l = t.child, o = { mode: "hidden", children: o }, !(r & 1) && l !== null ? (l.childLanes = 0, l.pendingProps = o) : l = Ka(o, r, 0, null), e = _n(e, r, n, null), l.return = t, e.return = t, l.sibling = e, t.child = l, t.child.memoizedState = Po(n), t.memoizedState = Mo, e) : jo(t, o));
    if (a = e.memoizedState, a !== null && (c = a.dehydrated, c !== null)) return hf(e, t, o, r, c, a, n);
    if (l) {
      l = r.fallback, o = t.mode, a = e.child, c = a.sibling;
      var d = { mode: "hidden", children: r.children };
      return !(o & 1) && t.child !== a ? (r = t.child, r.childLanes = 0, r.pendingProps = d, t.deletions = null) : (r = cn(a, d), r.subtreeFlags = a.subtreeFlags & 14680064), c !== null ? l = cn(c, l) : (l = _n(l, o, n, null), l.flags |= 2), l.return = t, r.return = t, r.sibling = l, t.child = r, r = l, l = t.child, o = e.child.memoizedState, o = o === null ? Po(n) : { baseLanes: o.baseLanes | n, cachePool: null, transitions: o.transitions }, l.memoizedState = o, l.childLanes = e.childLanes & ~n, t.memoizedState = Mo, r;
    }
    return l = e.child, e = l.sibling, r = cn(l, { mode: "visible", children: r.children }), !(t.mode & 1) && (r.lanes = n), r.return = t, r.sibling = null, e !== null && (n = t.deletions, n === null ? (t.deletions = [e], t.flags |= 16) : n.push(e)), t.child = r, t.memoizedState = null, r;
  }
  function jo(e, t) {
    return t = Ka({ mode: "visible", children: t }, e.mode, 0, null), t.return = e, e.child = t;
  }
  function Fa(e, t, n, r) {
    return r !== null && ao(r), Xn(t, e.child, null, n), e = jo(t, t.pendingProps.children), e.flags |= 2, t.memoizedState = null, e;
  }
  function hf(e, t, n, r, a, l, o) {
    if (n)
      return t.flags & 256 ? (t.flags &= -257, r = No(Error(s(422))), Fa(e, t, o, r)) : t.memoizedState !== null ? (t.child = e.child, t.flags |= 128, null) : (l = r.fallback, a = t.mode, r = Ka({ mode: "visible", children: r.children }, a, 0, null), l = _n(l, a, o, null), l.flags |= 2, r.return = t, l.return = t, r.sibling = l, t.child = r, t.mode & 1 && Xn(t, e.child, null, o), t.child.memoizedState = Po(o), t.memoizedState = Mo, l);
    if (!(t.mode & 1)) return Fa(e, t, o, null);
    if (a.data === "$!") {
      if (r = a.nextSibling && a.nextSibling.dataset, r) var c = r.dgst;
      return r = c, l = Error(s(419)), r = No(l, r, void 0), Fa(e, t, o, r);
    }
    if (c = (o & e.childLanes) !== 0, tt || c) {
      if (r = Ae, r !== null) {
        switch (o & -o) {
          case 4:
            a = 2;
            break;
          case 16:
            a = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            a = 32;
            break;
          case 536870912:
            a = 268435456;
            break;
          default:
            a = 0;
        }
        a = a & (r.suspendedLanes | o) ? 0 : a, a !== 0 && a !== l.retryLane && (l.retryLane = a, Ht(e, a), Ct(r, e, a, -1));
      }
      return Zo(), r = No(Error(s(421))), Fa(e, t, o, r);
    }
    return a.data === "$?" ? (t.flags |= 128, t.child = e.child, t = Lf.bind(null, e), a._reactRetry = t, null) : (e = l.treeContext, it = Jt(a.nextSibling), ot = t, Le = !0, yt = null, e !== null && (ct[dt++] = Ft, ct[dt++] = Vt, ct[dt++] = bn, Ft = e.id, Vt = e.overflow, bn = t), t = jo(t, r.children), t.flags |= 4096, t);
  }
  function ku(e, t, n) {
    e.lanes |= t;
    var r = e.alternate;
    r !== null && (r.lanes |= t), so(e.return, t, n);
  }
  function Io(e, t, n, r, a) {
    var l = e.memoizedState;
    l === null ? e.memoizedState = { isBackwards: t, rendering: null, renderingStartTime: 0, last: r, tail: n, tailMode: a } : (l.isBackwards = t, l.rendering = null, l.renderingStartTime = 0, l.last = r, l.tail = n, l.tailMode = a);
  }
  function Cu(e, t, n) {
    var r = t.pendingProps, a = r.revealOrder, l = r.tail;
    if (qe(e, t, r.children, n), r = Pe.current, r & 2) r = r & 1 | 2, t.flags |= 128;
    else {
      if (e !== null && e.flags & 128) e: for (e = t.child; e !== null; ) {
        if (e.tag === 13) e.memoizedState !== null && ku(e, n, t);
        else if (e.tag === 19) ku(e, n, t);
        else if (e.child !== null) {
          e.child.return = e, e = e.child;
          continue;
        }
        if (e === t) break e;
        for (; e.sibling === null; ) {
          if (e.return === null || e.return === t) break e;
          e = e.return;
        }
        e.sibling.return = e.return, e = e.sibling;
      }
      r &= 1;
    }
    if (Ee(Pe, r), !(t.mode & 1)) t.memoizedState = null;
    else switch (a) {
      case "forwards":
        for (n = t.child, a = null; n !== null; ) e = n.alternate, e !== null && Ma(e) === null && (a = n), n = n.sibling;
        n = a, n === null ? (a = t.child, t.child = null) : (a = n.sibling, n.sibling = null), Io(t, !1, a, n, l);
        break;
      case "backwards":
        for (n = null, a = t.child, t.child = null; a !== null; ) {
          if (e = a.alternate, e !== null && Ma(e) === null) {
            t.child = a;
            break;
          }
          e = a.sibling, a.sibling = n, n = a, a = e;
        }
        Io(t, !0, n, null, l);
        break;
      case "together":
        Io(t, !1, null, null, void 0);
        break;
      default:
        t.memoizedState = null;
    }
    return t.child;
  }
  function Va(e, t) {
    !(t.mode & 1) && e !== null && (e.alternate = null, t.alternate = null, t.flags |= 2);
  }
  function At(e, t, n) {
    if (e !== null && (t.dependencies = e.dependencies), Cn |= t.lanes, !(n & t.childLanes)) return null;
    if (e !== null && t.child !== e.child) throw Error(s(153));
    if (t.child !== null) {
      for (e = t.child, n = cn(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null; ) e = e.sibling, n = n.sibling = cn(e, e.pendingProps), n.return = t;
      n.sibling = null;
    }
    return t.child;
  }
  function gf(e, t, n) {
    switch (t.tag) {
      case 3:
        yu(t), Qn();
        break;
      case 5:
        Fs(t);
        break;
      case 1:
        et(t.type) && wa(t);
        break;
      case 4:
        fo(t, t.stateNode.containerInfo);
        break;
      case 10:
        var r = t.type._context, a = t.memoizedProps.value;
        Ee(Na, r._currentValue), r._currentValue = a;
        break;
      case 13:
        if (r = t.memoizedState, r !== null)
          return r.dehydrated !== null ? (Ee(Pe, Pe.current & 1), t.flags |= 128, null) : n & t.child.childLanes ? xu(e, t, n) : (Ee(Pe, Pe.current & 1), e = At(e, t, n), e !== null ? e.sibling : null);
        Ee(Pe, Pe.current & 1);
        break;
      case 19:
        if (r = (n & t.childLanes) !== 0, e.flags & 128) {
          if (r) return Cu(e, t, n);
          t.flags |= 128;
        }
        if (a = t.memoizedState, a !== null && (a.rendering = null, a.tail = null, a.lastEffect = null), Ee(Pe, Pe.current), r) break;
        return null;
      case 22:
      case 23:
        return t.lanes = 0, gu(e, t, n);
    }
    return At(e, t, n);
  }
  var Su, Ro, Eu, Nu;
  Su = function(e, t) {
    for (var n = t.child; n !== null; ) {
      if (n.tag === 5 || n.tag === 6) e.appendChild(n.stateNode);
      else if (n.tag !== 4 && n.child !== null) {
        n.child.return = n, n = n.child;
        continue;
      }
      if (n === t) break;
      for (; n.sibling === null; ) {
        if (n.return === null || n.return === t) return;
        n = n.return;
      }
      n.sibling.return = n.return, n = n.sibling;
    }
  }, Ro = function() {
  }, Eu = function(e, t, n, r) {
    var a = e.memoizedProps;
    if (a !== r) {
      e = t.stateNode, xn(zt.current);
      var l = null;
      switch (n) {
        case "input":
          a = or(e, a), r = or(e, r), l = [];
          break;
        case "select":
          a = F({}, a, { value: void 0 }), r = F({}, r, { value: void 0 }), l = [];
          break;
        case "textarea":
          a = Pn(e, a), r = Pn(e, r), l = [];
          break;
        default:
          typeof a.onClick != "function" && typeof r.onClick == "function" && (e.onclick = va);
      }
      pl(n, r);
      var o;
      n = null;
      for (b in a) if (!r.hasOwnProperty(b) && a.hasOwnProperty(b) && a[b] != null) if (b === "style") {
        var c = a[b];
        for (o in c) c.hasOwnProperty(o) && (n || (n = {}), n[o] = "");
      } else b !== "dangerouslySetInnerHTML" && b !== "children" && b !== "suppressContentEditableWarning" && b !== "suppressHydrationWarning" && b !== "autoFocus" && (C.hasOwnProperty(b) ? l || (l = []) : (l = l || []).push(b, null));
      for (b in r) {
        var d = r[b];
        if (c = a?.[b], r.hasOwnProperty(b) && d !== c && (d != null || c != null)) if (b === "style") if (c) {
          for (o in c) !c.hasOwnProperty(o) || d && d.hasOwnProperty(o) || (n || (n = {}), n[o] = "");
          for (o in d) d.hasOwnProperty(o) && c[o] !== d[o] && (n || (n = {}), n[o] = d[o]);
        } else n || (l || (l = []), l.push(
          b,
          n
        )), n = d;
        else b === "dangerouslySetInnerHTML" ? (d = d ? d.__html : void 0, c = c ? c.__html : void 0, d != null && c !== d && (l = l || []).push(b, d)) : b === "children" ? typeof d != "string" && typeof d != "number" || (l = l || []).push(b, "" + d) : b !== "suppressContentEditableWarning" && b !== "suppressHydrationWarning" && (C.hasOwnProperty(b) ? (d != null && b === "onScroll" && Ne("scroll", e), l || c === d || (l = [])) : (l = l || []).push(b, d));
      }
      n && (l = l || []).push("style", n);
      var b = l;
      (t.updateQueue = b) && (t.flags |= 4);
    }
  }, Nu = function(e, t, n, r) {
    n !== r && (t.flags |= 4);
  };
  function Vr(e, t) {
    if (!Le) switch (e.tailMode) {
      case "hidden":
        t = e.tail;
        for (var n = null; t !== null; ) t.alternate !== null && (n = t), t = t.sibling;
        n === null ? e.tail = null : n.sibling = null;
        break;
      case "collapsed":
        n = e.tail;
        for (var r = null; n !== null; ) n.alternate !== null && (r = n), n = n.sibling;
        r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
    }
  }
  function Xe(e) {
    var t = e.alternate !== null && e.alternate.child === e.child, n = 0, r = 0;
    if (t) for (var a = e.child; a !== null; ) n |= a.lanes | a.childLanes, r |= a.subtreeFlags & 14680064, r |= a.flags & 14680064, a.return = e, a = a.sibling;
    else for (a = e.child; a !== null; ) n |= a.lanes | a.childLanes, r |= a.subtreeFlags, r |= a.flags, a.return = e, a = a.sibling;
    return e.subtreeFlags |= r, e.childLanes = n, t;
  }
  function vf(e, t, n) {
    var r = t.pendingProps;
    switch (to(t), t.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Xe(t), null;
      case 1:
        return et(t.type) && ya(), Xe(t), null;
      case 3:
        return r = t.stateNode, Jn(), _e(Ge), _e(Ze), ho(), r.pendingContext && (r.context = r.pendingContext, r.pendingContext = null), (e === null || e.child === null) && (Sa(t) ? t.flags |= 4 : e === null || e.memoizedState.isDehydrated && !(t.flags & 256) || (t.flags |= 1024, yt !== null && (Do(yt), yt = null))), Ro(e, t), Xe(t), null;
      case 5:
        po(t);
        var a = xn(Ir.current);
        if (n = t.type, e !== null && t.stateNode != null) Eu(e, t, n, r, a), e.ref !== t.ref && (t.flags |= 512, t.flags |= 2097152);
        else {
          if (!r) {
            if (t.stateNode === null) throw Error(s(166));
            return Xe(t), null;
          }
          if (e = xn(zt.current), Sa(t)) {
            r = t.stateNode, n = t.type;
            var l = t.memoizedProps;
            switch (r[Lt] = t, r[Lr] = l, e = (t.mode & 1) !== 0, n) {
              case "dialog":
                Ne("cancel", r), Ne("close", r);
                break;
              case "iframe":
              case "object":
              case "embed":
                Ne("load", r);
                break;
              case "video":
              case "audio":
                for (a = 0; a < Er.length; a++) Ne(Er[a], r);
                break;
              case "source":
                Ne("error", r);
                break;
              case "img":
              case "image":
              case "link":
                Ne(
                  "error",
                  r
                ), Ne("load", r);
                break;
              case "details":
                Ne("toggle", r);
                break;
              case "input":
                Qr(r, l), Ne("invalid", r);
                break;
              case "select":
                r._wrapperState = { wasMultiple: !!l.multiple }, Ne("invalid", r);
                break;
              case "textarea":
                It(r, l), Ne("invalid", r);
            }
            pl(n, l), a = null;
            for (var o in l) if (l.hasOwnProperty(o)) {
              var c = l[o];
              o === "children" ? typeof c == "string" ? r.textContent !== c && (l.suppressHydrationWarning !== !0 && ga(r.textContent, c, e), a = ["children", c]) : typeof c == "number" && r.textContent !== "" + c && (l.suppressHydrationWarning !== !0 && ga(
                r.textContent,
                c,
                e
              ), a = ["children", "" + c]) : C.hasOwnProperty(o) && c != null && o === "onScroll" && Ne("scroll", r);
            }
            switch (n) {
              case "input":
                Bt(r), Xr(r, l, !0);
                break;
              case "textarea":
                Bt(r), jn(r);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof l.onClick == "function" && (r.onclick = va);
            }
            r = a, t.updateQueue = r, r !== null && (t.flags |= 4);
          } else {
            o = a.nodeType === 9 ? a : a.ownerDocument, e === "http://www.w3.org/1999/xhtml" && (e = In(n)), e === "http://www.w3.org/1999/xhtml" ? n === "script" ? (e = o.createElement("div"), e.innerHTML = "<script><\/script>", e = e.removeChild(e.firstChild)) : typeof r.is == "string" ? e = o.createElement(n, { is: r.is }) : (e = o.createElement(n), n === "select" && (o = e, r.multiple ? o.multiple = !0 : r.size && (o.size = r.size))) : e = o.createElementNS(e, n), e[Lt] = t, e[Lr] = r, Su(e, t, !1, !1), t.stateNode = e;
            e: {
              switch (o = ml(n, r), n) {
                case "dialog":
                  Ne("cancel", e), Ne("close", e), a = r;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  Ne("load", e), a = r;
                  break;
                case "video":
                case "audio":
                  for (a = 0; a < Er.length; a++) Ne(Er[a], e);
                  a = r;
                  break;
                case "source":
                  Ne("error", e), a = r;
                  break;
                case "img":
                case "image":
                case "link":
                  Ne(
                    "error",
                    e
                  ), Ne("load", e), a = r;
                  break;
                case "details":
                  Ne("toggle", e), a = r;
                  break;
                case "input":
                  Qr(e, r), a = or(e, r), Ne("invalid", e);
                  break;
                case "option":
                  a = r;
                  break;
                case "select":
                  e._wrapperState = { wasMultiple: !!r.multiple }, a = F({}, r, { value: void 0 }), Ne("invalid", e);
                  break;
                case "textarea":
                  It(e, r), a = Pn(e, r), Ne("invalid", e);
                  break;
                default:
                  a = r;
              }
              pl(n, a), c = a;
              for (l in c) if (c.hasOwnProperty(l)) {
                var d = c[l];
                l === "style" ? hi(e, d) : l === "dangerouslySetInnerHTML" ? (d = d ? d.__html : void 0, d != null && Fe(e, d)) : l === "children" ? typeof d == "string" ? (n !== "textarea" || d !== "") && ze(e, d) : typeof d == "number" && ze(e, "" + d) : l !== "suppressContentEditableWarning" && l !== "suppressHydrationWarning" && l !== "autoFocus" && (C.hasOwnProperty(l) ? d != null && l === "onScroll" && Ne("scroll", e) : d != null && H(e, l, d, o));
              }
              switch (n) {
                case "input":
                  Bt(e), Xr(e, r, !1);
                  break;
                case "textarea":
                  Bt(e), jn(e);
                  break;
                case "option":
                  r.value != null && e.setAttribute("value", "" + ye(r.value));
                  break;
                case "select":
                  e.multiple = !!r.multiple, l = r.value, l != null ? Nt(e, !!r.multiple, l, !1) : r.defaultValue != null && Nt(
                    e,
                    !!r.multiple,
                    r.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof a.onClick == "function" && (e.onclick = va);
              }
              switch (n) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  r = !!r.autoFocus;
                  break e;
                case "img":
                  r = !0;
                  break e;
                default:
                  r = !1;
              }
            }
            r && (t.flags |= 4);
          }
          t.ref !== null && (t.flags |= 512, t.flags |= 2097152);
        }
        return Xe(t), null;
      case 6:
        if (e && t.stateNode != null) Nu(e, t, e.memoizedProps, r);
        else {
          if (typeof r != "string" && t.stateNode === null) throw Error(s(166));
          if (n = xn(Ir.current), xn(zt.current), Sa(t)) {
            if (r = t.stateNode, n = t.memoizedProps, r[Lt] = t, (l = r.nodeValue !== n) && (e = ot, e !== null)) switch (e.tag) {
              case 3:
                ga(r.nodeValue, n, (e.mode & 1) !== 0);
                break;
              case 5:
                e.memoizedProps.suppressHydrationWarning !== !0 && ga(r.nodeValue, n, (e.mode & 1) !== 0);
            }
            l && (t.flags |= 4);
          } else r = (n.nodeType === 9 ? n : n.ownerDocument).createTextNode(r), r[Lt] = t, t.stateNode = r;
        }
        return Xe(t), null;
      case 13:
        if (_e(Pe), r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
          if (Le && it !== null && t.mode & 1 && !(t.flags & 128)) zs(), Qn(), t.flags |= 98560, l = !1;
          else if (l = Sa(t), r !== null && r.dehydrated !== null) {
            if (e === null) {
              if (!l) throw Error(s(318));
              if (l = t.memoizedState, l = l !== null ? l.dehydrated : null, !l) throw Error(s(317));
              l[Lt] = t;
            } else Qn(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
            Xe(t), l = !1;
          } else yt !== null && (Do(yt), yt = null), l = !0;
          if (!l) return t.flags & 65536 ? t : null;
        }
        return t.flags & 128 ? (t.lanes = n, t) : (r = r !== null, r !== (e !== null && e.memoizedState !== null) && r && (t.child.flags |= 8192, t.mode & 1 && (e === null || Pe.current & 1 ? He === 0 && (He = 3) : Zo())), t.updateQueue !== null && (t.flags |= 4), Xe(t), null);
      case 4:
        return Jn(), Ro(e, t), e === null && Nr(t.stateNode.containerInfo), Xe(t), null;
      case 10:
        return io(t.type._context), Xe(t), null;
      case 17:
        return et(t.type) && ya(), Xe(t), null;
      case 19:
        if (_e(Pe), l = t.memoizedState, l === null) return Xe(t), null;
        if (r = (t.flags & 128) !== 0, o = l.rendering, o === null) if (r) Vr(l, !1);
        else {
          if (He !== 0 || e !== null && e.flags & 128) for (e = t.child; e !== null; ) {
            if (o = Ma(e), o !== null) {
              for (t.flags |= 128, Vr(l, !1), r = o.updateQueue, r !== null && (t.updateQueue = r, t.flags |= 4), t.subtreeFlags = 0, r = n, n = t.child; n !== null; ) l = n, e = r, l.flags &= 14680066, o = l.alternate, o === null ? (l.childLanes = 0, l.lanes = e, l.child = null, l.subtreeFlags = 0, l.memoizedProps = null, l.memoizedState = null, l.updateQueue = null, l.dependencies = null, l.stateNode = null) : (l.childLanes = o.childLanes, l.lanes = o.lanes, l.child = o.child, l.subtreeFlags = 0, l.deletions = null, l.memoizedProps = o.memoizedProps, l.memoizedState = o.memoizedState, l.updateQueue = o.updateQueue, l.type = o.type, e = o.dependencies, l.dependencies = e === null ? null : { lanes: e.lanes, firstContext: e.firstContext }), n = n.sibling;
              return Ee(Pe, Pe.current & 1 | 2), t.child;
            }
            e = e.sibling;
          }
          l.tail !== null && Re() > nr && (t.flags |= 128, r = !0, Vr(l, !1), t.lanes = 4194304);
        }
        else {
          if (!r) if (e = Ma(o), e !== null) {
            if (t.flags |= 128, r = !0, n = e.updateQueue, n !== null && (t.updateQueue = n, t.flags |= 4), Vr(l, !0), l.tail === null && l.tailMode === "hidden" && !o.alternate && !Le) return Xe(t), null;
          } else 2 * Re() - l.renderingStartTime > nr && n !== 1073741824 && (t.flags |= 128, r = !0, Vr(l, !1), t.lanes = 4194304);
          l.isBackwards ? (o.sibling = t.child, t.child = o) : (n = l.last, n !== null ? n.sibling = o : t.child = o, l.last = o);
        }
        return l.tail !== null ? (t = l.tail, l.rendering = t, l.tail = t.sibling, l.renderingStartTime = Re(), t.sibling = null, n = Pe.current, Ee(Pe, r ? n & 1 | 2 : n & 1), t) : (Xe(t), null);
      case 22:
      case 23:
        return Yo(), r = t.memoizedState !== null, e !== null && e.memoizedState !== null !== r && (t.flags |= 8192), r && t.mode & 1 ? st & 1073741824 && (Xe(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : Xe(t), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(s(156, t.tag));
  }
  function bf(e, t) {
    switch (to(t), t.tag) {
      case 1:
        return et(t.type) && ya(), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
      case 3:
        return Jn(), _e(Ge), _e(Ze), ho(), e = t.flags, e & 65536 && !(e & 128) ? (t.flags = e & -65537 | 128, t) : null;
      case 5:
        return po(t), null;
      case 13:
        if (_e(Pe), e = t.memoizedState, e !== null && e.dehydrated !== null) {
          if (t.alternate === null) throw Error(s(340));
          Qn();
        }
        return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
      case 19:
        return _e(Pe), null;
      case 4:
        return Jn(), null;
      case 10:
        return io(t.type._context), null;
      case 22:
      case 23:
        return Yo(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var Ha = !1, Ke = !1, yf = typeof WeakSet == "function" ? WeakSet : Set, G = null;
  function er(e, t) {
    var n = e.ref;
    if (n !== null) if (typeof n == "function") try {
      n(null);
    } catch (r) {
      Ie(e, t, r);
    }
    else n.current = null;
  }
  function _u(e, t, n) {
    try {
      n();
    } catch (r) {
      Ie(e, t, r);
    }
  }
  var Lu = !1;
  function wf(e, t) {
    if (Yl = la, e = ls(), Vl(e)) {
      if ("selectionStart" in e) var n = { start: e.selectionStart, end: e.selectionEnd };
      else e: {
        n = (n = e.ownerDocument) && n.defaultView || window;
        var r = n.getSelection && n.getSelection();
        if (r && r.rangeCount !== 0) {
          n = r.anchorNode;
          var a = r.anchorOffset, l = r.focusNode;
          r = r.focusOffset;
          try {
            n.nodeType, l.nodeType;
          } catch {
            n = null;
            break e;
          }
          var o = 0, c = -1, d = -1, b = 0, I = 0, T = e, P = null;
          t: for (; ; ) {
            for (var J; T !== n || a !== 0 && T.nodeType !== 3 || (c = o + a), T !== l || r !== 0 && T.nodeType !== 3 || (d = o + r), T.nodeType === 3 && (o += T.nodeValue.length), (J = T.firstChild) !== null; )
              P = T, T = J;
            for (; ; ) {
              if (T === e) break t;
              if (P === n && ++b === a && (c = o), P === l && ++I === r && (d = o), (J = T.nextSibling) !== null) break;
              T = P, P = T.parentNode;
            }
            T = J;
          }
          n = c === -1 || d === -1 ? null : { start: c, end: d };
        } else n = null;
      }
      n = n || { start: 0, end: 0 };
    } else n = null;
    for (Zl = { focusedElem: e, selectionRange: n }, la = !1, G = t; G !== null; ) if (t = G, e = t.child, (t.subtreeFlags & 1028) !== 0 && e !== null) e.return = t, G = e;
    else for (; G !== null; ) {
      t = G;
      try {
        var te = t.alternate;
        if (t.flags & 1024) switch (t.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (te !== null) {
              var re = te.memoizedProps, Te = te.memoizedState, g = t.stateNode, f = g.getSnapshotBeforeUpdate(t.elementType === t.type ? re : wt(t.type, re), Te);
              g.__reactInternalSnapshotBeforeUpdate = f;
            }
            break;
          case 3:
            var v = t.stateNode.containerInfo;
            v.nodeType === 1 ? v.textContent = "" : v.nodeType === 9 && v.documentElement && v.removeChild(v.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(s(163));
        }
      } catch (A) {
        Ie(t, t.return, A);
      }
      if (e = t.sibling, e !== null) {
        e.return = t.return, G = e;
        break;
      }
      G = t.return;
    }
    return te = Lu, Lu = !1, te;
  }
  function Hr(e, t, n) {
    var r = t.updateQueue;
    if (r = r !== null ? r.lastEffect : null, r !== null) {
      var a = r = r.next;
      do {
        if ((a.tag & e) === e) {
          var l = a.destroy;
          a.destroy = void 0, l !== void 0 && _u(t, n, l);
        }
        a = a.next;
      } while (a !== r);
    }
  }
  function $a(e, t) {
    if (t = t.updateQueue, t = t !== null ? t.lastEffect : null, t !== null) {
      var n = t = t.next;
      do {
        if ((n.tag & e) === e) {
          var r = n.create;
          n.destroy = r();
        }
        n = n.next;
      } while (n !== t);
    }
  }
  function To(e) {
    var t = e.ref;
    if (t !== null) {
      var n = e.stateNode;
      switch (e.tag) {
        case 5:
          e = n;
          break;
        default:
          e = n;
      }
      typeof t == "function" ? t(e) : t.current = e;
    }
  }
  function zu(e) {
    var t = e.alternate;
    t !== null && (e.alternate = null, zu(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && (delete t[Lt], delete t[Lr], delete t[ql], delete t[tf], delete t[nf])), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
  }
  function Mu(e) {
    return e.tag === 5 || e.tag === 3 || e.tag === 4;
  }
  function Pu(e) {
    e: for (; ; ) {
      for (; e.sibling === null; ) {
        if (e.return === null || Mu(e.return)) return null;
        e = e.return;
      }
      for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18; ) {
        if (e.flags & 2 || e.child === null || e.tag === 4) continue e;
        e.child.return = e, e = e.child;
      }
      if (!(e.flags & 2)) return e.stateNode;
    }
  }
  function Oo(e, t, n) {
    var r = e.tag;
    if (r === 5 || r === 6) e = e.stateNode, t ? n.nodeType === 8 ? n.parentNode.insertBefore(e, t) : n.insertBefore(e, t) : (n.nodeType === 8 ? (t = n.parentNode, t.insertBefore(e, n)) : (t = n, t.appendChild(e)), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = va));
    else if (r !== 4 && (e = e.child, e !== null)) for (Oo(e, t, n), e = e.sibling; e !== null; ) Oo(e, t, n), e = e.sibling;
  }
  function Fo(e, t, n) {
    var r = e.tag;
    if (r === 5 || r === 6) e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);
    else if (r !== 4 && (e = e.child, e !== null)) for (Fo(e, t, n), e = e.sibling; e !== null; ) Fo(e, t, n), e = e.sibling;
  }
  var De = null, xt = !1;
  function an(e, t, n) {
    for (n = n.child; n !== null; ) ju(e, t, n), n = n.sibling;
  }
  function ju(e, t, n) {
    if (_t && typeof _t.onCommitFiberUnmount == "function") try {
      _t.onCommitFiberUnmount(Gr, n);
    } catch {
    }
    switch (n.tag) {
      case 5:
        Ke || er(n, t);
      case 6:
        var r = De, a = xt;
        De = null, an(e, t, n), De = r, xt = a, De !== null && (xt ? (e = De, n = n.stateNode, e.nodeType === 8 ? e.parentNode.removeChild(n) : e.removeChild(n)) : De.removeChild(n.stateNode));
        break;
      case 18:
        De !== null && (xt ? (e = De, n = n.stateNode, e.nodeType === 8 ? Kl(e.parentNode, n) : e.nodeType === 1 && Kl(e, n), vr(e)) : Kl(De, n.stateNode));
        break;
      case 4:
        r = De, a = xt, De = n.stateNode.containerInfo, xt = !0, an(e, t, n), De = r, xt = a;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!Ke && (r = n.updateQueue, r !== null && (r = r.lastEffect, r !== null))) {
          a = r = r.next;
          do {
            var l = a, o = l.destroy;
            l = l.tag, o !== void 0 && (l & 2 || l & 4) && _u(n, t, o), a = a.next;
          } while (a !== r);
        }
        an(e, t, n);
        break;
      case 1:
        if (!Ke && (er(n, t), r = n.stateNode, typeof r.componentWillUnmount == "function")) try {
          r.props = n.memoizedProps, r.state = n.memoizedState, r.componentWillUnmount();
        } catch (c) {
          Ie(n, t, c);
        }
        an(e, t, n);
        break;
      case 21:
        an(e, t, n);
        break;
      case 22:
        n.mode & 1 ? (Ke = (r = Ke) || n.memoizedState !== null, an(e, t, n), Ke = r) : an(e, t, n);
        break;
      default:
        an(e, t, n);
    }
  }
  function Iu(e) {
    var t = e.updateQueue;
    if (t !== null) {
      e.updateQueue = null;
      var n = e.stateNode;
      n === null && (n = e.stateNode = new yf()), t.forEach(function(r) {
        var a = zf.bind(null, e, r);
        n.has(r) || (n.add(r), r.then(a, a));
      });
    }
  }
  function kt(e, t) {
    var n = t.deletions;
    if (n !== null) for (var r = 0; r < n.length; r++) {
      var a = n[r];
      try {
        var l = e, o = t, c = o;
        e: for (; c !== null; ) {
          switch (c.tag) {
            case 5:
              De = c.stateNode, xt = !1;
              break e;
            case 3:
              De = c.stateNode.containerInfo, xt = !0;
              break e;
            case 4:
              De = c.stateNode.containerInfo, xt = !0;
              break e;
          }
          c = c.return;
        }
        if (De === null) throw Error(s(160));
        ju(l, o, a), De = null, xt = !1;
        var d = a.alternate;
        d !== null && (d.return = null), a.return = null;
      } catch (b) {
        Ie(a, t, b);
      }
    }
    if (t.subtreeFlags & 12854) for (t = t.child; t !== null; ) Ru(t, e), t = t.sibling;
  }
  function Ru(e, t) {
    var n = e.alternate, r = e.flags;
    switch (e.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (kt(t, e), Pt(e), r & 4) {
          try {
            Hr(3, e, e.return), $a(3, e);
          } catch (re) {
            Ie(e, e.return, re);
          }
          try {
            Hr(5, e, e.return);
          } catch (re) {
            Ie(e, e.return, re);
          }
        }
        break;
      case 1:
        kt(t, e), Pt(e), r & 512 && n !== null && er(n, n.return);
        break;
      case 5:
        if (kt(t, e), Pt(e), r & 512 && n !== null && er(n, n.return), e.flags & 32) {
          var a = e.stateNode;
          try {
            ze(a, "");
          } catch (re) {
            Ie(e, e.return, re);
          }
        }
        if (r & 4 && (a = e.stateNode, a != null)) {
          var l = e.memoizedProps, o = n !== null ? n.memoizedProps : l, c = e.type, d = e.updateQueue;
          if (e.updateQueue = null, d !== null) try {
            c === "input" && l.type === "radio" && l.name != null && Mn(a, l), ml(c, o);
            var b = ml(c, l);
            for (o = 0; o < d.length; o += 2) {
              var I = d[o], T = d[o + 1];
              I === "style" ? hi(a, T) : I === "dangerouslySetInnerHTML" ? Fe(a, T) : I === "children" ? ze(a, T) : H(a, I, T, b);
            }
            switch (c) {
              case "input":
                Et(a, l);
                break;
              case "textarea":
                Rt(a, l);
                break;
              case "select":
                var P = a._wrapperState.wasMultiple;
                a._wrapperState.wasMultiple = !!l.multiple;
                var J = l.value;
                J != null ? Nt(a, !!l.multiple, J, !1) : P !== !!l.multiple && (l.defaultValue != null ? Nt(
                  a,
                  !!l.multiple,
                  l.defaultValue,
                  !0
                ) : Nt(a, !!l.multiple, l.multiple ? [] : "", !1));
            }
            a[Lr] = l;
          } catch (re) {
            Ie(e, e.return, re);
          }
        }
        break;
      case 6:
        if (kt(t, e), Pt(e), r & 4) {
          if (e.stateNode === null) throw Error(s(162));
          a = e.stateNode, l = e.memoizedProps;
          try {
            a.nodeValue = l;
          } catch (re) {
            Ie(e, e.return, re);
          }
        }
        break;
      case 3:
        if (kt(t, e), Pt(e), r & 4 && n !== null && n.memoizedState.isDehydrated) try {
          vr(t.containerInfo);
        } catch (re) {
          Ie(e, e.return, re);
        }
        break;
      case 4:
        kt(t, e), Pt(e);
        break;
      case 13:
        kt(t, e), Pt(e), a = e.child, a.flags & 8192 && (l = a.memoizedState !== null, a.stateNode.isHidden = l, !l || a.alternate !== null && a.alternate.memoizedState !== null || ($o = Re())), r & 4 && Iu(e);
        break;
      case 22:
        if (I = n !== null && n.memoizedState !== null, e.mode & 1 ? (Ke = (b = Ke) || I, kt(t, e), Ke = b) : kt(t, e), Pt(e), r & 8192) {
          if (b = e.memoizedState !== null, (e.stateNode.isHidden = b) && !I && e.mode & 1) for (G = e, I = e.child; I !== null; ) {
            for (T = G = I; G !== null; ) {
              switch (P = G, J = P.child, P.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  Hr(4, P, P.return);
                  break;
                case 1:
                  er(P, P.return);
                  var te = P.stateNode;
                  if (typeof te.componentWillUnmount == "function") {
                    r = P, n = P.return;
                    try {
                      t = r, te.props = t.memoizedProps, te.state = t.memoizedState, te.componentWillUnmount();
                    } catch (re) {
                      Ie(r, n, re);
                    }
                  }
                  break;
                case 5:
                  er(P, P.return);
                  break;
                case 22:
                  if (P.memoizedState !== null) {
                    Fu(T);
                    continue;
                  }
              }
              J !== null ? (J.return = P, G = J) : Fu(T);
            }
            I = I.sibling;
          }
          e: for (I = null, T = e; ; ) {
            if (T.tag === 5) {
              if (I === null) {
                I = T;
                try {
                  a = T.stateNode, b ? (l = a.style, typeof l.setProperty == "function" ? l.setProperty("display", "none", "important") : l.display = "none") : (c = T.stateNode, d = T.memoizedProps.style, o = d != null && d.hasOwnProperty("display") ? d.display : null, c.style.display = mi("display", o));
                } catch (re) {
                  Ie(e, e.return, re);
                }
              }
            } else if (T.tag === 6) {
              if (I === null) try {
                T.stateNode.nodeValue = b ? "" : T.memoizedProps;
              } catch (re) {
                Ie(e, e.return, re);
              }
            } else if ((T.tag !== 22 && T.tag !== 23 || T.memoizedState === null || T === e) && T.child !== null) {
              T.child.return = T, T = T.child;
              continue;
            }
            if (T === e) break e;
            for (; T.sibling === null; ) {
              if (T.return === null || T.return === e) break e;
              I === T && (I = null), T = T.return;
            }
            I === T && (I = null), T.sibling.return = T.return, T = T.sibling;
          }
        }
        break;
      case 19:
        kt(t, e), Pt(e), r & 4 && Iu(e);
        break;
      case 21:
        break;
      default:
        kt(
          t,
          e
        ), Pt(e);
    }
  }
  function Pt(e) {
    var t = e.flags;
    if (t & 2) {
      try {
        e: {
          for (var n = e.return; n !== null; ) {
            if (Mu(n)) {
              var r = n;
              break e;
            }
            n = n.return;
          }
          throw Error(s(160));
        }
        switch (r.tag) {
          case 5:
            var a = r.stateNode;
            r.flags & 32 && (ze(a, ""), r.flags &= -33);
            var l = Pu(e);
            Fo(e, l, a);
            break;
          case 3:
          case 4:
            var o = r.stateNode.containerInfo, c = Pu(e);
            Oo(e, c, o);
            break;
          default:
            throw Error(s(161));
        }
      } catch (d) {
        Ie(e, e.return, d);
      }
      e.flags &= -3;
    }
    t & 4096 && (e.flags &= -4097);
  }
  function xf(e, t, n) {
    G = e, Tu(e);
  }
  function Tu(e, t, n) {
    for (var r = (e.mode & 1) !== 0; G !== null; ) {
      var a = G, l = a.child;
      if (a.tag === 22 && r) {
        var o = a.memoizedState !== null || Ha;
        if (!o) {
          var c = a.alternate, d = c !== null && c.memoizedState !== null || Ke;
          c = Ha;
          var b = Ke;
          if (Ha = o, (Ke = d) && !b) for (G = a; G !== null; ) o = G, d = o.child, o.tag === 22 && o.memoizedState !== null ? Vu(a) : d !== null ? (d.return = o, G = d) : Vu(a);
          for (; l !== null; ) G = l, Tu(l), l = l.sibling;
          G = a, Ha = c, Ke = b;
        }
        Ou(e);
      } else a.subtreeFlags & 8772 && l !== null ? (l.return = a, G = l) : Ou(e);
    }
  }
  function Ou(e) {
    for (; G !== null; ) {
      var t = G;
      if (t.flags & 8772) {
        var n = t.alternate;
        try {
          if (t.flags & 8772) switch (t.tag) {
            case 0:
            case 11:
            case 15:
              Ke || $a(5, t);
              break;
            case 1:
              var r = t.stateNode;
              if (t.flags & 4 && !Ke) if (n === null) r.componentDidMount();
              else {
                var a = t.elementType === t.type ? n.memoizedProps : wt(t.type, n.memoizedProps);
                r.componentDidUpdate(a, n.memoizedState, r.__reactInternalSnapshotBeforeUpdate);
              }
              var l = t.updateQueue;
              l !== null && Os(t, l, r);
              break;
            case 3:
              var o = t.updateQueue;
              if (o !== null) {
                if (n = null, t.child !== null) switch (t.child.tag) {
                  case 5:
                    n = t.child.stateNode;
                    break;
                  case 1:
                    n = t.child.stateNode;
                }
                Os(t, o, n);
              }
              break;
            case 5:
              var c = t.stateNode;
              if (n === null && t.flags & 4) {
                n = c;
                var d = t.memoizedProps;
                switch (t.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    d.autoFocus && n.focus();
                    break;
                  case "img":
                    d.src && (n.src = d.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (t.memoizedState === null) {
                var b = t.alternate;
                if (b !== null) {
                  var I = b.memoizedState;
                  if (I !== null) {
                    var T = I.dehydrated;
                    T !== null && vr(T);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(s(163));
          }
          Ke || t.flags & 512 && To(t);
        } catch (P) {
          Ie(t, t.return, P);
        }
      }
      if (t === e) {
        G = null;
        break;
      }
      if (n = t.sibling, n !== null) {
        n.return = t.return, G = n;
        break;
      }
      G = t.return;
    }
  }
  function Fu(e) {
    for (; G !== null; ) {
      var t = G;
      if (t === e) {
        G = null;
        break;
      }
      var n = t.sibling;
      if (n !== null) {
        n.return = t.return, G = n;
        break;
      }
      G = t.return;
    }
  }
  function Vu(e) {
    for (; G !== null; ) {
      var t = G;
      try {
        switch (t.tag) {
          case 0:
          case 11:
          case 15:
            var n = t.return;
            try {
              $a(4, t);
            } catch (d) {
              Ie(t, n, d);
            }
            break;
          case 1:
            var r = t.stateNode;
            if (typeof r.componentDidMount == "function") {
              var a = t.return;
              try {
                r.componentDidMount();
              } catch (d) {
                Ie(t, a, d);
              }
            }
            var l = t.return;
            try {
              To(t);
            } catch (d) {
              Ie(t, l, d);
            }
            break;
          case 5:
            var o = t.return;
            try {
              To(t);
            } catch (d) {
              Ie(t, o, d);
            }
        }
      } catch (d) {
        Ie(t, t.return, d);
      }
      if (t === e) {
        G = null;
        break;
      }
      var c = t.sibling;
      if (c !== null) {
        c.return = t.return, G = c;
        break;
      }
      G = t.return;
    }
  }
  var kf = Math.ceil, Aa = j.ReactCurrentDispatcher, Vo = j.ReactCurrentOwner, mt = j.ReactCurrentBatchConfig, xe = 0, Ae = null, Oe = null, Ue = 0, st = 0, tr = Gt(0), He = 0, $r = null, Cn = 0, Wa = 0, Ho = 0, Ar = null, nt = null, $o = 0, nr = 1 / 0, Wt = null, Ba = !1, Ao = null, ln = null, Da = !1, on = null, Ua = 0, Wr = 0, Wo = null, Ya = -1, Za = 0;
  function Je() {
    return xe & 6 ? Re() : Ya !== -1 ? Ya : Ya = Re();
  }
  function sn(e) {
    return e.mode & 1 ? xe & 2 && Ue !== 0 ? Ue & -Ue : af.transition !== null ? (Za === 0 && (Za = Mi()), Za) : (e = Se, e !== 0 || (e = window.event, e = e === void 0 ? 16 : Hi(e.type)), e) : 1;
  }
  function Ct(e, t, n, r) {
    if (50 < Wr) throw Wr = 0, Wo = null, Error(s(185));
    fr(e, n, r), (!(xe & 2) || e !== Ae) && (e === Ae && (!(xe & 2) && (Wa |= n), He === 4 && un(e, Ue)), rt(e, r), n === 1 && xe === 0 && !(t.mode & 1) && (nr = Re() + 500, xa && tn()));
  }
  function rt(e, t) {
    var n = e.callbackNode;
    ad(e, t);
    var r = na(e, e === Ae ? Ue : 0);
    if (r === 0) n !== null && _i(n), e.callbackNode = null, e.callbackPriority = 0;
    else if (t = r & -r, e.callbackPriority !== t) {
      if (n != null && _i(n), t === 1) e.tag === 0 ? rf($u.bind(null, e)) : Ss($u.bind(null, e)), Gd(function() {
        !(xe & 6) && tn();
      }), n = null;
      else {
        switch (Pi(r)) {
          case 1:
            n = xl;
            break;
          case 4:
            n = Li;
            break;
          case 16:
            n = Jr;
            break;
          case 536870912:
            n = zi;
            break;
          default:
            n = Jr;
        }
        n = Qu(n, Hu.bind(null, e));
      }
      e.callbackPriority = t, e.callbackNode = n;
    }
  }
  function Hu(e, t) {
    if (Ya = -1, Za = 0, xe & 6) throw Error(s(327));
    var n = e.callbackNode;
    if (rr() && e.callbackNode !== n) return null;
    var r = na(e, e === Ae ? Ue : 0);
    if (r === 0) return null;
    if (r & 30 || r & e.expiredLanes || t) t = Qa(e, r);
    else {
      t = r;
      var a = xe;
      xe |= 2;
      var l = Wu();
      (Ae !== e || Ue !== t) && (Wt = null, nr = Re() + 500, En(e, t));
      do
        try {
          Ef();
          break;
        } catch (c) {
          Au(e, c);
        }
      while (!0);
      oo(), Aa.current = l, xe = a, Oe !== null ? t = 0 : (Ae = null, Ue = 0, t = He);
    }
    if (t !== 0) {
      if (t === 2 && (a = kl(e), a !== 0 && (r = a, t = Bo(e, a))), t === 1) throw n = $r, En(e, 0), un(e, r), rt(e, Re()), n;
      if (t === 6) un(e, r);
      else {
        if (a = e.current.alternate, !(r & 30) && !Cf(a) && (t = Qa(e, r), t === 2 && (l = kl(e), l !== 0 && (r = l, t = Bo(e, l))), t === 1)) throw n = $r, En(e, 0), un(e, r), rt(e, Re()), n;
        switch (e.finishedWork = a, e.finishedLanes = r, t) {
          case 0:
          case 1:
            throw Error(s(345));
          case 2:
            Nn(e, nt, Wt);
            break;
          case 3:
            if (un(e, r), (r & 130023424) === r && (t = $o + 500 - Re(), 10 < t)) {
              if (na(e, 0) !== 0) break;
              if (a = e.suspendedLanes, (a & r) !== r) {
                Je(), e.pingedLanes |= e.suspendedLanes & a;
                break;
              }
              e.timeoutHandle = Xl(Nn.bind(null, e, nt, Wt), t);
              break;
            }
            Nn(e, nt, Wt);
            break;
          case 4:
            if (un(e, r), (r & 4194240) === r) break;
            for (t = e.eventTimes, a = -1; 0 < r; ) {
              var o = 31 - vt(r);
              l = 1 << o, o = t[o], o > a && (a = o), r &= ~l;
            }
            if (r = a, r = Re() - r, r = (120 > r ? 120 : 480 > r ? 480 : 1080 > r ? 1080 : 1920 > r ? 1920 : 3e3 > r ? 3e3 : 4320 > r ? 4320 : 1960 * kf(r / 1960)) - r, 10 < r) {
              e.timeoutHandle = Xl(Nn.bind(null, e, nt, Wt), r);
              break;
            }
            Nn(e, nt, Wt);
            break;
          case 5:
            Nn(e, nt, Wt);
            break;
          default:
            throw Error(s(329));
        }
      }
    }
    return rt(e, Re()), e.callbackNode === n ? Hu.bind(null, e) : null;
  }
  function Bo(e, t) {
    var n = Ar;
    return e.current.memoizedState.isDehydrated && (En(e, t).flags |= 256), e = Qa(e, t), e !== 2 && (t = nt, nt = n, t !== null && Do(t)), e;
  }
  function Do(e) {
    nt === null ? nt = e : nt.push.apply(nt, e);
  }
  function Cf(e) {
    for (var t = e; ; ) {
      if (t.flags & 16384) {
        var n = t.updateQueue;
        if (n !== null && (n = n.stores, n !== null)) for (var r = 0; r < n.length; r++) {
          var a = n[r], l = a.getSnapshot;
          a = a.value;
          try {
            if (!bt(l(), a)) return !1;
          } catch {
            return !1;
          }
        }
      }
      if (n = t.child, t.subtreeFlags & 16384 && n !== null) n.return = t, t = n;
      else {
        if (t === e) break;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e) return !0;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
    }
    return !0;
  }
  function un(e, t) {
    for (t &= ~Ho, t &= ~Wa, e.suspendedLanes |= t, e.pingedLanes &= ~t, e = e.expirationTimes; 0 < t; ) {
      var n = 31 - vt(t), r = 1 << n;
      e[n] = -1, t &= ~r;
    }
  }
  function $u(e) {
    if (xe & 6) throw Error(s(327));
    rr();
    var t = na(e, 0);
    if (!(t & 1)) return rt(e, Re()), null;
    var n = Qa(e, t);
    if (e.tag !== 0 && n === 2) {
      var r = kl(e);
      r !== 0 && (t = r, n = Bo(e, r));
    }
    if (n === 1) throw n = $r, En(e, 0), un(e, t), rt(e, Re()), n;
    if (n === 6) throw Error(s(345));
    return e.finishedWork = e.current.alternate, e.finishedLanes = t, Nn(e, nt, Wt), rt(e, Re()), null;
  }
  function Uo(e, t) {
    var n = xe;
    xe |= 1;
    try {
      return e(t);
    } finally {
      xe = n, xe === 0 && (nr = Re() + 500, xa && tn());
    }
  }
  function Sn(e) {
    on !== null && on.tag === 0 && !(xe & 6) && rr();
    var t = xe;
    xe |= 1;
    var n = mt.transition, r = Se;
    try {
      if (mt.transition = null, Se = 1, e) return e();
    } finally {
      Se = r, mt.transition = n, xe = t, !(xe & 6) && tn();
    }
  }
  function Yo() {
    st = tr.current, _e(tr);
  }
  function En(e, t) {
    e.finishedWork = null, e.finishedLanes = 0;
    var n = e.timeoutHandle;
    if (n !== -1 && (e.timeoutHandle = -1, Jd(n)), Oe !== null) for (n = Oe.return; n !== null; ) {
      var r = n;
      switch (to(r), r.tag) {
        case 1:
          r = r.type.childContextTypes, r != null && ya();
          break;
        case 3:
          Jn(), _e(Ge), _e(Ze), ho();
          break;
        case 5:
          po(r);
          break;
        case 4:
          Jn();
          break;
        case 13:
          _e(Pe);
          break;
        case 19:
          _e(Pe);
          break;
        case 10:
          io(r.type._context);
          break;
        case 22:
        case 23:
          Yo();
      }
      n = n.return;
    }
    if (Ae = e, Oe = e = cn(e.current, null), Ue = st = t, He = 0, $r = null, Ho = Wa = Cn = 0, nt = Ar = null, wn !== null) {
      for (t = 0; t < wn.length; t++) if (n = wn[t], r = n.interleaved, r !== null) {
        n.interleaved = null;
        var a = r.next, l = n.pending;
        if (l !== null) {
          var o = l.next;
          l.next = a, r.next = o;
        }
        n.pending = r;
      }
      wn = null;
    }
    return e;
  }
  function Au(e, t) {
    do {
      var n = Oe;
      try {
        if (oo(), Pa.current = Ta, ja) {
          for (var r = je.memoizedState; r !== null; ) {
            var a = r.queue;
            a !== null && (a.pending = null), r = r.next;
          }
          ja = !1;
        }
        if (kn = 0, $e = Ve = je = null, Rr = !1, Tr = 0, Vo.current = null, n === null || n.return === null) {
          He = 1, $r = t, Oe = null;
          break;
        }
        e: {
          var l = e, o = n.return, c = n, d = t;
          if (t = Ue, c.flags |= 32768, d !== null && typeof d == "object" && typeof d.then == "function") {
            var b = d, I = c, T = I.tag;
            if (!(I.mode & 1) && (T === 0 || T === 11 || T === 15)) {
              var P = I.alternate;
              P ? (I.updateQueue = P.updateQueue, I.memoizedState = P.memoizedState, I.lanes = P.lanes) : (I.updateQueue = null, I.memoizedState = null);
            }
            var J = du(o);
            if (J !== null) {
              J.flags &= -257, fu(J, o, c, l, t), J.mode & 1 && cu(l, b, t), t = J, d = b;
              var te = t.updateQueue;
              if (te === null) {
                var re = /* @__PURE__ */ new Set();
                re.add(d), t.updateQueue = re;
              } else te.add(d);
              break e;
            } else {
              if (!(t & 1)) {
                cu(l, b, t), Zo();
                break e;
              }
              d = Error(s(426));
            }
          } else if (Le && c.mode & 1) {
            var Te = du(o);
            if (Te !== null) {
              !(Te.flags & 65536) && (Te.flags |= 256), fu(Te, o, c, l, t), ao(Gn(d, c));
              break e;
            }
          }
          l = d = Gn(d, c), He !== 4 && (He = 2), Ar === null ? Ar = [l] : Ar.push(l), l = o;
          do {
            switch (l.tag) {
              case 3:
                l.flags |= 65536, t &= -t, l.lanes |= t;
                var g = su(l, d, t);
                Ts(l, g);
                break e;
              case 1:
                c = d;
                var f = l.type, v = l.stateNode;
                if (!(l.flags & 128) && (typeof f.getDerivedStateFromError == "function" || v !== null && typeof v.componentDidCatch == "function" && (ln === null || !ln.has(v)))) {
                  l.flags |= 65536, t &= -t, l.lanes |= t;
                  var A = uu(l, c, t);
                  Ts(l, A);
                  break e;
                }
            }
            l = l.return;
          } while (l !== null);
        }
        Du(n);
      } catch (le) {
        t = le, Oe === n && n !== null && (Oe = n = n.return);
        continue;
      }
      break;
    } while (!0);
  }
  function Wu() {
    var e = Aa.current;
    return Aa.current = Ta, e === null ? Ta : e;
  }
  function Zo() {
    (He === 0 || He === 3 || He === 2) && (He = 4), Ae === null || !(Cn & 268435455) && !(Wa & 268435455) || un(Ae, Ue);
  }
  function Qa(e, t) {
    var n = xe;
    xe |= 2;
    var r = Wu();
    (Ae !== e || Ue !== t) && (Wt = null, En(e, t));
    do
      try {
        Sf();
        break;
      } catch (a) {
        Au(e, a);
      }
    while (!0);
    if (oo(), xe = n, Aa.current = r, Oe !== null) throw Error(s(261));
    return Ae = null, Ue = 0, He;
  }
  function Sf() {
    for (; Oe !== null; ) Bu(Oe);
  }
  function Ef() {
    for (; Oe !== null && !Xc(); ) Bu(Oe);
  }
  function Bu(e) {
    var t = Zu(e.alternate, e, st);
    e.memoizedProps = e.pendingProps, t === null ? Du(e) : Oe = t, Vo.current = null;
  }
  function Du(e) {
    var t = e;
    do {
      var n = t.alternate;
      if (e = t.return, t.flags & 32768) {
        if (n = bf(n, t), n !== null) {
          n.flags &= 32767, Oe = n;
          return;
        }
        if (e !== null) e.flags |= 32768, e.subtreeFlags = 0, e.deletions = null;
        else {
          He = 6, Oe = null;
          return;
        }
      } else if (n = vf(n, t, st), n !== null) {
        Oe = n;
        return;
      }
      if (t = t.sibling, t !== null) {
        Oe = t;
        return;
      }
      Oe = t = e;
    } while (t !== null);
    He === 0 && (He = 5);
  }
  function Nn(e, t, n) {
    var r = Se, a = mt.transition;
    try {
      mt.transition = null, Se = 1, Nf(e, t, n, r);
    } finally {
      mt.transition = a, Se = r;
    }
    return null;
  }
  function Nf(e, t, n, r) {
    do
      rr();
    while (on !== null);
    if (xe & 6) throw Error(s(327));
    n = e.finishedWork;
    var a = e.finishedLanes;
    if (n === null) return null;
    if (e.finishedWork = null, e.finishedLanes = 0, n === e.current) throw Error(s(177));
    e.callbackNode = null, e.callbackPriority = 0;
    var l = n.lanes | n.childLanes;
    if (ld(e, l), e === Ae && (Oe = Ae = null, Ue = 0), !(n.subtreeFlags & 2064) && !(n.flags & 2064) || Da || (Da = !0, Qu(Jr, function() {
      return rr(), null;
    })), l = (n.flags & 15990) !== 0, n.subtreeFlags & 15990 || l) {
      l = mt.transition, mt.transition = null;
      var o = Se;
      Se = 1;
      var c = xe;
      xe |= 4, Vo.current = null, wf(e, n), Ru(n, e), Ud(Zl), la = !!Yl, Zl = Yl = null, e.current = n, xf(n), Kc(), xe = c, Se = o, mt.transition = l;
    } else e.current = n;
    if (Da && (Da = !1, on = e, Ua = a), l = e.pendingLanes, l === 0 && (ln = null), Gc(n.stateNode), rt(e, Re()), t !== null) for (r = e.onRecoverableError, n = 0; n < t.length; n++) a = t[n], r(a.value, { componentStack: a.stack, digest: a.digest });
    if (Ba) throw Ba = !1, e = Ao, Ao = null, e;
    return Ua & 1 && e.tag !== 0 && rr(), l = e.pendingLanes, l & 1 ? e === Wo ? Wr++ : (Wr = 0, Wo = e) : Wr = 0, tn(), null;
  }
  function rr() {
    if (on !== null) {
      var e = Pi(Ua), t = mt.transition, n = Se;
      try {
        if (mt.transition = null, Se = 16 > e ? 16 : e, on === null) var r = !1;
        else {
          if (e = on, on = null, Ua = 0, xe & 6) throw Error(s(331));
          var a = xe;
          for (xe |= 4, G = e.current; G !== null; ) {
            var l = G, o = l.child;
            if (G.flags & 16) {
              var c = l.deletions;
              if (c !== null) {
                for (var d = 0; d < c.length; d++) {
                  var b = c[d];
                  for (G = b; G !== null; ) {
                    var I = G;
                    switch (I.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Hr(8, I, l);
                    }
                    var T = I.child;
                    if (T !== null) T.return = I, G = T;
                    else for (; G !== null; ) {
                      I = G;
                      var P = I.sibling, J = I.return;
                      if (zu(I), I === b) {
                        G = null;
                        break;
                      }
                      if (P !== null) {
                        P.return = J, G = P;
                        break;
                      }
                      G = J;
                    }
                  }
                }
                var te = l.alternate;
                if (te !== null) {
                  var re = te.child;
                  if (re !== null) {
                    te.child = null;
                    do {
                      var Te = re.sibling;
                      re.sibling = null, re = Te;
                    } while (re !== null);
                  }
                }
                G = l;
              }
            }
            if (l.subtreeFlags & 2064 && o !== null) o.return = l, G = o;
            else e: for (; G !== null; ) {
              if (l = G, l.flags & 2048) switch (l.tag) {
                case 0:
                case 11:
                case 15:
                  Hr(9, l, l.return);
              }
              var g = l.sibling;
              if (g !== null) {
                g.return = l.return, G = g;
                break e;
              }
              G = l.return;
            }
          }
          var f = e.current;
          for (G = f; G !== null; ) {
            o = G;
            var v = o.child;
            if (o.subtreeFlags & 2064 && v !== null) v.return = o, G = v;
            else e: for (o = f; G !== null; ) {
              if (c = G, c.flags & 2048) try {
                switch (c.tag) {
                  case 0:
                  case 11:
                  case 15:
                    $a(9, c);
                }
              } catch (le) {
                Ie(c, c.return, le);
              }
              if (c === o) {
                G = null;
                break e;
              }
              var A = c.sibling;
              if (A !== null) {
                A.return = c.return, G = A;
                break e;
              }
              G = c.return;
            }
          }
          if (xe = a, tn(), _t && typeof _t.onPostCommitFiberRoot == "function") try {
            _t.onPostCommitFiberRoot(Gr, e);
          } catch {
          }
          r = !0;
        }
        return r;
      } finally {
        Se = n, mt.transition = t;
      }
    }
    return !1;
  }
  function Uu(e, t, n) {
    t = Gn(n, t), t = su(e, t, 1), e = rn(e, t, 1), t = Je(), e !== null && (fr(e, 1, t), rt(e, t));
  }
  function Ie(e, t, n) {
    if (e.tag === 3) Uu(e, e, n);
    else for (; t !== null; ) {
      if (t.tag === 3) {
        Uu(t, e, n);
        break;
      } else if (t.tag === 1) {
        var r = t.stateNode;
        if (typeof t.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && (ln === null || !ln.has(r))) {
          e = Gn(n, e), e = uu(t, e, 1), t = rn(t, e, 1), e = Je(), t !== null && (fr(t, 1, e), rt(t, e));
          break;
        }
      }
      t = t.return;
    }
  }
  function _f(e, t, n) {
    var r = e.pingCache;
    r !== null && r.delete(t), t = Je(), e.pingedLanes |= e.suspendedLanes & n, Ae === e && (Ue & n) === n && (He === 4 || He === 3 && (Ue & 130023424) === Ue && 500 > Re() - $o ? En(e, 0) : Ho |= n), rt(e, t);
  }
  function Yu(e, t) {
    t === 0 && (e.mode & 1 ? (t = ta, ta <<= 1, !(ta & 130023424) && (ta = 4194304)) : t = 1);
    var n = Je();
    e = Ht(e, t), e !== null && (fr(e, t, n), rt(e, n));
  }
  function Lf(e) {
    var t = e.memoizedState, n = 0;
    t !== null && (n = t.retryLane), Yu(e, n);
  }
  function zf(e, t) {
    var n = 0;
    switch (e.tag) {
      case 13:
        var r = e.stateNode, a = e.memoizedState;
        a !== null && (n = a.retryLane);
        break;
      case 19:
        r = e.stateNode;
        break;
      default:
        throw Error(s(314));
    }
    r !== null && r.delete(t), Yu(e, n);
  }
  var Zu;
  Zu = function(e, t, n) {
    if (e !== null) if (e.memoizedProps !== t.pendingProps || Ge.current) tt = !0;
    else {
      if (!(e.lanes & n) && !(t.flags & 128)) return tt = !1, gf(e, t, n);
      tt = !!(e.flags & 131072);
    }
    else tt = !1, Le && t.flags & 1048576 && Es(t, Ca, t.index);
    switch (t.lanes = 0, t.tag) {
      case 2:
        var r = t.type;
        Va(e, t), e = t.pendingProps;
        var a = Un(t, Ze.current);
        qn(t, n), a = bo(null, t, r, e, a, n);
        var l = yo();
        return t.flags |= 1, typeof a == "object" && a !== null && typeof a.render == "function" && a.$$typeof === void 0 ? (t.tag = 1, t.memoizedState = null, t.updateQueue = null, et(r) ? (l = !0, wa(t)) : l = !1, t.memoizedState = a.state !== null && a.state !== void 0 ? a.state : null, co(t), a.updater = Oa, t.stateNode = a, a._reactInternals = t, Eo(t, r, e, n), t = zo(null, t, r, !0, l, n)) : (t.tag = 0, Le && l && eo(t), qe(null, t, a, n), t = t.child), t;
      case 16:
        r = t.elementType;
        e: {
          switch (Va(e, t), e = t.pendingProps, a = r._init, r = a(r._payload), t.type = r, a = t.tag = Pf(r), e = wt(r, e), a) {
            case 0:
              t = Lo(null, t, r, e, n);
              break e;
            case 1:
              t = bu(null, t, r, e, n);
              break e;
            case 11:
              t = pu(null, t, r, e, n);
              break e;
            case 14:
              t = mu(null, t, r, wt(r.type, e), n);
              break e;
          }
          throw Error(s(
            306,
            r,
            ""
          ));
        }
        return t;
      case 0:
        return r = t.type, a = t.pendingProps, a = t.elementType === r ? a : wt(r, a), Lo(e, t, r, a, n);
      case 1:
        return r = t.type, a = t.pendingProps, a = t.elementType === r ? a : wt(r, a), bu(e, t, r, a, n);
      case 3:
        e: {
          if (yu(t), e === null) throw Error(s(387));
          r = t.pendingProps, l = t.memoizedState, a = l.element, Rs(e, t), za(t, r, null, n);
          var o = t.memoizedState;
          if (r = o.element, l.isDehydrated) if (l = { element: r, isDehydrated: !1, cache: o.cache, pendingSuspenseBoundaries: o.pendingSuspenseBoundaries, transitions: o.transitions }, t.updateQueue.baseState = l, t.memoizedState = l, t.flags & 256) {
            a = Gn(Error(s(423)), t), t = wu(e, t, r, n, a);
            break e;
          } else if (r !== a) {
            a = Gn(Error(s(424)), t), t = wu(e, t, r, n, a);
            break e;
          } else for (it = Jt(t.stateNode.containerInfo.firstChild), ot = t, Le = !0, yt = null, n = js(t, null, r, n), t.child = n; n; ) n.flags = n.flags & -3 | 4096, n = n.sibling;
          else {
            if (Qn(), r === a) {
              t = At(e, t, n);
              break e;
            }
            qe(e, t, r, n);
          }
          t = t.child;
        }
        return t;
      case 5:
        return Fs(t), e === null && ro(t), r = t.type, a = t.pendingProps, l = e !== null ? e.memoizedProps : null, o = a.children, Ql(r, a) ? o = null : l !== null && Ql(r, l) && (t.flags |= 32), vu(e, t), qe(e, t, o, n), t.child;
      case 6:
        return e === null && ro(t), null;
      case 13:
        return xu(e, t, n);
      case 4:
        return fo(t, t.stateNode.containerInfo), r = t.pendingProps, e === null ? t.child = Xn(t, null, r, n) : qe(e, t, r, n), t.child;
      case 11:
        return r = t.type, a = t.pendingProps, a = t.elementType === r ? a : wt(r, a), pu(e, t, r, a, n);
      case 7:
        return qe(e, t, t.pendingProps, n), t.child;
      case 8:
        return qe(e, t, t.pendingProps.children, n), t.child;
      case 12:
        return qe(e, t, t.pendingProps.children, n), t.child;
      case 10:
        e: {
          if (r = t.type._context, a = t.pendingProps, l = t.memoizedProps, o = a.value, Ee(Na, r._currentValue), r._currentValue = o, l !== null) if (bt(l.value, o)) {
            if (l.children === a.children && !Ge.current) {
              t = At(e, t, n);
              break e;
            }
          } else for (l = t.child, l !== null && (l.return = t); l !== null; ) {
            var c = l.dependencies;
            if (c !== null) {
              o = l.child;
              for (var d = c.firstContext; d !== null; ) {
                if (d.context === r) {
                  if (l.tag === 1) {
                    d = $t(-1, n & -n), d.tag = 2;
                    var b = l.updateQueue;
                    if (b !== null) {
                      b = b.shared;
                      var I = b.pending;
                      I === null ? d.next = d : (d.next = I.next, I.next = d), b.pending = d;
                    }
                  }
                  l.lanes |= n, d = l.alternate, d !== null && (d.lanes |= n), so(
                    l.return,
                    n,
                    t
                  ), c.lanes |= n;
                  break;
                }
                d = d.next;
              }
            } else if (l.tag === 10) o = l.type === t.type ? null : l.child;
            else if (l.tag === 18) {
              if (o = l.return, o === null) throw Error(s(341));
              o.lanes |= n, c = o.alternate, c !== null && (c.lanes |= n), so(o, n, t), o = l.sibling;
            } else o = l.child;
            if (o !== null) o.return = l;
            else for (o = l; o !== null; ) {
              if (o === t) {
                o = null;
                break;
              }
              if (l = o.sibling, l !== null) {
                l.return = o.return, o = l;
                break;
              }
              o = o.return;
            }
            l = o;
          }
          qe(e, t, a.children, n), t = t.child;
        }
        return t;
      case 9:
        return a = t.type, r = t.pendingProps.children, qn(t, n), a = ft(a), r = r(a), t.flags |= 1, qe(e, t, r, n), t.child;
      case 14:
        return r = t.type, a = wt(r, t.pendingProps), a = wt(r.type, a), mu(e, t, r, a, n);
      case 15:
        return hu(e, t, t.type, t.pendingProps, n);
      case 17:
        return r = t.type, a = t.pendingProps, a = t.elementType === r ? a : wt(r, a), Va(e, t), t.tag = 1, et(r) ? (e = !0, wa(t)) : e = !1, qn(t, n), ou(t, r, a), Eo(t, r, a, n), zo(null, t, r, !0, e, n);
      case 19:
        return Cu(e, t, n);
      case 22:
        return gu(e, t, n);
    }
    throw Error(s(156, t.tag));
  };
  function Qu(e, t) {
    return Ni(e, t);
  }
  function Mf(e, t, n, r) {
    this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function ht(e, t, n, r) {
    return new Mf(e, t, n, r);
  }
  function Qo(e) {
    return e = e.prototype, !(!e || !e.isReactComponent);
  }
  function Pf(e) {
    if (typeof e == "function") return Qo(e) ? 1 : 0;
    if (e != null) {
      if (e = e.$$typeof, e === ae) return 11;
      if (e === D) return 14;
    }
    return 2;
  }
  function cn(e, t) {
    var n = e.alternate;
    return n === null ? (n = ht(e.tag, t, e.key, e.mode), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = e.flags & 14680064, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n;
  }
  function Xa(e, t, n, r, a, l) {
    var o = 2;
    if (r = e, typeof e == "function") Qo(e) && (o = 1);
    else if (typeof e == "string") o = 5;
    else e: switch (e) {
      case q:
        return _n(n.children, a, l, t);
      case fe:
        o = 8, a |= 8;
        break;
      case de:
        return e = ht(12, n, t, a | 2), e.elementType = de, e.lanes = l, e;
      case ne:
        return e = ht(13, n, t, a), e.elementType = ne, e.lanes = l, e;
      case se:
        return e = ht(19, n, t, a), e.elementType = se, e.lanes = l, e;
      case B:
        return Ka(n, a, l, t);
      default:
        if (typeof e == "object" && e !== null) switch (e.$$typeof) {
          case K:
            o = 10;
            break e;
          case ee:
            o = 9;
            break e;
          case ae:
            o = 11;
            break e;
          case D:
            o = 14;
            break e;
          case S:
            o = 16, r = null;
            break e;
        }
        throw Error(s(130, e == null ? e : typeof e, ""));
    }
    return t = ht(o, n, t, a), t.elementType = e, t.type = r, t.lanes = l, t;
  }
  function _n(e, t, n, r) {
    return e = ht(7, e, r, t), e.lanes = n, e;
  }
  function Ka(e, t, n, r) {
    return e = ht(22, e, r, t), e.elementType = B, e.lanes = n, e.stateNode = { isHidden: !1 }, e;
  }
  function Xo(e, t, n) {
    return e = ht(6, e, null, t), e.lanes = n, e;
  }
  function Ko(e, t, n) {
    return t = ht(4, e.children !== null ? e.children : [], e.key, t), t.lanes = n, t.stateNode = { containerInfo: e.containerInfo, pendingChildren: null, implementation: e.implementation }, t;
  }
  function jf(e, t, n, r, a) {
    this.tag = t, this.containerInfo = e, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Cl(0), this.expirationTimes = Cl(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Cl(0), this.identifierPrefix = r, this.onRecoverableError = a, this.mutableSourceEagerHydrationData = null;
  }
  function qo(e, t, n, r, a, l, o, c, d) {
    return e = new jf(e, t, n, c, d), t === 1 ? (t = 1, l === !0 && (t |= 8)) : t = 0, l = ht(3, null, null, t), e.current = l, l.stateNode = e, l.memoizedState = { element: r, isDehydrated: n, cache: null, transitions: null, pendingSuspenseBoundaries: null }, co(l), e;
  }
  function If(e, t, n) {
    var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: Y, key: r == null ? null : "" + r, children: e, containerInfo: t, implementation: n };
  }
  function Xu(e) {
    if (!e) return en;
    e = e._reactInternals;
    e: {
      if (hn(e) !== e || e.tag !== 1) throw Error(s(170));
      var t = e;
      do {
        switch (t.tag) {
          case 3:
            t = t.stateNode.context;
            break e;
          case 1:
            if (et(t.type)) {
              t = t.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        t = t.return;
      } while (t !== null);
      throw Error(s(171));
    }
    if (e.tag === 1) {
      var n = e.type;
      if (et(n)) return ks(e, n, t);
    }
    return t;
  }
  function Ku(e, t, n, r, a, l, o, c, d) {
    return e = qo(n, r, !0, e, a, l, o, c, d), e.context = Xu(null), n = e.current, r = Je(), a = sn(n), l = $t(r, a), l.callback = t ?? null, rn(n, l, a), e.current.lanes = a, fr(e, a, r), rt(e, r), e;
  }
  function qa(e, t, n, r) {
    var a = t.current, l = Je(), o = sn(a);
    return n = Xu(n), t.context === null ? t.context = n : t.pendingContext = n, t = $t(l, o), t.payload = { element: e }, r = r === void 0 ? null : r, r !== null && (t.callback = r), e = rn(a, t, o), e !== null && (Ct(e, a, o, l), La(e, a, o)), o;
  }
  function Ja(e) {
    if (e = e.current, !e.child) return null;
    switch (e.child.tag) {
      case 5:
        return e.child.stateNode;
      default:
        return e.child.stateNode;
    }
  }
  function qu(e, t) {
    if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
      var n = e.retryLane;
      e.retryLane = n !== 0 && n < t ? n : t;
    }
  }
  function Jo(e, t) {
    qu(e, t), (e = e.alternate) && qu(e, t);
  }
  function Rf() {
    return null;
  }
  var Ju = typeof reportError == "function" ? reportError : function(e) {
    console.error(e);
  };
  function Go(e) {
    this._internalRoot = e;
  }
  Ga.prototype.render = Go.prototype.render = function(e) {
    var t = this._internalRoot;
    if (t === null) throw Error(s(409));
    qa(e, t, null, null);
  }, Ga.prototype.unmount = Go.prototype.unmount = function() {
    var e = this._internalRoot;
    if (e !== null) {
      this._internalRoot = null;
      var t = e.containerInfo;
      Sn(function() {
        qa(null, e, null, null);
      }), t[Tt] = null;
    }
  };
  function Ga(e) {
    this._internalRoot = e;
  }
  Ga.prototype.unstable_scheduleHydration = function(e) {
    if (e) {
      var t = Ri();
      e = { blockedOn: null, target: e, priority: t };
      for (var n = 0; n < Xt.length && t !== 0 && t < Xt[n].priority; n++) ;
      Xt.splice(n, 0, e), n === 0 && Fi(e);
    }
  };
  function ei(e) {
    return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
  }
  function el(e) {
    return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11 && (e.nodeType !== 8 || e.nodeValue !== " react-mount-point-unstable "));
  }
  function Gu() {
  }
  function Tf(e, t, n, r, a) {
    if (a) {
      if (typeof r == "function") {
        var l = r;
        r = function() {
          var b = Ja(o);
          l.call(b);
        };
      }
      var o = Ku(t, r, e, 0, null, !1, !1, "", Gu);
      return e._reactRootContainer = o, e[Tt] = o.current, Nr(e.nodeType === 8 ? e.parentNode : e), Sn(), o;
    }
    for (; a = e.lastChild; ) e.removeChild(a);
    if (typeof r == "function") {
      var c = r;
      r = function() {
        var b = Ja(d);
        c.call(b);
      };
    }
    var d = qo(e, 0, !1, null, null, !1, !1, "", Gu);
    return e._reactRootContainer = d, e[Tt] = d.current, Nr(e.nodeType === 8 ? e.parentNode : e), Sn(function() {
      qa(t, d, n, r);
    }), d;
  }
  function tl(e, t, n, r, a) {
    var l = n._reactRootContainer;
    if (l) {
      var o = l;
      if (typeof a == "function") {
        var c = a;
        a = function() {
          var d = Ja(o);
          c.call(d);
        };
      }
      qa(t, o, e, a);
    } else o = Tf(n, t, e, a, r);
    return Ja(o);
  }
  ji = function(e) {
    switch (e.tag) {
      case 3:
        var t = e.stateNode;
        if (t.current.memoizedState.isDehydrated) {
          var n = dr(t.pendingLanes);
          n !== 0 && (Sl(t, n | 1), rt(t, Re()), !(xe & 6) && (nr = Re() + 500, tn()));
        }
        break;
      case 13:
        Sn(function() {
          var r = Ht(e, 1);
          if (r !== null) {
            var a = Je();
            Ct(r, e, 1, a);
          }
        }), Jo(e, 1);
    }
  }, El = function(e) {
    if (e.tag === 13) {
      var t = Ht(e, 134217728);
      if (t !== null) {
        var n = Je();
        Ct(t, e, 134217728, n);
      }
      Jo(e, 134217728);
    }
  }, Ii = function(e) {
    if (e.tag === 13) {
      var t = sn(e), n = Ht(e, t);
      if (n !== null) {
        var r = Je();
        Ct(n, e, t, r);
      }
      Jo(e, t);
    }
  }, Ri = function() {
    return Se;
  }, Ti = function(e, t) {
    var n = Se;
    try {
      return Se = e, t();
    } finally {
      Se = n;
    }
  }, vl = function(e, t, n) {
    switch (t) {
      case "input":
        if (Et(e, n), t = n.name, n.type === "radio" && t != null) {
          for (n = e; n.parentNode; ) n = n.parentNode;
          for (n = n.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < n.length; t++) {
            var r = n[t];
            if (r !== e && r.form === e.form) {
              var a = ba(r);
              if (!a) throw Error(s(90));
              jt(r), Et(r, a);
            }
          }
        }
        break;
      case "textarea":
        Rt(e, n);
        break;
      case "select":
        t = n.value, t != null && Nt(e, !!n.multiple, t, !1);
    }
  }, yi = Uo, wi = Sn;
  var Of = { usingClientEntryPoint: !1, Events: [zr, Bn, ba, vi, bi, Uo] }, Br = { findFiberByHostInstance: gn, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, Ff = { bundleType: Br.bundleType, version: Br.version, rendererPackageName: Br.rendererPackageName, rendererConfig: Br.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: j.ReactCurrentDispatcher, findHostInstanceByFiber: function(e) {
    return e = Si(e), e === null ? null : e.stateNode;
  }, findFiberByHostInstance: Br.findFiberByHostInstance || Rf, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var nl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!nl.isDisabled && nl.supportsFiber) try {
      Gr = nl.inject(Ff), _t = nl;
    } catch {
    }
  }
  return at.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Of, at.createPortal = function(e, t) {
    var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!ei(t)) throw Error(s(200));
    return If(e, t, null, n);
  }, at.createRoot = function(e, t) {
    if (!ei(e)) throw Error(s(299));
    var n = !1, r = "", a = Ju;
    return t != null && (t.unstable_strictMode === !0 && (n = !0), t.identifierPrefix !== void 0 && (r = t.identifierPrefix), t.onRecoverableError !== void 0 && (a = t.onRecoverableError)), t = qo(e, 1, !1, null, null, n, !1, r, a), e[Tt] = t.current, Nr(e.nodeType === 8 ? e.parentNode : e), new Go(t);
  }, at.findDOMNode = function(e) {
    if (e == null) return null;
    if (e.nodeType === 1) return e;
    var t = e._reactInternals;
    if (t === void 0)
      throw typeof e.render == "function" ? Error(s(188)) : (e = Object.keys(e).join(","), Error(s(268, e)));
    return e = Si(t), e = e === null ? null : e.stateNode, e;
  }, at.flushSync = function(e) {
    return Sn(e);
  }, at.hydrate = function(e, t, n) {
    if (!el(t)) throw Error(s(200));
    return tl(null, e, t, !0, n);
  }, at.hydrateRoot = function(e, t, n) {
    if (!ei(e)) throw Error(s(405));
    var r = n != null && n.hydratedSources || null, a = !1, l = "", o = Ju;
    if (n != null && (n.unstable_strictMode === !0 && (a = !0), n.identifierPrefix !== void 0 && (l = n.identifierPrefix), n.onRecoverableError !== void 0 && (o = n.onRecoverableError)), t = Ku(t, null, e, 1, n ?? null, a, !1, l, o), e[Tt] = t.current, Nr(e), r) for (e = 0; e < r.length; e++) n = r[e], a = n._getVersion, a = a(n._source), t.mutableSourceEagerHydrationData == null ? t.mutableSourceEagerHydrationData = [n, a] : t.mutableSourceEagerHydrationData.push(
      n,
      a
    );
    return new Ga(t);
  }, at.render = function(e, t, n) {
    if (!el(t)) throw Error(s(200));
    return tl(null, e, t, !1, n);
  }, at.unmountComponentAtNode = function(e) {
    if (!el(e)) throw Error(s(40));
    return e._reactRootContainer ? (Sn(function() {
      tl(null, null, e, !1, function() {
        e._reactRootContainer = null, e[Tt] = null;
      });
    }), !0) : !1;
  }, at.unstable_batchedUpdates = Uo, at.unstable_renderSubtreeIntoContainer = function(e, t, n, r) {
    if (!el(n)) throw Error(s(200));
    if (e == null || e._reactInternals === void 0) throw Error(s(38));
    return tl(e, t, n, !1, r);
  }, at.version = "18.3.1-next-f1338f8080-20240426", at;
}
function kc() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(kc);
    } catch (i) {
      console.error(i);
    }
}
kc(), xc.exports = vp();
var bp = xc.exports, Cc, oc = bp;
Cc = oc.createRoot, oc.hydrateRoot;
var Sc = { exports: {} }, Dr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ic;
function yp() {
  if (ic) return Dr;
  ic = 1;
  var i = dl, m = Symbol.for("react.element"), s = Symbol.for("react.fragment"), y = Object.prototype.hasOwnProperty, C = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, _ = { key: !0, ref: !0, __self: !0, __source: !0 };
  function O(M, E, U) {
    var R, L = {}, V = null, W = null;
    U !== void 0 && (V = "" + U), E.key !== void 0 && (V = "" + E.key), E.ref !== void 0 && (W = E.ref);
    for (R in E) y.call(E, R) && !_.hasOwnProperty(R) && (L[R] = E[R]);
    if (M && M.defaultProps) for (R in E = M.defaultProps, E) L[R] === void 0 && (L[R] = E[R]);
    return { $$typeof: m, type: M, key: V, ref: W, props: L, _owner: C.current };
  }
  return Dr.Fragment = s, Dr.jsx = O, Dr.jsxs = O, Dr;
}
Sc.exports = yp();
var u = Sc.exports;
async function wp(i) {
  const m = await fetch(i);
  if (!m.ok)
    throw new Error(`Failed to fetch composition: ${m.statusText}`);
  return await m.json();
}
const ti = /* @__PURE__ */ new Map(), xp = (i) => {
  const [m, s] = h.useState({
    status: "pending",
    isSuccess: !1
  });
  return h.useEffect(() => {
    const y = (_) => s({ status: "success", data: _, isSuccess: !0 }), C = ti.get(i);
    if (C && !(C instanceof Promise)) {
      y(C);
      return;
    }
    s({
      status: "fetching",
      isSuccess: !1
    }), async function() {
      try {
        let _;
        if (C)
          _ = await C;
        else {
          const O = wp(i);
          ti.set(i, O), _ = await O, ti.set(i, _);
        }
        y(_);
      } catch (_) {
        s({
          status: "error",
          isSuccess: !1,
          error: _
        });
      }
    }();
  }, [i]), m;
}, Ec = h.createContext(null), St = () => {
  const i = h.useContext(Ec);
  if (!i)
    throw new Error(
      "useGlobalContext must be used within a GlobalContextProvider"
    );
  return i;
}, kp = ({ children: i, ...m }) => /* @__PURE__ */ u.jsx(Ec.Provider, { value: m, children: i }), Nc = h.createContext(null), pn = () => {
  const i = h.useContext(Nc);
  if (!i)
    throw new Error(
      "useCompositionContext must be used within a CompositionContextProvider"
    );
  return i;
}, Cp = ({ composition: i, children: m }) => {
  const {
    aspectRatio: s,
    categories: y,
    imageHdWidth: C,
    imageSubWidths: _
  } = i, { minMediaWidth: O, maxMediaWidth: M } = St(), E = h.useMemo(
    () => y.flatMap(({ items: L }) => L),
    [y]
  ), U = {
    aspectRatio: s.replace(":", " / ")
  }, R = h.useMemo(() => {
    const L = _.concat(C), V = L.sort((x, N) => x - N), W = V.filter(
      (x) => x >= O && x <= M
    );
    if (W.length === 0) {
      const x = (O + M) / 2, N = L.reduce(
        (z, Z) => Math.abs(Z - x) < Math.abs(z - x) ? Z : z,
        C
      );
      return console.warn(
        `None of available media widths (${V.join("|")}) match the given constraints (${O > 0 ? `${O} ≤ ` : ""}width${M < 1 / 0 ? ` ≤ ${M}` : ""}).`,
        `Using the closest width instead (${N}).`
      ), [N];
    }
    return W;
  }, [_, C, O, M]);
  return /* @__PURE__ */ u.jsx(
    Nc.Provider,
    {
      value: {
        ...i,
        items: E,
        aspectRatioStyle: U,
        usedMediaWidths: R
      },
      children: m
    }
  );
}, _c = 500, ai = 0.75, ul = 1 + ai * 2;
function zn(i, m, s) {
  return Math.min(Math.max(i, m), s);
}
const il = (i, m, s) => i + (m - i) * s, sc = (i, m) => (i % m + m) % m, Lc = h.createContext(null), ci = () => h.useContext(Lc), Zr = () => {
  const i = ci();
  if (!i)
    throw new Error(
      "useCustomizationContext must be used within a CustomizationContextProvider"
    );
  return i;
}, uc = "*:size-full", cc = "*:object-cover *:size-full", Sp = ({ children: i }) => {
  const { compositionUrl: m } = St(), s = h.useCallback(
    () => document.querySelector(
      `${cl}[composition-url="${m}"]`
    ),
    [m]
  ), y = h.useCallback((x) => {
    const N = x.querySelectorAll(ui), z = /* @__PURE__ */ new Map();
    for (const Z of N) {
      const X = Z.getAttribute("name");
      if (!X) {
        console.warn("Icon element is missing a name attribute");
        continue;
      }
      const H = Z.innerHTML, j = H ? /* @__PURE__ */ u.jsx(
        "div",
        {
          className: uc,
          dangerouslySetInnerHTML: { __html: H }
        }
      ) : void 0;
      if (!j) {
        console.warn(`Icon "${X}" customization is empty.`);
        continue;
      }
      z.set(X, { Icon: j });
    }
    return z;
  }, []), [C, _] = h.useState(
    () => {
      const x = s();
      return x ? y(x) : /* @__PURE__ */ new Map();
    }
  );
  h.useEffect(() => {
    const x = s();
    if (!x)
      return;
    const N = new MutationObserver(() => {
      _(y(x));
    });
    return N.observe(x, {
      childList: !0,
      subtree: !0
    }), () => N.disconnect();
  }, [y, s]);
  const O = h.useCallback(
    (x) => C.get(x),
    [C]
  ), M = h.useCallback(
    (x, N) => {
      _((z) => {
        const { Icon: Z, ...X } = N;
        return new Map(
          z.set(x, {
            ...X,
            Icon: /* @__PURE__ */ u.jsx("div", { className: uc, children: Z })
          })
        );
      });
    },
    []
  ), E = h.useCallback((x) => {
    _((N) => (N.delete(x), new Map(N)));
  }, []), U = h.useCallback((x) => {
    const N = x.querySelectorAll(
      si
    ), z = new Array();
    for (const Z of N) {
      const X = Z.innerHTML;
      if (!X) {
        console.warn("Custom media element is empty");
        continue;
      }
      const H = Number(Z.getAttribute("index"));
      if (Number.isNaN(H)) {
        console.warn("Custom media element is missing the 'index' attribute");
        continue;
      }
      const j = Z.getAttribute("thumbnail-src") ?? void 0, Q = JSON.stringify({ index: H, thumbnailSrc: j });
      z.push({
        id: Q,
        Media: /* @__PURE__ */ u.jsx(
          "div",
          {
            className: cc,
            dangerouslySetInnerHTML: { __html: X }
          }
        ),
        index: H,
        thumbnailSrc: j
      });
    }
    return z;
  }, []), [R, L] = h.useState(() => {
    const x = s();
    return x ? U(x) : [];
  });
  h.useEffect(() => {
    const x = s();
    if (!x)
      return;
    const N = new MutationObserver(() => {
      L(U(x));
    });
    return N.observe(x, {
      childList: !0,
      subtree: !0
    }), () => N.disconnect();
  }, [U, s]);
  const V = h.useCallback((x) => {
    const { Media: N, ...z } = x, Z = /* @__PURE__ */ u.jsx("div", { className: cc, children: N }), X = JSON.stringify(z);
    return L((H) => [
      ...H,
      {
        id: X,
        Media: Z,
        ...z
      }
    ]), X;
  }, []), W = h.useCallback((x) => {
    L(
      (N) => N.filter((z) => z.id !== x)
    );
  }, []);
  return /* @__PURE__ */ u.jsx(
    Lc.Provider,
    {
      value: {
        getIconConfig: O,
        registerIconConfig: M,
        unregisterIconConfig: E,
        customMediaList: R,
        registerCustomMedia: V,
        unregisterCustomMedia: W
      },
      children: i
    }
  );
}, zc = h.createContext(null), ut = () => {
  const i = h.useContext(zc);
  if (!i)
    throw new Error(
      "useControlsContext must be used within a ControlsContextProvider"
    );
  return i;
}, Ep = ({
  children: i
}) => {
  const {
    infiniteCarrousel: m,
    preventFullScreen: s,
    emitEvent: y,
    isFullScreen: C,
    requestFullscreen: _,
    exitFullscreen: O
  } = St(), { customMediaList: M } = Zr(), { categories: E, items: U } = pn(), R = h.useMemo(() => {
    const he = new Array(
      ...U
    ), Fe = M.slice().sort((ze, Me) => ze.index < 0 && Me.index < 0 ? Me.index - ze.index : ze.index < 0 ? 1 : Me.index < 0 ? -1 : ze.index - Me.index);
    for (const ze of Fe) {
      let Me = ze.index;
      Me < 0 && (Me = he.length + Me + 1), he.splice(Me, 0, {
        type: "custom",
        ...ze
      });
    }
    return he;
  }, [U, M]), [L, V] = h.useState(R.map(() => null));
  h.useEffect(() => {
    V(R.map(() => null));
  }, [R]);
  const W = h.useCallback(
    (he, Fe) => {
      V(
        (ze) => ze.map((Me, fl) => fl === he ? Fe : Me)
      );
    },
    []
  ), [x, N] = h.useState(0), [z, Z] = h.useState(null), X = z ?? x, H = R[X], j = L[X], [Q, Y] = h.useState(
    null
  ), q = !!Q, fe = h.useCallback(() => Y(null), []), de = h.useCallback(() => {
    if (q || z !== null)
      return;
    const he = x - 1;
    he >= 0 ? Z(he) : m && (Y("first_to_last"), Z(R.length - 1));
  }, [
    q,
    z,
    x,
    m,
    R.length
  ]), K = h.useCallback(() => {
    if (q || z !== null)
      return;
    const he = x + 1;
    he < R.length ? Z(he) : m && (Y("last_to_first"), Z(0));
  }, [
    q,
    z,
    x,
    R.length,
    m
  ]), ee = h.useCallback(
    (he) => {
      const Fe = Math.min(x, he), ze = Math.max(x, he);
      L.slice(Fe, ze + 1).filter((Me) => Me === null).length > 2 && Y("instant"), Z(he);
    },
    [x, L]
  );
  h.useEffect(() => {
    y(rp, {
      index: X,
      item: H
    });
  }, [H, y, X]);
  const ae = h.useMemo(() => {
    let he;
    if (H.type === "custom") {
      const Fe = R.slice(0, X).reverse().find((ze) => ze.type !== "custom") ?? R.slice(X + 1).find((ze) => ze.type !== "custom");
      if (!Fe)
        throw new Error("No non-custom item found");
      he = Fe;
    } else
      he = H;
    for (const Fe of E)
      if (Fe.items.includes(he))
        return Fe.id;
    throw new Error("Current item not found in any category");
  }, [E, H, R, X]), ne = h.useCallback(
    (he) => {
      const Fe = E.find(({ id: Me }) => Me === he)?.items[0];
      if (Fe === void 0)
        throw new Error("Failed to find target category");
      const ze = R.findIndex((Me) => Me === Fe);
      ee(ze);
    },
    [E, R, ee]
  ), se = h.useMemo(() => {
    switch (H.type) {
      case "image":
        return !!H.hotspots?.length;
      case "360":
        return j === "running";
      default:
        return !1;
    }
  }, [H, j]), [D, S] = h.useState(!0), B = h.useCallback(() => {
    const he = !D;
    S(he), y(he ? op : ip);
  }, [y, D]), w = h.useMemo(() => {
    switch (H.type) {
      case "video":
        return j !== "running";
      default:
        return !0;
    }
  }, [H, j]), [$, F] = h.useState(!1), p = h.useCallback(() => {
    const he = !$;
    F(he), y(he ? sp : up);
  }, [y, $]), [k, oe] = h.useState(null), ie = h.useCallback(() => oe(null), []), me = !!k, ve = h.useMemo(() => {
    switch (H.type) {
      case "image":
        return !0;
      case "360":
        return j === "running";
      default:
        return !1;
    }
  }, [H.type, j]), [we, ye] = h.useState(1), Ce = we !== 1, Be = we < ul, Bt = we > 1, jt = h.useCallback((he) => {
    ye((Fe) => zn(Fe + he, 1, ul));
  }, []), Dt = h.useCallback(() => ye(1), []), or = h.useCallback(() => jt(ai), [jt]), Qr = h.useCallback(() => jt(-ai), [jt]), Mn = h.useCallback(() => {
    Dt(), ie();
  }, [Dt, ie]), [Et, Xr] = h.useState(!1), [mn, Ut] = h.useState(), [Nt, Pn] = h.useState(!1), It = h.useCallback(
    async (he) => {
      Mn(), Xr(he), y(he ? ap : lp);
    },
    [y, Mn]
  ), Rt = h.useCallback(() => {
    clearTimeout(mn);
    const he = setTimeout(() => {
      Ut(void 0);
    }, _c);
    Ut(he);
  }, [mn]), jn = h.useCallback(async () => {
    if (Rt(), !s) {
      const he = await _();
      if (Pn(!he), he)
        return;
    }
    It(!0);
  }, [
    s,
    It,
    _,
    Rt
  ]), In = h.useCallback(async () => {
    Rt(), !(!s && (Pn(!1), await O())) && It(!1);
  }, [
    s,
    It,
    O,
    Rt
  ]), ir = h.useCallback(() => {
    Et ? In() : jn();
  }, [In, jn, Et]);
  return h.useEffect(() => {
    s || Nt && Et || C !== Et && (Rt(), It(C));
  }, [
    s,
    It,
    Et,
    Nt,
    C,
    Rt
  ]), /* @__PURE__ */ u.jsx(
    zc.Provider,
    {
      value: {
        items: R,
        setItemInteraction: W,
        slidable: R.length > 1,
        carrouselItemIndex: x,
        setCarrouselItemIndex: N,
        itemIndexCommand: z,
        setItemIndexCommand: Z,
        masterItemIndex: X,
        specialCommand: Q,
        isRunningSpecialCommand: q,
        finishSpecialCommand: fe,
        prevItem: de,
        nextItem: K,
        scrollToItemIndex: ee,
        displayedCategoryId: ae,
        changeCategory: ne,
        enableHotspotsControl: se,
        showHotspots: D,
        toggleHotspots: B,
        showGalleryControls: w,
        showGallery: $,
        toggleGallery: p,
        shownDetails: k,
        isShowingDetails: me,
        setShownDetails: oe,
        resetShownDetails: ie,
        showZoomControls: ve,
        zoom: we,
        isZooming: Ce,
        setZoom: ye,
        resetZoom: Dt,
        canZoomIn: Be,
        zoomIn: or,
        canZoomOut: Bt,
        zoomOut: Qr,
        resetView: Mn,
        extendMode: Et,
        enableExtendMode: jn,
        disableExtendMode: In,
        toggleExtendMode: ir,
        extendTransition: !!mn,
        fakeFullScreen: Nt
      },
      children: i
    }
  );
}, Mc = ["left", "center", "right", "fullW"], Pc = ["top", "middle", "bottom", "fullH"], Np = [
  ...Mc,
  ...Pc,
  "top-left",
  "top-center",
  "top-right",
  "top-fullW",
  "middle-left",
  "middle-center",
  "middle-right",
  "middle-fullW",
  "bottom-left",
  "bottom-center",
  "bottom-right",
  "bottom-fullW",
  "fullH-left",
  "fullH-center",
  "fullH-right",
  "fullW-fullW"
];
function _p(i) {
  return Mc.includes(i);
}
function Lp(i) {
  return Pc.includes(i);
}
function zp(i) {
  return Np.includes(i);
}
function Mp(i) {
  if (!zp(i))
    throw new Error(`Invalid position: ${i}`);
  return Lp(i) ? [i, void 0] : _p(i) ? [void 0, i] : i.split("-");
}
function ge(...i) {
  return i.filter((m) => !!m).map((m) => m.trim()).join(" ");
}
function Pp(i) {
  switch (i) {
    case "left":
      return "left-1 small:left-2";
    case "right":
      return "right-1 small:right-2";
    case "center":
      return "left-1/2 -translate-x-1/2";
    case "fullW":
      return "inset-x-1 small:inset-x-2";
  }
}
function jc(i) {
  switch (i) {
    case "top":
      return "top-1 small:top-2";
    case "bottom":
      return "bottom-1 small:bottom-2";
    case "middle":
      return "top-1/2 -translate-y-1/2";
    case "fullH":
      return "inset-y-1 small:inset-y-2";
  }
}
function jp({
  positionX: i,
  positionY: m
}) {
  const s = new Array();
  return i && s.push(Pp(i)), m && s.push(jc(m)), s.join(" ");
}
function ar(i) {
  const [m, s] = Mp(i);
  return jp({ positionX: s, positionY: m });
}
const Ye = ({
  customizationKey: i,
  className: m,
  children: s
}) => {
  const { getIconConfig: y } = Zr(), C = y(i)?.Icon;
  return C ? m ? /* @__PURE__ */ u.jsx("div", { className: m, children: C }) : C : s;
}, Ip = ({ className: i }) => /* @__PURE__ */ u.jsx(Ye, { className: i, customizationKey: "UI_CLOSE", children: /* @__PURE__ */ u.jsx(
  "svg",
  {
    className: i,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ u.jsx(
      "path",
      {
        d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
        fill: "currentColor"
      }
    )
  }
) }), Rp = {
  fill: {
    primary: "bg-primary text-primary-foreground hover:opacity-80",
    neutral: "bg-background text-neutral-foreground hover:opacity-80"
  },
  ghost: {
    primary: "bg-transparent text-foreground hover:bg-primary/25",
    neutral: "bg-transparent text-background hover:bg-foreground/25"
  }
}, Tp = {
  button: "h-8 px-2",
  icon: "size-8 p-2"
}, gt = ({
  variant: i = "fill",
  shape: m = "button",
  color: s = "primary",
  className: y,
  children: C,
  ..._
}) => {
  const O = Rp[i][s], M = Tp[m];
  return /* @__PURE__ */ u.jsx(
    "button",
    {
      className: ge(
        "flex items-center justify-center rounded-ui text-sm transition-all disabled:opacity-60",
        O,
        M,
        y
      ),
      ..._,
      children: C
    }
  );
}, Ic = (i) => /* @__PURE__ */ u.jsx(gt, { color: "neutral", shape: "icon", ...i, children: /* @__PURE__ */ u.jsx(Ip, { className: "size-full" }) }), Rc = ({ text: i, className: m }) => /* @__PURE__ */ u.jsxs(
  "div",
  {
    className: ge(
      "flex size-full flex-col items-center justify-center gap-y-4",
      m
    ),
    children: [
      /* @__PURE__ */ u.jsx(
        "img",
        {
          className: "h-20 small:h-28",
          src: "https://cdn.car-cutter.com/libs/web-player/v3/assets/car_placeholder.png"
        }
      ),
      /* @__PURE__ */ u.jsx("div", { className: "text-2xl font-bold", children: i })
    ]
  }
), Op = {
  primary: "border-primary",
  foreground: "border-foreground",
  background: "border-background"
}, Fp = {
  sm: "size-4 border",
  md: "size-8 border-2",
  lg: "size-12 border-4"
}, Tc = ({
  color: i = "foreground",
  size: m = "md"
}) => {
  const s = Op[i], y = Fp[m];
  return /* @__PURE__ */ u.jsx(
    "div",
    {
      className: ge(
        "inline-block animate-rotation rounded-full border-b-transparent",
        y,
        s
      )
    }
  );
}, lr = ({
  src: i,
  className: m,
  onLoad: s,
  imgInPlayerWidthRatio: y = 1,
  onlyThumbnail: C,
  fadeIn: _,
  ...O
}) => {
  const { mediaLoadStrategy: M, playerInViewportWidthRatio: E } = St(), { imageHdWidth: U, usedMediaWidths: R } = pn(), [L, V] = h.useMemo(() => {
    const N = R.map((Z) => `${Z !== U ? fp(i, Z) : i} ${Z}w`);
    let z;
    if (C)
      z = [`${R[0]}px`];
    else {
      const Z = 1 / (y * E);
      switch (M) {
        case "quality": {
          const X = [...R], H = X.pop();
          z = X.map(
            (j) => `(max-width: ${Z * j}px) ${j}px`
          ), z.push(`${H}px`);
          break;
        }
        case "balanced": {
          z = [];
          for (let X = 0; X < R.length - 1; X++) {
            const H = R[X], j = R[X + 1], Q = Math.round((H + j) / 2);
            z.push(
              `(max-width: ${Z * Q}px) ${H}px`
            );
          }
          z.push(`${R[R.length - 1]}px`);
          break;
        }
        case "speed": {
          const X = [...R], H = X.shift();
          z = X.reverse().map(
            (j) => `(min-width: ${Z * j}px) ${j}px`
          ), z.push(`${H}px`);
          break;
        }
      }
    }
    return [N.join(", "), z.join(", ")];
  }, [
    U,
    y,
    M,
    C,
    E,
    i,
    R
  ]), [W, x] = h.useState();
  return h.useEffect(() => {
    if (W === !0)
      return;
    const N = setTimeout(() => {
      x((z) => z ?? !1);
    }, 30);
    return () => clearTimeout(N);
  }, [W]), /* @__PURE__ */ u.jsx(
    "img",
    {
      src: i,
      srcSet: L,
      sizes: V,
      className: ge(
        m,
        _ && ge(
          W !== void 0 && "transition-opacity duration-200",
          W === !1 && "opacity-0",
          W === !0 && "opacity-100"
        )
      ),
      onLoad: (N) => {
        x(!0), s?.(N);
      },
      ...O
    }
  );
}, Oc = ({ className: i }) => /* @__PURE__ */ u.jsx(Ye, { className: i, customizationKey: "UI_IMAGE", children: /* @__PURE__ */ u.jsx("svg", { className: i, viewBox: "0 0 12 12", fill: "none", children: /* @__PURE__ */ u.jsx(
  "path",
  {
    d: "M9.5 2.5V9.5H2.5V2.5H9.5ZM9.5 1.5H2.5C1.95 1.5 1.5 1.95 1.5 2.5V9.5C1.5 10.05 1.95 10.5 2.5 10.5H9.5C10.05 10.5 10.5 10.05 10.5 9.5V2.5C10.5 1.95 10.05 1.5 9.5 1.5ZM7.07 5.93L5.57 7.865L4.5 6.57L3 8.5H9L7.07 5.93Z",
    fill: "currentColor"
  }
) }) }), di = ({ className: i }) => /* @__PURE__ */ u.jsx(Ye, { className: i, customizationKey: "UI_PLAY", children: /* @__PURE__ */ u.jsx(
  "svg",
  {
    className: i,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: /* @__PURE__ */ u.jsx("polygon", { points: "6 3 20 12 6 21 6 3" })
  }
) }), Fc = ({ className: i }) => /* @__PURE__ */ u.jsx(Ye, { className: i, customizationKey: "UI_360", children: /* @__PURE__ */ u.jsxs(
  "svg",
  {
    className: i,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ u.jsxs("g", { clipPath: "url(#clip0_134_843)", children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M35.2497 43.93C34.4358 43.93 33.7296 43.325 33.6241 42.4966C33.51 41.5977 34.1457 40.7765 35.0442 40.662C40.2284 40.0015 44.8709 38.5967 48.1162 36.7057C51.0843 34.9767 52.7185 32.9438 52.7185 30.9819C52.7185 28.8196 50.8062 27.0504 49.2014 25.9464C48.455 25.4329 48.2662 24.4117 48.7798 23.6649C49.2933 22.9185 50.3148 22.7297 51.0612 23.2432C54.2921 25.4657 55.9998 28.1416 55.9998 30.9823C55.9998 34.2063 53.8452 37.1659 49.7684 39.5409C46.0988 41.6789 41.1509 43.1922 35.4591 43.9172C35.3886 43.9257 35.3185 43.93 35.2497 43.93Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M27.6 41.5797L23.225 37.2047C22.5842 36.5638 21.5455 36.5638 20.9047 37.2047C20.2642 37.8451 20.2642 38.8842 20.9047 39.5246L22.183 40.8029C17.2816 40.2966 12.8289 39.1555 9.38102 37.4973C5.50463 35.6333 3.28124 33.2582 3.28124 30.9818C3.28124 29.0511 4.87316 27.0443 7.76347 25.3311C8.5432 24.8692 8.8004 23.8626 8.33854 23.0833C7.87627 22.3036 6.86968 22.0464 6.09038 22.5083C1.05658 25.4922 0 28.7631 0 30.9818C0 34.622 2.82665 37.9861 7.95915 40.4547C11.9428 42.3701 17.0958 43.6531 22.7098 44.1495L20.9047 45.9546C20.2642 46.5951 20.2642 47.6341 20.9047 48.275C21.2251 48.595 21.6451 48.7552 22.0651 48.7552C22.4846 48.7552 22.9046 48.595 23.225 48.275L27.6 43.9C28.2405 43.2592 28.2405 42.2201 27.6 41.5797Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M17.1827 27.6963V27.3016C17.1827 25.9092 16.3303 25.6391 15.1874 25.6391C14.4808 25.6391 14.2522 25.0158 14.2522 24.3924C14.2522 23.7687 14.4808 23.1453 15.1874 23.1453C15.977 23.1453 16.8084 23.0415 16.8084 21.3581C16.8084 20.1529 16.1227 19.8619 15.2703 19.8619C14.2522 19.8619 13.7327 20.1114 13.7327 20.9219C13.7327 21.6282 13.4208 22.1063 12.2155 22.1063C10.7193 22.1063 10.5326 21.7944 10.5326 20.7967C10.5326 19.1762 11.696 17.0771 15.2703 17.0771C17.9098 17.0771 19.9046 18.0329 19.9046 20.8386C19.9046 22.3553 19.3437 23.7687 18.3046 24.2468C19.5308 24.7039 20.4242 25.6182 20.4242 27.3016V27.6963C20.4242 31.1045 18.076 32.393 15.1665 32.393C11.5922 32.393 10.2207 30.2111 10.2207 28.4654C10.2207 27.5301 10.6155 27.2806 11.7584 27.2806C13.0884 27.2806 13.4208 27.5716 13.4208 28.3616C13.4208 29.3382 14.3355 29.5668 15.2703 29.5668C16.6836 29.5668 17.1827 29.0473 17.1827 27.6963Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M33.0384 27.3016V27.4887C33.0384 31.063 30.8146 32.393 27.9469 32.393C25.0792 32.393 22.8345 31.063 22.8345 27.4887V21.9815C22.8345 18.4072 25.1412 17.0771 28.134 17.0771C31.646 17.0771 33.0384 19.2591 33.0384 20.9839C33.0384 21.9815 32.5603 22.293 31.5212 22.293C30.6279 22.293 29.8379 22.0644 29.8379 21.1086C29.8379 20.3191 29.0069 19.9034 28.0302 19.9034C26.804 19.9034 26.0764 20.5477 26.0764 21.9815V23.8515C26.7416 23.1244 27.6769 22.9372 28.6745 22.9372C31.0431 22.9372 33.0384 23.9763 33.0384 27.3016ZM26.0764 27.7173C26.0764 29.1511 26.7831 29.7745 27.9469 29.7745C29.1107 29.7745 29.7964 29.1511 29.7964 27.7173V27.5301C29.7964 26.013 29.1107 25.4311 27.926 25.4311C26.804 25.4311 26.0764 25.9715 26.0764 27.343V27.7173Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M35.5527 27.4887V21.9815C35.5527 18.4072 37.7761 17.0771 40.6442 17.0771C43.5119 17.0771 45.7562 18.4072 45.7562 21.9815V27.4887C45.7562 31.063 43.5119 32.393 40.6442 32.393C37.7761 32.393 35.5527 31.063 35.5527 27.4887ZM42.5143 21.9815C42.5143 20.5477 41.808 19.9034 40.6442 19.9034C39.4804 19.9034 38.7947 20.5477 38.7947 21.9815V27.4887C38.7947 28.9225 39.4804 29.5668 40.6442 29.5668C41.808 29.5668 42.5143 28.9225 42.5143 27.4887V21.9815Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M49.6948 17.0625C46.9805 17.0625 44.7729 14.8545 44.7729 12.1406C44.7729 9.42675 46.9805 7.21875 49.6948 7.21875C52.4087 7.21875 54.6167 9.42675 54.6167 12.1406C54.6167 14.8545 52.4087 17.0625 49.6948 17.0625ZM49.6948 10.5C48.7899 10.5 48.0542 11.2361 48.0542 12.1406C48.0542 13.0455 48.7899 13.7812 49.6948 13.7812C50.5993 13.7812 51.3354 13.0455 51.3354 12.1406C51.3354 11.2361 50.5993 10.5 49.6948 10.5Z",
            fill: "white"
          }
        )
      ] }),
      /* @__PURE__ */ u.jsx("defs", { children: /* @__PURE__ */ u.jsx("clipPath", { id: "clip0_134_843", children: /* @__PURE__ */ u.jsx("rect", { width: "56", height: "56", fill: "white" }) }) })
    ]
  }
) }), Vp = ({
  src: i,
  withCdn: m
}) => {
  const { permanentGallery: s } = St();
  if (!i)
    return null;
  const y = "size-full object-cover";
  return m ? /* @__PURE__ */ u.jsx(
    lr,
    {
      className: y,
      src: i,
      onlyThumbnail: !0,
      fadeIn: !s
    }
  ) : /* @__PURE__ */ u.jsx("img", { className: y, src: i });
}, ni = ({
  children: i
}) => {
  const { extendMode: m } = ut();
  return /* @__PURE__ */ u.jsx(
    "div",
    {
      className: ge(
        "flex aspect-square h-3/4 items-center justify-center rounded-full bg-foreground/50 p-1",
        m && "large:h-3/5 large:p-2"
      ),
      children: i
    }
  );
}, Hp = ({ item: i }) => {
  const { aspectRatioStyle: m } = pn(), { type: s } = i;
  let y, C;
  switch (s) {
    case "360":
      y = i.images[0].src, C = !0;
      break;
    case "image":
      y = i.src, C = !0;
      break;
    case "video":
      y = i.poster, C = !0;
      break;
    case "custom":
      y = i.thumbnailSrc, C = !1;
      break;
  }
  const _ = /* @__PURE__ */ u.jsx(Vp, { src: y, withCdn: C });
  let O;
  switch (s) {
    case "360":
      O = /* @__PURE__ */ u.jsx(ni, { children: /* @__PURE__ */ u.jsx(Fc, { className: "size-full text-primary-light" }) });
      break;
    case "video":
      O = /* @__PURE__ */ u.jsx(ni, { children: /* @__PURE__ */ u.jsx(di, { className: "size-full p-0.5 text-background" }) });
      break;
    case "custom":
      O = y ? null : /* @__PURE__ */ u.jsx(ni, { children: /* @__PURE__ */ u.jsx(Oc, { className: "size-full p-0.5 text-background" }) });
      break;
  }
  return /* @__PURE__ */ u.jsxs("div", { className: "relative bg-foreground/30", style: m, children: [
    _,
    O && /* @__PURE__ */ u.jsx("div", { className: "absolute inset-0 flex items-center justify-center bg-foreground/25", children: O })
  ] });
}, $p = {
  primary: "bg-primary/50",
  neutral: "bg-neutral/50",
  background: "bg-background/50",
  foreground: "bg-foreground/50"
}, Vc = ({
  color: i = "neutral",
  orientation: m = "horizontal"
}) => {
  const s = $p[i], y = m === "horizontal" ? "h-px w-full" : "w-px h-full";
  return /* @__PURE__ */ u.jsx("div", { className: ge(s, y) });
}, Hc = ({
  className: i = "",
  containerClassName: m = ""
}) => {
  const { hideCategories: s, infiniteCarrousel: y, permanentGallery: C, isFullScreen: _ } = St(), { categories: O, aspectRatioStyle: M } = pn(), {
    items: E,
    extendMode: U,
    extendTransition: R,
    masterItemIndex: L,
    prevItem: V,
    nextItem: W,
    scrollToItemIndex: x,
    resetView: N
  } = ut(), z = h.useMemo(() => {
    if (s)
      return [];
    const K = new Array();
    let ee = O[0];
    const ae = (ne) => O.find(
      (se) => se.items.some((D) => D === ne)
    );
    for (let ne = 0; ne < E.length; ne++) {
      const se = E[ne], D = ae(se);
      D && D !== ee && (K.push(ne), ee = D);
    }
    return K;
  }, [O, s, E]), Z = h.useRef(null), X = h.useCallback(() => {
    if (!Z.current)
      throw new Error("slider.current is null");
    return Z.current;
  }, []), H = h.useRef(!1), j = h.useRef(
    null
  ), [Q, Y] = h.useState(!1), q = h.useCallback(
    (K, ee) => {
      const ae = X(), ne = ae.clientWidth, se = ae.scrollWidth / E.length, D = (K + 1 / 2) * se - ne / 2, S = ae.scrollWidth - ae.clientWidth;
      ae.scrollTo({
        left: zn(D, 0, S),
        behavior: ee
      });
    },
    [E.length, X]
  );
  h.useEffect(() => {
    const K = Z.current;
    if (!K)
      return;
    const ee = (se) => {
      se.preventDefault(), H.current = !0, j.current = {
        x: se.pageX - K.offsetLeft,
        scrollLeft: K.scrollLeft
      };
    }, ae = (se) => {
      if (!H.current)
        return;
      if (j.current === null)
        throw new Error("[onMouseMove] scrollStart is null");
      const D = se.pageX - K.offsetLeft - j.current.x;
      if (!Q && Math.abs(D) < 5)
        return;
      const S = j.current.scrollLeft - D;
      Y(!0), requestAnimationFrame(() => {
        K.scrollLeft = S;
      });
    }, ne = () => {
      H.current && (H.current = !1, requestAnimationFrame(() => {
        Y(!1);
      }));
    };
    return K.addEventListener("mousedown", ee), document.addEventListener("mousemove", ae), document.addEventListener("mouseleave", ne), document.addEventListener("mouseup", ne), document.addEventListener("contextmenu", ne), () => {
      K.removeEventListener("mousedown", ee), document.removeEventListener("mousemove", ae), document.removeEventListener("mouseleave", ne), document.removeEventListener("mouseup", ne), document.removeEventListener("contextmenu", ne);
    };
  }, [Q]);
  const fe = h.useRef(L);
  h.useEffect(() => {
    Z.current && (q(L, "smooth"), fe.current = L);
  }, [L, q]), h.useEffect(() => {
    Z.current && q(fe.current, "instant");
  }, [
    q,
    // - Run the effect when those values change
    _,
    U,
    R
  ]);
  const de = (K) => {
    Q || (y && K === E.length - 1 && L === 0 ? V() : y && K === 0 && L === E.length - 1 ? W() : x(K), N());
  };
  return /* @__PURE__ */ u.jsx(
    "div",
    {
      ref: Z,
      className: ge(
        "relative w-full overflow-x-auto no-scrollbar",
        Q ? "cursor-grab" : "cursor-grabbing",
        i
      ),
      children: /* @__PURE__ */ u.jsx(
        "div",
        {
          className: ge(
            "flex h-10 w-fit gap-1 small:h-12 small:gap-2",
            U && "large:h-20 large:gap-4",
            m
          ),
          children: E.map((K, ee) => /* @__PURE__ */ u.jsxs(h.Fragment, { children: [
            z.includes(ee) && /* @__PURE__ */ u.jsx("div", { className: "my-2", children: /* @__PURE__ */ u.jsx(
              Vc,
              {
                color: C && !_ ? "neutral" : "background",
                orientation: "vertical"
              }
            ) }),
            /* @__PURE__ */ u.jsx(
              "div",
              {
                className: ge(
                  "relative h-full overflow-hidden rounded-gallery transition-radius",
                  !Q && "cursor-pointer",
                  "after:absolute after:inset-0 after:rounded-gallery after:border-2 after:border-primary after:transition-all",
                  ee === L ? "after:opacity-100" : "after:opacity-0 hover:after:opacity-70"
                ),
                style: M,
                onClick: () => de(ee),
                children: /* @__PURE__ */ u.jsx(Hp, { item: K })
              }
            )
          ] }, ee))
        }
      )
    }
  );
}, $c = (i) => 1 - Math.pow(1 - i, 2), Ap = ({
  Media: i,
  itemIndex: m
}) => {
  const { setItemInteraction: s } = ut();
  return h.useEffect(() => {
    s(m, "ready");
  }, [m, s]), i;
}, dc = (i, m) => Math.sqrt(
  (i.clientX - m.clientX) ** 2 + (i.clientY - m.clientY) ** 2
), Wp = ({
  onlyPreload: i,
  ...m
}) => {
  const { zoom: s, isZooming: y, setZoom: C } = ut(), _ = h.useRef(null), O = h.useRef(null), M = h.useCallback((H) => {
    if (!O.current)
      throw new Error(
        `[${H ?? "getTransformElementOrThrow"}] transformElementRef.current is null`
      );
    return O.current;
  }, []), E = h.useRef(!1), U = h.useRef(null), R = h.useRef(/* @__PURE__ */ new Map()), L = h.useRef({ x: 0, y: 0, scale: 1 }), V = h.useRef(null), W = h.useCallback(
    (H) => {
      const j = M("setTransformStyle"), {
        x: Q,
        y: Y,
        scale: q
      } = {
        ...L.current,
        ...H
      }, fe = zn(q, 1, ul), de = j.clientWidth, K = j.clientHeight, ee = de * fe, ae = K * fe, ne = zn(Q, -(ee - de), 0), se = zn(Y, -(ae - K), 0);
      L.current = { x: ne, y: se, scale: fe }, j.style.transform = `translate(${ne}px, ${se}px) scale(${fe})`;
    },
    [M]
  ), x = h.useCallback(
    (H, j) => {
      const {
        x: Q,
        y: Y,
        scale: q
      } = L.current, {
        x: fe,
        y: de,
        scale: K
      } = {
        ...L.current,
        ...H
      };
      V.current && (cancelAnimationFrame(V.current), V.current = null);
      const ee = () => {
        W({ x: fe, y: de, scale: K }), C(K);
      }, ae = Math.abs(fe - Q) < 1 && Math.abs(de - Y) < 1 && Math.abs(K - q) < 5e-3;
      if (!j || ae) {
        ee();
        return;
      }
      const ne = (/* @__PURE__ */ new Date()).getTime(), se = () => {
        const D = () => {
          const S = (/* @__PURE__ */ new Date()).getTime() - ne;
          if (S >= j) {
            ee(), V.current = null;
            return;
          }
          const B = Math.min(S / j, 1), w = $c(B), $ = il(Q, fe, w), F = il(Y, de, w), p = il(q, K, w);
          W({ x: $, y: F, scale: p }), se();
        };
        V.current = requestAnimationFrame(D);
      };
      se();
    },
    [W, C]
  ), N = h.useCallback(
    (H, j) => {
      let { x: Q, y: Y } = L.current;
      H.x && (Q += H.x), H.y && (Y += H.y), x(
        {
          x: Q,
          y: Y
        },
        j
      );
    },
    [x]
  ), z = h.useCallback(
    (H, j, Q) => {
      const Y = L.current.scale, q = zn(H, 1, ul), fe = q / Y, { x: de, y: K } = L.current, { x: ee, y: ae } = j, ne = -de + ee, se = -K + ae, D = ne * fe, S = se * fe, B = D - ee, w = S - ae, $ = -B, F = -w;
      x(
        {
          x: $,
          y: F,
          scale: q
        },
        Q
      );
    },
    [x]
  ), Z = h.useCallback(
    (H) => {
      const j = M(
        "shiftZoomFromButton"
      ), Q = j.clientWidth, Y = j.clientHeight;
      z(
        H,
        {
          x: Q / 2,
          y: Y / 2
        },
        200
      );
    },
    [M, z]
  ), X = h.useCallback(
    (H, j, Q) => {
      const { scale: Y } = L.current;
      z(
        Y + H,
        j,
        Q
      );
    },
    [z]
  );
  return h.useEffect(() => {
    i || O.current && Z(s);
  }, [i, Z, s]), h.useEffect(() => {
    if (i || !y)
      return;
    const H = O.current;
    if (!H)
      return;
    const j = (q) => {
      q.preventDefault(), q.stopPropagation(), E.current = !0, U.current = {
        x: q.clientX,
        y: q.clientY
      };
    }, Q = (q) => {
      if (!E.current)
        return;
      if (!U.current)
        throw new Error("mouseStartXY.current is null");
      q.stopPropagation();
      const fe = q.clientX - U.current.x, de = q.clientY - U.current.y;
      N({
        x: fe,
        y: de
      }), U.current = {
        x: q.clientX,
        y: q.clientY
      };
    }, Y = () => {
      E.current = !1;
    };
    return H.addEventListener("mousedown", j), document.addEventListener("mousemove", Q), document.addEventListener("mouseleave", Y), document.addEventListener("mouseup", Y), document.addEventListener("contextmenu", Y), () => {
      H.removeEventListener("mousedown", j), document.removeEventListener("mousemove", Q), document.removeEventListener("mouseleave", Y), document.removeEventListener("mouseup", Y), document.removeEventListener("contextmenu", Y);
    };
  }, [y, N, i]), h.useEffect(() => {
    if (i)
      return;
    const H = _.current;
    if (!H)
      return;
    const j = (Q) => {
      const { ctrlKey: Y, clientX: q, clientY: fe, deltaX: de, deltaY: K } = Q;
      if (Y) {
        if (!y && K >= 0)
          return;
        const { left: ee, top: ae } = H.getBoundingClientRect(), ne = q - ee, se = fe - ae;
        X(-0.01 * K, {
          x: ne,
          y: se
        });
      } else {
        if (!y)
          return;
        N({
          x: -2 * de,
          y: -2 * K
        });
      }
      Q.preventDefault();
    };
    return H.addEventListener("wheel", j), () => {
      H.removeEventListener("wheel", j);
    };
  }, [y, N, X, i]), h.useEffect(() => {
    const H = _.current, j = O.current;
    if (!H || !j)
      return;
    const Q = R.current, Y = (de) => {
      for (let K = 0; K < de.changedTouches.length; K++) {
        const ee = de.changedTouches[K];
        Q.set(ee.identifier, ee);
      }
    }, q = (de) => {
      for (let K = 0; K < de.changedTouches.length; K++) {
        const ee = de.changedTouches[K];
        Q.delete(ee.identifier);
      }
    }, fe = (de) => {
      const K = de.touches.length;
      if (K === 1) {
        if (!y)
          return;
        de.preventDefault();
        const ee = de.touches[0], ae = Q.get(ee.identifier);
        if (!ae)
          throw new Error("touchStart is null");
        const ne = ee.clientX - ae.clientX, se = ee.clientY - ae.clientY;
        N({
          x: ne,
          y: se
        }), Q.set(ee.identifier, ee);
      } else if (K === 2) {
        de.preventDefault();
        const [ee, ae] = de.touches, ne = Q.get(ee.identifier), se = Q.get(ae.identifier);
        if (!ne || !se)
          throw new Error("intialTouch1 or intialTouch2 is null");
        const D = dc(
          ne,
          se
        ), S = dc(ee, ae) / D, { left: B, top: w } = H.getBoundingClientRect();
        X(S - 1, {
          x: (ee.clientX + ae.clientX) / 2 - B,
          y: (ee.clientY + ae.clientY) / 2 - w
        }), Q.set(ee.identifier, ee), Q.set(ae.identifier, ae);
      }
    };
    return j.addEventListener("touchstart", Y), j.addEventListener("touchmove", fe), j.addEventListener("touchend", q), j.addEventListener("touchcancel", q), () => {
      j.removeEventListener("touchstart", Y), j.removeEventListener("touchmove", fe), j.removeEventListener("touchend", q), j.removeEventListener("touchcancel", q);
    };
  }, [y, N, X]), /* @__PURE__ */ u.jsx(
    "div",
    {
      ref: _,
      className: `relative size-full overflow-hidden ${y ? "z-zoomed-image cursor-move" : ""}`,
      children: /* @__PURE__ */ u.jsx(
        "div",
        {
          ref: O,
          className: "origin-top-left",
          children: /* @__PURE__ */ u.jsx(
            lr,
            {
              ...m,
              imgInPlayerWidthRatio: i ? 1 : s
            }
          )
        }
      )
    }
  );
}, Bp = ({ hotspot: i }) => {
  const { title: m, icon: s, description: y, position: C, detail: _ } = i, { getIconConfig: O } = Zr(), M = s ? O(s) : void 0, { extendMode: E, setShownDetails: U } = ut(), R = !!_, L = _?.type === "image", V = !!m || !!y, W = L ? /* @__PURE__ */ u.jsx(Oc, { className: "size-4" }) : /* @__PURE__ */ u.jsx("div", { className: "size-1" }), x = () => {
    L && U({
      src: _.src,
      title: m,
      text: y
    });
  };
  return /* @__PURE__ */ u.jsxs(
    "div",
    {
      className: ge(
        "group absolute z-hotspot -translate-x-1/2 -translate-y-1/2 hover:z-hotspot-hover",
        R ? "cursor-pointer" : "cursor-help"
      ),
      style: {
        top: `${100 * i.position.y}%`,
        left: `${100 * i.position.x}%`
      },
      onClick: x,
      children: [
        /* @__PURE__ */ u.jsxs(
          "div",
          {
            className: "relative flex items-center justify-center rounded-full border-2 border-background bg-primary text-primary-foreground",
            children: [
              /* @__PURE__ */ u.jsx(
                "div",
                {
                  className: "pointer-events-none absolute -z-20 size-8 animate-hotspot-ping rounded-full border-2 border-background"
                }
              ),
              /* @__PURE__ */ u.jsx("div", { className: "p-1", children: M?.Icon ? /* @__PURE__ */ u.jsx("div", { className: "size-4", children: M.Icon }) : W })
            ]
          }
        ),
        !L && V && /* @__PURE__ */ u.jsx(
          "div",
          {
            className: ge(
              "absolute -z-10 w-max max-w-40 text-pretty rounded-ui bg-background p-2 small:max-w-48",
              E && "large:max-w-56",
              C.y < 0.55 ? "-top-1" : "-bottom-1",
              C.x < 0.55 ? "-left-1 pl-6 small:pl-8" : "-right-1 pr-4 small:pr-6",
              "pointer-events-none opacity-0 transition-opacity duration-200 group-hover:pointer-events-auto group-hover:opacity-100"
            ),
            children: /* @__PURE__ */ u.jsxs("div", { className: "space-y-1 text-pretty", children: [
              m && /* @__PURE__ */ u.jsx("div", { className: "text-sm font-semibold small:text-base small:font-bold", children: m }),
              y && /* @__PURE__ */ u.jsx("div", { className: "text-xs text-foreground/65 small:text-sm", children: y })
            ] })
          }
        )
      ]
    }
  );
}, Dp = ({ hotspot: i }) => {
  const { detail: m } = i, s = /* @__PURE__ */ u.jsx(Bp, { hotspot: i });
  switch (m?.type) {
    case "link":
    case "pdf":
      return /* @__PURE__ */ u.jsx("a", { href: m.src, target: "_blank", rel: "noreferrer", children: s });
    default:
      return s;
  }
}, Ac = ({
  hotspots: i,
  itemIndex: m,
  className: s,
  onLoad: y,
  ...C
}) => {
  const { isShowingDetails: _, showHotspots: O, setItemInteraction: M } = ut();
  return /* @__PURE__ */ u.jsx("div", { className: ge("relative size-full overflow-hidden", s), children: /* @__PURE__ */ u.jsxs(
    "div",
    {
      className: ge(
        "size-full duration-details",
        _ ? "scale-105" : "scale-100"
      ),
      children: [
        /* @__PURE__ */ u.jsx(
          Wp,
          {
            className: "size-full object-cover",
            onLoad: (E) => {
              m !== void 0 && M(m, "ready"), y?.(E);
            },
            ...C
          }
        ),
        O && i?.map((E, U) => /* @__PURE__ */ u.jsx(Dp, { hotspot: E }, U))
      ]
    }
  ) });
}, Ur = 10, Up = 15, Yp = ({
  images: i,
  onlyPreload: m
}) => {
  const { reverse360: s } = St(), { isShowingDetails: y, isZooming: C } = ut(), _ = C || y, O = h.useRef(null), M = h.useRef(null), [E, U] = h.useState(0), R = i.length, L = h.useCallback(() => {
    U((W) => (W - 1 + R) % R);
  }, [R]), V = h.useCallback(() => {
    U((W) => (W + 1) % R);
  }, [R]);
  return h.useEffect(() => {
    if (_)
      return;
    const W = O.current, x = M.current;
    if (!W || !x)
      return;
    let N = null, z = [], Z = null;
    const X = (S) => {
      z.push(S), z.length > 20 && z.shift();
    }, H = () => {
      const S = Date.now(), B = (() => {
        const p = Date.now(), k = z.filter(
          (me) => p - me.timestamp < 50
        );
        if (k.length < 2)
          return 0;
        const oe = k[0], ie = k[k.length - 1];
        return (ie.value - oe.value) / (1e-3 * Math.max(ie.timestamp - oe.timestamp, 1));
      })();
      let w = 0, $ = S;
      const F = () => {
        Z = requestAnimationFrame(() => {
          const p = Date.now(), k = (p - S) / 1e3, oe = Math.pow(0.05, k), ie = B * oe, me = (p - $) / 1e3;
          if (w += ie * me, Math.abs(ie) < 5 * Ur && Math.abs(w) < Ur) {
            Z = null;
            return;
          }
          Math.abs(w) >= Ur && (w > 0 !== s ? V() : L(), w = 0), $ = p, F();
        });
      };
      F();
    }, j = () => {
      Z && (cancelAnimationFrame(Z), Z = null);
    }, Q = (S) => {
      if (S.button !== 0)
        return;
      S.preventDefault(), S.stopPropagation(), j();
      const B = S.clientX;
      N = B, z = [{ timestamp: Date.now(), value: B }];
    }, Y = (S) => {
      if (N === null)
        return;
      S.stopPropagation();
      const { clientX: B } = S;
      X({ timestamp: Date.now(), value: B });
      const w = B - N;
      Math.abs(w) < Ur || (w > 0 !== s ? V() : L(), N = B);
    }, q = () => {
      N !== null && (N = null, H());
    };
    W.addEventListener("mousedown", Q), document.addEventListener("mousemove", Y), document.addEventListener("mouseleave", q), document.addEventListener("mouseup", q), document.addEventListener("contextmenu", q);
    const fe = () => x.getBoundingClientRect().width, de = () => x.scrollWidth / 2 - fe() / 2, K = () => {
      const S = de();
      x.scrollLeft = S;
    };
    K();
    const ee = () => {
      const S = x.scrollLeft - de();
      Math.abs(S) < Up || (S < 0 !== s ? V() : L(), K());
    };
    x.addEventListener("scroll", ee);
    let ae = null;
    const ne = (S) => {
      if (ae !== null || S.changedTouches.length !== 1)
        return;
      j();
      const { identifier: B, clientX: w } = S.changedTouches[0];
      ae = B, N = w, z = [{ timestamp: Date.now(), value: w }];
    }, se = (S) => {
      if (!N)
        return;
      const B = Array.from(S.changedTouches).find(
        ({ identifier: F }) => F === ae
      );
      if (!B)
        return;
      S.preventDefault();
      const { clientX: w } = B;
      X({ timestamp: Date.now(), value: w });
      const $ = w - N;
      Math.abs($) < Ur || ($ > 0 !== s ? V() : L(), N = w);
    }, D = (S) => {
      !N || !Array.from(S.changedTouches).some(
        ({ identifier: B }) => B === ae
      ) || (ae = null, N = null, H());
    };
    return x.addEventListener("touchstart", ne), x.addEventListener("touchmove", se), x.addEventListener("touchend", D), x.addEventListener("touchcancel", D), () => {
      W.removeEventListener("mousedown", Q), document.removeEventListener("mousemove", Y), document.removeEventListener("mouseleave", q), document.removeEventListener("mouseup", q), document.removeEventListener("contextmenu", q), x.removeEventListener("scroll", ee), x.removeEventListener("touchstart", ne), x.removeEventListener("touchmove", se), x.removeEventListener("touchend", D), x.removeEventListener("touchcancel", D);
    };
  }, [V, L, _, s]), /* @__PURE__ */ u.jsx("div", { ref: O, className: "cursor-ew-resize", children: /* @__PURE__ */ u.jsxs("div", { ref: M, className: "overflow-x-scroll no-scrollbar", children: [
    /* @__PURE__ */ u.jsxs("div", { className: "sticky left-0 top-0", children: [
      i.map((W) => /* @__PURE__ */ u.jsx(
        lr,
        {
          src: W.src,
          className: "pointer-events-none !absolute left-0 top-0 -z-10"
        },
        W.src
      )),
      /* @__PURE__ */ u.jsx(Ac, { ...i[E], onlyPreload: m })
    ] }),
    /* @__PURE__ */ u.jsx("div", { className: "pointer-events-none -mt-px h-px w-[calc(100%+1024px)]" })
  ] }) });
}, Zp = ({ images: i, onPlaceholderImageLoaded: m, onSpinImagesLoaded: s, onError: y }) => {
  const C = h.useMemo(() => i.map(({ src: R }) => R), [i]), [_, O] = h.useState(null), M = _ ? [..._.values()].filter((R) => R).length / i.length * 100 : null, E = h.useCallback(() => {
    M === null && O(new Map(C.map((R) => [R, !1])));
  }, [C, M]), U = h.useCallback((R) => {
    O((L) => {
      const V = new Map(L);
      return V.set(R, !0), V;
    });
  }, []);
  return h.useEffect(() => {
    M === 100 && s();
  }, [M, s]), /* @__PURE__ */ u.jsxs("div", { className: "relative size-full", children: [
    M !== null && M !== 100 && // Add images to DOM to preload them
    /* @__PURE__ */ u.jsx("div", { className: "hidden", children: C.map((R) => /* @__PURE__ */ u.jsx(
      lr,
      {
        src: R,
        onLoad: () => U(R),
        onError: y
      },
      R
    )) }),
    /* @__PURE__ */ u.jsx(
      lr,
      {
        className: "size-full",
        src: C[0],
        onLoad: m
      }
    ),
    /* @__PURE__ */ u.jsxs("div", { className: "absolute inset-0 flex flex-col items-center justify-center gap-y-4 bg-foreground/35", children: [
      /* @__PURE__ */ u.jsx(Fc, { className: "size-20 text-primary-light" }),
      /* @__PURE__ */ u.jsx(gt, { color: "neutral", shape: "icon", onClick: E, children: /* @__PURE__ */ u.jsx(di, { className: "size-full" }) }),
      /* @__PURE__ */ u.jsx(
        "div",
        {
          className: ge(
            "relative h-1 w-3/5 overflow-hidden rounded-full bg-background",
            M === null && "invisible"
          ),
          children: /* @__PURE__ */ u.jsx(
            "div",
            {
              className: "h-full bg-primary transition-[width]",
              style: { width: `${M ?? 0}%` }
            }
          )
        }
      )
    ] })
  ] });
}, Qp = (i) => {
  const { itemIndex: m } = i, { setItemInteraction: s } = ut(), [y, C] = h.useState();
  return h.useEffect(() => {
    y === null || y === "error" || s(m, y === "spin" ? "running" : "ready");
  }, [m, s, y]), y === "error" ? /* @__PURE__ */ u.jsx(
    Rc,
    {
      className: "text-background",
      text: "Spin could not be loaded"
    }
  ) : y !== "spin" ? /* @__PURE__ */ u.jsx(
    Zp,
    {
      ...i,
      onPlaceholderImageLoaded: () => C("placeholder"),
      onSpinImagesLoaded: () => C("spin"),
      onError: () => C("error")
    }
  ) : /* @__PURE__ */ u.jsx(Yp, { ...i });
}, Xp = (i) => /* @__PURE__ */ u.jsx(gt, { color: "neutral", shape: "icon", ...i, children: /* @__PURE__ */ u.jsx(di, { className: "size-full" }) }), Kp = ({ className: i }) => /* @__PURE__ */ u.jsx(Ye, { className: i, customizationKey: "UI_PAUSE", children: /* @__PURE__ */ u.jsx(
  "svg",
  {
    className: i,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ u.jsx(
      "path",
      {
        d: "M4 12.6667H6.66667V3.33333H4V12.6667ZM9.33333 3.33333V12.6667H12V3.33333H9.33333Z",
        fill: "currentColor"
      }
    )
  }
) }), qp = ({ className: i }) => /* @__PURE__ */ u.jsx(Ye, { className: i, customizationKey: "UI_VOLUME", children: /* @__PURE__ */ u.jsx(
  "svg",
  {
    className: i,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ u.jsx(
      "path",
      {
        d: "M2 6V10H4.66667L8 13.3333V2.66667L4.66667 6H2ZM11 8C11 6.82 10.32 5.80667 9.33333 5.31334V10.68C10.32 10.1933 11 9.18 11 8ZM9.33333 2.15334V3.52667C11.26 4.1 12.6667 5.88667 12.6667 8C12.6667 10.1133 11.26 11.9 9.33333 12.4733V13.8467C12.0067 13.24 14 10.8533 14 8C14 5.14667 12.0067 2.76 9.33333 2.15334Z",
        fill: "currentColor"
      }
    )
  }
) }), Jp = ({ className: i }) => /* @__PURE__ */ u.jsx(Ye, { className: i, customizationKey: "UI_VOLUME_OFF", children: /* @__PURE__ */ u.jsx(
  "svg",
  {
    className: i,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ u.jsx(
      "path",
      {
        d: "M11 8C11 6.82 10.32 5.80667 9.33333 5.31333V6.78667L10.9667 8.42C10.9867 8.28667 11 8.14667 11 8ZM12.6667 8C12.6667 8.62667 12.5333 9.21333 12.3067 9.76L13.3133 10.7667C13.7533 9.94 14 9 14 8C14 5.14667 12.0067 2.76 9.33333 2.15333V3.52667C11.26 4.1 12.6667 5.88667 12.6667 8ZM2.84667 2L2 2.84667L5.15333 6H2V10H4.66667L8 13.3333V8.84667L10.8333 11.68C10.3867 12.0267 9.88667 12.3 9.33333 12.4667V13.84C10.2533 13.6333 11.0867 13.2067 11.7933 12.6333L13.1533 14L14 13.1533L2.84667 2ZM8 2.66667L6.60667 4.06L8 5.45333V2.66667Z",
        fill: "currentColor"
      }
    )
  }
) }), fc = ({ progress: i }) => /* @__PURE__ */ u.jsx("div", { className: "h-1 w-full overflow-hidden rounded-ui-sm bg-background/25", children: /* @__PURE__ */ u.jsx(
  "div",
  {
    className: "size-full rounded-ui-sm bg-background transition-transform",
    style: { transform: `translateX(-${100 * (1 - i)}%)` }
  }
) }), Gp = 3e3, em = ({ src: i, poster: m, itemIndex: s }) => {
  const { carrouselItemIndex: y, setItemInteraction: C } = ut(), _ = h.useRef(null), O = h.useRef(null), M = h.useCallback(() => {
    if (!O.current)
      throw new Error("videoRef.current is null");
    return O.current;
  }, []);
  h.useEffect(() => {
    C(s, "ready");
  }, [s, C]);
  const E = h.useCallback(() => {
    M().play();
  }, [M]), U = h.useCallback(() => {
    M().pause();
  }, [M]);
  h.useEffect(() => {
    y === s || U();
  }, [y, s, U]);
  const [R, L] = h.useState(!1), [V, W] = h.useState(!0), x = () => {
    L(!0), C(s, "running");
  }, N = () => {
    L(!1), C(s, "ready");
  }, z = () => {
    W(!1);
  }, Z = () => {
    W(!0);
  }, [X, H] = h.useState(null), j = (S) => {
    const B = M(), w = S.currentTarget.getBoundingClientRect(), $ = (S.clientX - w.left) / w.width, F = Math.min(1, Math.max(0, $));
    B.volume = F, B.muted = !1;
  }, Q = (S) => {
    const B = M();
    B.muted = S;
  };
  h.useEffect(() => {
    const S = O.current;
    if (!S)
      return;
    const B = () => {
      H({
        volume: S.volume,
        isMuted: S.muted
      });
    };
    return B(), S.addEventListener("volumechange", B), () => {
      S.removeEventListener("volumechange", B);
    };
  }, []);
  const [Y, q] = h.useState(null), fe = Y ? Y.currentTime / Y.duration : 0;
  h.useEffect(() => {
    const S = O.current;
    if (!S) return;
    const B = () => {
      const w = S.currentTime, $ = S.duration;
      isNaN(w) || isNaN($) || q({
        currentTime: w,
        duration: $
      });
    };
    return B(), S.addEventListener("timeupdate", B), () => {
      S.removeEventListener("timeupdate", B);
    };
  }, []);
  const de = (S) => {
    const B = M(), w = S.currentTarget.getBoundingClientRect(), $ = (S.clientX - w.left) / w.width, F = B.duration * $;
    B.currentTime = F;
  }, K = (S) => {
    const B = Math.floor(S % 3600 / 60), w = Math.floor(S % 60);
    return `${B}:${w.toString().padStart(2, "0")}`;
  }, [ee, ae] = h.useState(!1), ne = h.useRef(void 0), se = h.useCallback(
    () => clearTimeout(ne.current),
    []
  ), D = h.useCallback(() => {
    se(), ne.current = setTimeout(() => {
      ae(!1);
    }, Gp);
  }, [se]);
  return h.useEffect(() => {
    const S = _.current, B = O.current;
    if (!S || !B)
      return;
    const w = () => {
      D(), ae(!0);
    }, $ = () => {
      se(), ae(!1);
    };
    let F = !1;
    const p = () => {
      F = !0;
    }, k = () => {
      F && (F = !1, U());
    }, oe = () => {
      F = !1, w();
    }, ie = (me) => {
      me.preventDefault(), me.touches.length === 1 && (D(), ae((ve) => !ve));
    };
    return S.addEventListener("mousedown", p), S.addEventListener("mouseup", k), S.addEventListener("mouseenter", w), S.addEventListener("mousemove", oe), S.addEventListener("mouseleave", $), B.addEventListener("touchstart", ie), () => {
      S.removeEventListener("mousedown", p), S.removeEventListener("mouseup", k), S.removeEventListener("mouseenter", w), S.removeEventListener("mousemove", w), S.removeEventListener("mouseleave", $), B.removeEventListener("touchstart", ie);
    };
  }, [se, U, D]), /* @__PURE__ */ u.jsxs("div", { ref: _, className: "relative size-full", children: [
    /* @__PURE__ */ u.jsx(
      "video",
      {
        ref: O,
        className: "size-full",
        src: i,
        poster: m,
        disablePictureInPicture: !0,
        playsInline: !0,
        onPlay: x,
        onPause: N,
        onEnded: N,
        onCanPlay: z,
        onWaiting: Z
      }
    ),
    R ? /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsxs(
        "div",
        {
          className: ge(
            "absolute inset-x-0 bottom-0 cursor-auto space-y-2 bg-gradient-to-t from-foreground to-transparent p-4 pr-12 pt-8 transition-opacity duration-300",
            ee ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"
          ),
          onMouseDownCapture: (S) => S.stopPropagation(),
          children: [
            /* @__PURE__ */ u.jsxs("div", { className: "flex items-center justify-between text-background", children: [
              /* @__PURE__ */ u.jsxs(
                "div",
                {
                  className: "flex items-center gap-x-4",
                  children: [
                    /* @__PURE__ */ u.jsx(
                      gt,
                      {
                        shape: "icon",
                        variant: "ghost",
                        color: "neutral",
                        onClick: U,
                        children: /* @__PURE__ */ u.jsx(Kp, { className: "size-full" })
                      }
                    ),
                    Y && /* @__PURE__ */ u.jsxs("span", { className: "text-sm", children: [
                      K(Y.currentTime),
                      " /",
                      " ",
                      K(Y.duration)
                    ] })
                  ]
                }
              ),
              X && /* @__PURE__ */ u.jsxs(
                "div",
                {
                  className: "group/volume flex items-center gap-x-4 rounded-ui-md p-2 transition-colors hover:bg-foreground/25",
                  children: [
                    /* @__PURE__ */ u.jsx(
                      "div",
                      {
                        className: `w-12 cursor-pointer py-1 opacity-0 transition-opacity ${X.isMuted ? "group-hover/volume:opacity-50" : "group-hover/volume:opacity-100"}`,
                        onClick: j,
                        children: /* @__PURE__ */ u.jsx(fc, { progress: X.volume })
                      }
                    ),
                    /* @__PURE__ */ u.jsx(
                      "div",
                      {
                        className: "size-5 cursor-pointer",
                        onClick: () => Q(!X.isMuted),
                        children: X.isMuted ? /* @__PURE__ */ u.jsx(Jp, { className: "size-full" }) : /* @__PURE__ */ u.jsx(qp, { className: "size-full" })
                      }
                    )
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ u.jsx(
              "div",
              {
                className: "cursor-pointer py-1",
                onClick: de,
                children: /* @__PURE__ */ u.jsx(fc, { progress: fe })
              }
            )
          ]
        }
      ),
      V && /* @__PURE__ */ u.jsx(
        "div",
        {
          className: "pointer-events-none absolute inset-0 flex items-center justify-center bg-foreground/25",
          children: /* @__PURE__ */ u.jsx(Tc, { size: "lg", color: "background" })
        }
      )
    ] }) : /* @__PURE__ */ u.jsx(
      "div",
      {
        className: "absolute inset-0 flex items-center justify-center bg-foreground/25",
        children: /* @__PURE__ */ u.jsx(Xp, { onClick: E })
      }
    )
  ] });
}, tm = ({ index: i, item: m, isShown: s }) => {
  const { type: y } = m;
  let C;
  switch (y) {
    case "image":
      C = /* @__PURE__ */ u.jsx(Ac, { itemIndex: i, onlyPreload: !s, ...m });
      break;
    case "video":
      C = /* @__PURE__ */ u.jsx(em, { itemIndex: i, ...m });
      break;
    case "360":
      C = /* @__PURE__ */ u.jsx(Qp, { itemIndex: i, onlyPreload: !s, ...m });
      break;
    case "custom":
      C = /* @__PURE__ */ u.jsx(Ap, { itemIndex: i, ...m });
  }
  return C = /* @__PURE__ */ u.jsx("div", { className: "-ml-px h-full w-[calc(100%+2px)]", children: C }), C;
}, nm = (i) => {
  h.useEffect(() => {
    const m = (s) => {
      s.key === "Escape" && i();
    };
    return addEventListener("keydown", m), () => {
      removeEventListener("keydown", m);
    };
  }, [i]);
};
function rm(i) {
  return i.target === i.currentTarget;
}
const am = ({ currentIndex: i, maxIndex: m }) => /* @__PURE__ */ u.jsxs("div", { className: "space-x-0.5 rounded-ui bg-foreground/40 px-1.5 py-0.5 text-xs text-background/75 transition-radius small:space-x-1 small:px-2 small:py-1 small:text-sm", children: [
  /* @__PURE__ */ u.jsx("span", { children: i + 1 }),
  /* @__PURE__ */ u.jsx("span", { children: "/" }),
  /* @__PURE__ */ u.jsx("span", { children: m + 1 })
] }), pc = ({ className: i }) => /* @__PURE__ */ u.jsx(Ye, { className: i, customizationKey: "UI_ARROW_RIGHT", children: /* @__PURE__ */ u.jsx("svg", { className: i, viewBox: "0 0 16 16", fill: "none", children: /* @__PURE__ */ u.jsx(
  "path",
  {
    d: "M4.07666 13.4868L5.25666 14.6668L11.9233 8.00016L5.25666 1.3335L4.07666 2.5135L9.56333 8.00016L4.07666 13.4868Z",
    fill: "currentColor"
  }
) }) }), lm = ({ className: i }) => /* @__PURE__ */ u.jsx(Ye, { className: i, customizationKey: "UI_EXTEND", children: /* @__PURE__ */ u.jsx("svg", { className: i, viewBox: "0 0 16 16", fill: "none", children: /* @__PURE__ */ u.jsx(
  "path",
  {
    d: "M4.66683 9.3335H3.3335V12.6668H6.66683V11.3335H4.66683V9.3335ZM3.3335 6.66683H4.66683V4.66683H6.66683V3.3335H3.3335V6.66683ZM11.3335 11.3335H9.3335V12.6668H12.6668V9.3335H11.3335V11.3335ZM9.3335 3.3335V4.66683H11.3335V6.66683H12.6668V3.3335H9.3335Z",
    fill: "currentColor"
  }
) }) }), om = ({ className: i }) => /* @__PURE__ */ u.jsx(Ye, { className: i, customizationKey: "UI_GALLERY", children: /* @__PURE__ */ u.jsx("svg", { className: i, viewBox: "0 0 16 16", fill: "none", children: /* @__PURE__ */ u.jsx(
  "path",
  {
    d: "M13.3334 2.66683V10.6668H5.33337V2.66683H13.3334ZM13.3334 1.3335H5.33337C4.60004 1.3335 4.00004 1.9335 4.00004 2.66683V10.6668C4.00004 11.4002 4.60004 12.0002 5.33337 12.0002H13.3334C14.0667 12.0002 14.6667 11.4002 14.6667 10.6668V2.66683C14.6667 1.9335 14.0667 1.3335 13.3334 1.3335ZM7.66671 7.78016L8.79337 9.28683L10.4467 7.22016L12.6667 10.0002H6.00004L7.66671 7.78016ZM1.33337 4.00016V13.3335C1.33337 14.0668 1.93337 14.6668 2.66671 14.6668H12V13.3335H2.66671V4.00016H1.33337Z",
    fill: "currentColor"
  }
) }) }), im = ({ className: i }) => /* @__PURE__ */ u.jsx(Ye, { className: i, customizationKey: "UI_HOTSPOTS", children: /* @__PURE__ */ u.jsxs(
  "svg",
  {
    className: i,
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ u.jsx("g", { clipPath: "url(#clip0_418_982)", children: /* @__PURE__ */ u.jsx(
        "path",
        {
          d: "M6 4C4.895 4 4 4.895 4 6C4 7.105 4.895 8 6 8C7.105 8 8 7.105 8 6C8 4.895 7.105 4 6 4ZM10.47 5.5C10.24 3.415 8.585 1.76 6.5 1.53V0.5H5.5V1.53C3.415 1.76 1.76 3.415 1.53 5.5H0.5V6.5H1.53C1.76 8.585 3.415 10.24 5.5 10.47V11.5H6.5V10.47C8.585 10.24 10.24 8.585 10.47 6.5H11.5V5.5H10.47ZM6 9.5C4.065 9.5 2.5 7.935 2.5 6C2.5 4.065 4.065 2.5 6 2.5C7.935 2.5 9.5 4.065 9.5 6C9.5 7.935 7.935 9.5 6 9.5Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ u.jsx("defs", { children: /* @__PURE__ */ u.jsx("clipPath", { id: "clip0_418_982", children: /* @__PURE__ */ u.jsx("rect", { width: "12", height: "12", fill: "white" }) }) })
    ]
  }
) }), sm = ({ className: i }) => /* @__PURE__ */ u.jsx(Ye, { className: i, customizationKey: "UI_MINUS", children: /* @__PURE__ */ u.jsx(
  "svg",
  {
    className: i,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ u.jsx(
      "path",
      {
        d: "M12.6666 8.66634H3.33325V7.33301H12.6666V8.66634Z",
        fill: "currentColor"
      }
    )
  }
) }), um = ({ className: i }) => /* @__PURE__ */ u.jsx(Ye, { className: i, customizationKey: "UI_PLUS", children: /* @__PURE__ */ u.jsx(
  "svg",
  {
    className: i,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ u.jsx(
      "path",
      {
        d: "M12.6666 8.66634H8.66659V12.6663H7.33325V8.66634H3.33325V7.33301H7.33325V3.33301H8.66659V7.33301H12.6666V8.66634Z",
        fill: "currentColor"
      }
    )
  }
) }), cm = ({ className: i }) => /* @__PURE__ */ u.jsx(Ye, { className: i, customizationKey: "UI_REDUCE", children: /* @__PURE__ */ u.jsx("svg", { className: i, viewBox: "0 0 16 16", fill: "none", children: /* @__PURE__ */ u.jsx(
  "path",
  {
    d: "M3.33325 10.6668H5.33325V12.6668H6.66659V9.3335H3.33325V10.6668ZM5.33325 5.3335H3.33325V6.66683H6.66659V3.3335H5.33325V5.3335ZM9.33325 12.6668H10.6666V10.6668H12.6666V9.3335H9.33325V12.6668ZM10.6666 5.3335V3.3335H9.33325V6.66683H12.6666V5.3335H10.6666Z",
    fill: "currentColor"
  }
) }) }), dm = ({
  enabled: i,
  onToggle: m,
  label: s,
  className: y,
  children: C
}) => /* @__PURE__ */ u.jsxs(
  "label",
  {
    className: ge(
      "flex cursor-pointer items-center justify-center gap-x-2",
      y
    ),
    children: [
      /* @__PURE__ */ u.jsx(
        "input",
        {
          type: "checkbox",
          className: "sr-only",
          checked: i,
          onChange: m
        }
      ),
      s && /* @__PURE__ */ u.jsx("div", { className: "text-xs text-background", children: s }),
      /* @__PURE__ */ u.jsx(
        "div",
        {
          className: ge(
            "flex h-5 w-8 items-center justify-center rounded-full transition-colors",
            i ? "bg-primary" : "bg-background/60"
          ),
          children: /* @__PURE__ */ u.jsx(
            "div",
            {
              className: ge(
                "flex size-4 items-center justify-center rounded-full p-0.5 transition",
                i ? "translate-x-1.5 bg-primary-foreground text-primary" : "-translate-x-1.5 bg-background text-foreground"
              ),
              children: C
            }
          )
        }
      )
    ]
  }
), fm = ({ className: i }) => /* @__PURE__ */ u.jsx(Ye, { className: i, customizationKey: "UI_BURGER", children: /* @__PURE__ */ u.jsx(
  "svg",
  {
    className: i,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ u.jsx(
      "path",
      {
        d: "M2 12H14V10.6667H2V12ZM2 8.66667H14V7.33333H2V8.66667ZM2 4V5.33333H14V4H2Z",
        fill: "currentColor"
      }
    )
  }
) }), pm = ({ sharedClassName: i }) => {
  const { categories: m } = pn(), { displayedCategoryId: s, changeCategory: y } = ut(), [C, _] = h.useState(!1), O = () => {
    _(!C);
  }, M = () => {
    _(!1);
  };
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    C && /* @__PURE__ */ u.jsx(
      "div",
      {
        className: ge(i, "inset-0 small:hidden"),
        onClick: M
      }
    ),
    /* @__PURE__ */ u.jsxs(
      "div",
      {
        className: ge(
          i,
          ar("top-left"),
          "flex gap-x-2 small:hidden"
        ),
        children: [
          /* @__PURE__ */ u.jsx(
            gt,
            {
              shape: "icon",
              color: C ? "primary" : "neutral",
              onClick: O,
              children: /* @__PURE__ */ u.jsx(fm, {})
            }
          ),
          C && /* @__PURE__ */ u.jsx("div", { className: "rounded-ui-md bg-background transition-radius", children: /* @__PURE__ */ u.jsx("ul", { className: "space-y-0.5 p-1", children: m.map(({ id: E, title: U }) => /* @__PURE__ */ u.jsx(
            "li",
            {
              className: ge(
                "cursor-pointer rounded-ui px-2 py-1 text-sm font-bold transition-all hover:bg-primary/30",
                E === s && "bg-primary/50"
              ),
              onClick: () => {
                y(E), _(!1);
              },
              children: U
            },
            E
          )) }) })
        ]
      }
    ),
    /* @__PURE__ */ u.jsx(
      "div",
      {
        className: ge(
          i,
          jc("top"),
          "w-full overflow-x-auto max-small:hidden"
        ),
        children: /* @__PURE__ */ u.jsx("div", { className: "mx-auto flex w-fit gap-x-1 rounded-ui-md bg-background p-1 shadow", children: m.map(({ id: E, title: U }) => /* @__PURE__ */ u.jsx(
          gt,
          {
            variant: E === s ? "fill" : "ghost",
            onClick: () => y(E),
            children: U
          },
          E
        )) })
      }
    )
  ] });
}, mm = () => {
  const { hideCategories: i, infiniteCarrousel: m, permanentGallery: s } = St(), { aspectRatioStyle: y } = pn(), {
    items: { length: C },
    slidable: _,
    carrouselItemIndex: O,
    masterItemIndex: M,
    prevItem: E,
    nextItem: U,
    showGalleryControls: R,
    enableHotspotsControl: L,
    showHotspots: V,
    toggleHotspots: W,
    showGallery: x,
    toggleGallery: N,
    extendMode: z,
    toggleExtendMode: Z,
    shownDetails: X,
    isShowingDetails: H,
    resetShownDetails: j,
    showZoomControls: Q,
    isZooming: Y,
    canZoomIn: q,
    zoomIn: fe,
    canZoomOut: de,
    zoomOut: K,
    resetView: ee
  } = ut(), ae = h.useCallback(
    (se) => {
      rm(se) && j();
    },
    [j]
  );
  nm(j);
  const ne = "absolute z-overlay";
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    !i && /* @__PURE__ */ u.jsx(
      pm,
      {
        sharedClassName: ge(
          ne,
          "transition-opacity",
          Y ? "!pointer-events-none opacity-0" : "opacity-100"
        )
      }
    ),
    _ && !Y && /* @__PURE__ */ u.jsx("div", { className: ge(ne, ar("top-right")), children: /* @__PURE__ */ u.jsx(
      am,
      {
        currentIndex: O,
        maxIndex: C - 1
      }
    ) }),
    _ && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsx(
        gt,
        {
          shape: "icon",
          color: "neutral",
          className: ge(
            ne,
            ar("middle-left"),
            Y ? "!pointer-events-none opacity-0" : "opacity-100"
          ),
          onClick: E,
          disabled: !m && M <= 0,
          children: /* @__PURE__ */ u.jsx(Ye, { customizationKey: "CONTROLS_PREV", children: /* @__PURE__ */ u.jsx(pc, { className: "size-full -scale-x-100" }) })
        }
      ),
      /* @__PURE__ */ u.jsx(
        gt,
        {
          shape: "icon",
          color: "neutral",
          className: ge(
            ne,
            ar("middle-right"),
            Y ? "!pointer-events-none opacity-0" : "opacity-100"
          ),
          onClick: U,
          disabled: !m && M >= C - 1,
          children: /* @__PURE__ */ u.jsx(Ye, { customizationKey: "CONTROLS_NEXT", children: /* @__PURE__ */ u.jsx(pc, { className: "size-full" }) })
        }
      )
    ] }),
    /* @__PURE__ */ u.jsxs(
      "div",
      {
        className: ge(
          ne,
          ar("bottom-fullW"),
          "pointer-events-none grid grid-cols-[auto,1fr,auto] items-end *:pointer-events-auto small:gap-x-2"
        ),
        children: [
          !s && _ && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
            /* @__PURE__ */ u.jsx(
              gt,
              {
                className: R && !Y ? "opacity-100" : "!pointer-events-none opacity-0",
                variant: "fill",
                color: x ? "primary" : "neutral",
                shape: "icon",
                onClick: N,
                children: /* @__PURE__ */ u.jsx(om, { className: "size-full" })
              }
            ),
            x && /* @__PURE__ */ u.jsx(
              Hc,
              {
                className: ge(
                  "transition-opacity",
                  R && !Y ? "opacity-100" : "!pointer-events-none opacity-0",
                  // Left & Right gradient mask to fade the gallery
                  "[mask-image:linear-gradient(to_left,transparent_0px,black_4px,black_calc(100%-4px),transparent_100%)]"
                ),
                containerClassName: "mx-1"
              }
            )
          ] }),
          /* @__PURE__ */ u.jsxs("div", { className: "col-start-3 flex flex-col items-end gap-y-1 small:gap-y-2", children: [
            L && /* @__PURE__ */ u.jsx(
              dm,
              {
                className: ge(
                  "transition-opacity",
                  Y ? "!pointer-events-none opacity-0" : "opacity-100"
                ),
                enabled: V,
                onToggle: W,
                children: /* @__PURE__ */ u.jsx(im, { className: "size-full" })
              }
            ),
            Q && /* @__PURE__ */ u.jsxs("div", { className: "max-small:hidden", children: [
              /* @__PURE__ */ u.jsx(
                gt,
                {
                  className: "rounded-b-none",
                  color: "neutral",
                  shape: "icon",
                  disabled: !q,
                  onClick: fe,
                  children: /* @__PURE__ */ u.jsx(um, { className: "size-full" })
                }
              ),
              /* @__PURE__ */ u.jsx(Vc, { color: "background" }),
              /* @__PURE__ */ u.jsx(
                gt,
                {
                  className: "rounded-t-none",
                  color: "neutral",
                  shape: "icon",
                  disabled: !de,
                  onClick: K,
                  children: /* @__PURE__ */ u.jsx(sm, { className: "size-full" })
                }
              )
            ] }),
            /* @__PURE__ */ u.jsx(
              gt,
              {
                variant: "fill",
                color: z ? "primary" : "neutral",
                shape: "icon",
                onClick: Z,
                children: z ? /* @__PURE__ */ u.jsx(cm, { className: "size-full" }) : /* @__PURE__ */ u.jsx(lm, { className: "size-full" })
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ u.jsx(
      "div",
      {
        className: ge(
          ne,
          "inset-0 flex justify-end overflow-hidden bg-foreground/60 transition-opacity duration-details",
          H ? "opacity-100" : "pointer-events-none opacity-0"
        ),
        onClick: ae,
        children: /* @__PURE__ */ u.jsx(
          "div",
          {
            className: ge(
              "h-full w-3/5 bg-background transition-transform duration-details",
              H ? "translate-x-0" : "translate-x-full"
            ),
            children: !!X && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
              /* @__PURE__ */ u.jsx(
                lr,
                {
                  className: "w-full bg-foreground/65",
                  style: y,
                  src: X.src,
                  imgInPlayerWidthRatio: 0.6
                }
              ),
              /* @__PURE__ */ u.jsxs(
                "div",
                {
                  className: ge(
                    "space-y-1 px-2 py-1 small:p-3",
                    z && "large:p-4"
                  ),
                  children: [
                    X.title && /* @__PURE__ */ u.jsx(
                      "span",
                      {
                        className: ge(
                          "text-sm font-semibold small:text-base small:font-bold",
                          z && "large:text-lg"
                        ),
                        children: X.title
                      }
                    ),
                    X.text && /* @__PURE__ */ u.jsx(
                      "p",
                      {
                        className: ge(
                          "text-xs text-foreground/65 small:text-sm",
                          z && "large:text-base"
                        ),
                        children: X.text
                      }
                    )
                  ]
                }
              )
            ] })
          }
        )
      }
    ),
    (Y || H) && /* @__PURE__ */ u.jsx(
      Ic,
      {
        className: ge(ne, ar("top-right")),
        onClick: ee
      }
    )
  ] });
}, hm = ({ className: i = "" }) => {
  const { infiniteCarrousel: m, preloadRange: s, isFullScreen: y } = St(), { aspectRatioStyle: C } = pn(), {
    items: _,
    slidable: O,
    carrouselItemIndex: M,
    setCarrouselItemIndex: E,
    itemIndexCommand: U,
    setItemIndexCommand: R,
    specialCommand: L,
    isRunningSpecialCommand: V,
    finishSpecialCommand: W,
    extendMode: x,
    extendTransition: N
  } = ut(), z = h.useRef(null), Z = h.useCallback((D) => {
    if (!z.current)
      throw new Error(`[${D ?? "sliderOrThrow"}] slider.current is null`);
    return z.current;
  }, []), X = h.useRef(!1), H = h.useRef(null), j = h.useRef(null), Q = h.useRef(null), Y = h.useCallback(() => {
    Q.current && cancelAnimationFrame(Q.current);
  }, []), q = h.useCallback(() => {
    const D = Z("computeClosestSnapIndex"), S = Array.from(D.children), B = D.scrollLeft, w = S.reduce(
      ($, F, p) => {
        const k = F.offsetLeft;
        return Math.abs(k - B) < Math.abs(S[$].offsetLeft - B) ? p : $;
      },
      0
    );
    return L === "first_to_last" ? sc(w, _.length) : L === "last_to_first" ? sc(w - 1, _.length) : w;
  }, [L, Z, _.length]), fe = h.useCallback(
    (D) => {
      const S = Z("setStyleCursor");
      S.style.cursor = D;
    },
    [Z]
  ), de = h.useCallback(
    (D) => {
      const S = Z("setStyleSnapState");
      D === "mandatory" ? S.style.scrollSnapType = "x mandatory" : S.style.scrollSnapType = "none";
    },
    [Z]
  ), K = h.useCallback(
    (D, S, B) => {
      Y();
      const w = Z("scrollToIndex"), $ = Array.from(w.children), F = w.scrollLeft, p = $[D].offsetLeft, k = (ye) => {
        w.scrollTo({
          left: ye,
          behavior: "instant"
        });
      }, oe = () => {
        k(p), de("mandatory"), B?.();
      }, ie = Math.abs(F - p);
      if (ie < 1 || S === "instant") {
        oe();
        return;
      }
      const me = zn(ie / 2.5, 300, 1e3), ve = (/* @__PURE__ */ new Date()).getTime();
      de("none");
      const we = () => {
        const ye = () => {
          const Ce = (/* @__PURE__ */ new Date()).getTime() - ve;
          if (Ce >= me) {
            oe();
            return;
          }
          const Be = Math.min(Ce / me, 1), Bt = $c(Be), jt = il(F, p, Bt);
          k(jt), we();
        };
        Q.current = requestAnimationFrame(ye);
      };
      we();
    },
    [Y, Z, de]
  ), [ee, ae] = h.useState(), ne = !!ee;
  h.useEffect(() => {
    const D = () => {
      clearTimeout(ee);
      const S = setTimeout(() => {
        ae(void 0);
      }, _c);
      ae(S);
    };
    return addEventListener("resize", D), document.addEventListener("fullscreenchange", D), () => {
      removeEventListener("resize", D), document.removeEventListener("fullscreenchange", D);
    };
  }, [ee]), h.useEffect(() => {
    const D = q();
    Number.isNaN(D) || D !== M && K(M, "instant");
  }, [
    M,
    K,
    q,
    // - Run the effect when those values change
    _,
    ee,
    y,
    x,
    N
  ]), h.useEffect(() => {
    if (!O || V) {
      fe("auto");
      return;
    }
    const D = z.current;
    if (!D)
      return;
    fe("grab"), de("mandatory");
    const S = ($) => {
      $.button === 0 && ($.preventDefault(), $.stopPropagation(), Y(), X.current = !0, H.current = $.pageX - D.offsetLeft, j.current = D.scrollLeft, fe("grabbing"));
    }, B = ($) => {
      if (!X.current)
        return;
      if (H.current === null)
        throw new Error("[onMouseMove] startX is null");
      de("none");
      const F = $.pageX - D.offsetLeft - H.current;
      requestAnimationFrame(() => {
        if (j.current === null)
          throw new Error("[onMouseMove] scrollLeft is null");
        D.scrollLeft = j.current - F;
      });
    }, w = () => {
      if (!X.current)
        return;
      X.current = !1, fe("grab");
      const $ = q();
      K($, "smooth");
    };
    return D.addEventListener("mousedown", S), document.addEventListener("mousemove", B), document.addEventListener("mouseleave", w), document.addEventListener("mouseup", w), document.addEventListener("contextmenu", w), () => {
      D.removeEventListener("mousedown", S), document.removeEventListener("mousemove", B), document.removeEventListener("mouseleave", w), document.removeEventListener("mouseup", w), document.removeEventListener("contextmenu", w);
    };
  }, [
    Y,
    q,
    V,
    K,
    fe,
    de,
    O
  ]), h.useEffect(() => {
    if (N || ne)
      return;
    const D = z.current;
    if (!D)
      return;
    const S = () => {
      const B = q();
      Number.isNaN(B) || (E(B), B === U && R(null));
    };
    return D.addEventListener("scroll", S), () => {
      D.removeEventListener("scroll", S);
    };
  }, [
    q,
    N,
    V,
    ne,
    U,
    _.length,
    E,
    R
  ]), h.useEffect(() => {
    if (U === null)
      return;
    const D = () => W();
    switch (L) {
      case "first_to_last":
        K(_.length, "instant"), K(_.length - 1, "smooth", D);
        break;
      case "last_to_first":
        K(0, "instant"), K(1, "smooth", D);
        break;
      case "instant":
        K(U, "instant", D);
        break;
      default:
        K(U, "smooth");
        break;
    }
  }, [
    L,
    W,
    U,
    _.length,
    K
  ]);
  const se = () => /* @__PURE__ */ u.jsx("div", { className: "h-full", style: C });
  return /* @__PURE__ */ u.jsxs(
    "div",
    {
      className: ge(
        "relative overflow-hidden rounded-carrousel transition-radius",
        i
      ),
      style: C,
      children: [
        /* @__PURE__ */ u.jsxs(
          "div",
          {
            ref: z,
            className: `flex size-full ${O ? "overflow-x-auto no-scrollbar *:snap-start *:snap-always" : "justify-center"}`,
            children: [
              L === "last_to_first" && /* @__PURE__ */ u.jsx(se, {}),
              _.map((D, S) => {
                const B = S === M, w = S === 0, $ = S === _.length - 1, F = (() => {
                  if (L === "first_to_last" && w)
                    return {
                      transform: `translateX(${100 * _.length}%)`
                    };
                  if (L === "last_to_first" && $)
                    return {
                      transform: `translateX(-${100 * _.length}%)`
                    };
                })();
                let p = Math.abs(S - M) <= s;
                p ||= S === U, m && (p ||= M < s && _.length - S <= s - M, p ||= M >= _.length - s && S <= s - (_.length - M));
                const k = (() => {
                  let oe;
                  switch (D.type) {
                    case "360":
                      oe = D.images[0].src;
                      break;
                    case "image":
                      oe = D.src;
                      break;
                    case "video":
                      oe = D.poster ?? "video";
                      break;
                    case "custom":
                      oe = "custom";
                      break;
                  }
                  return `${S}_${oe}`;
                })();
                return /* @__PURE__ */ u.jsx(
                  "div",
                  {
                    className: ge(
                      "h-full bg-foreground/35",
                      M === S && "z-1"
                      // Give high-ground to the shown item (to avoid 1px vertical line)
                    ),
                    style: { ...C, ...F },
                    children: p && /* @__PURE__ */ u.jsx(tm, { index: S, item: D, isShown: B })
                  },
                  k
                );
              }),
              L === "first_to_last" && /* @__PURE__ */ u.jsx(se, {})
            ]
          }
        ),
        /* @__PURE__ */ u.jsx(mm, {})
      ]
    }
  );
}, gm = () => {
  const { permanentGallery: i } = St(), { aspectRatioStyle: m } = pn(), {
    prevItem: s,
    nextItem: y,
    isShowingDetails: C,
    resetShownDetails: _,
    extendMode: O,
    disableExtendMode: M,
    isZooming: E,
    resetZoom: U,
    fakeFullScreen: R
  } = ut(), L = h.useRef(null), V = h.useRef(null), W = h.useRef(null);
  return h.useEffect(() => {
    if (!O)
      return;
    const x = L.current, N = V.current, z = W.current;
    if (!x || !N || !z)
      return;
    let Z = !1;
    const X = (Q) => [x, N, z].includes(Q.target), H = (Q) => {
      Z = X(Q);
    }, j = (Q) => {
      Z && (X(Q) && M(), Z = !1);
    };
    return x.addEventListener("mousedown", H), x.addEventListener("mouseup", j), () => {
      x.removeEventListener("mousedown", H), x.removeEventListener("mouseup", j);
    };
  }, [M, O]), h.useEffect(() => {
    const x = (N) => {
      N.key === "Escape" && (E ? U() : C ? _() : M());
    };
    return addEventListener("keydown", x), () => {
      removeEventListener("keydown", x);
    };
  }, [
    M,
    C,
    E,
    y,
    s,
    _,
    U
  ]), /* @__PURE__ */ u.jsxs(
    "div",
    {
      ref: L,
      className: ge(
        R ? "fixed inset-0 z-overlay" : "relative",
        O && "flex size-full items-center justify-center bg-foreground/75"
      ),
      children: [
        /* @__PURE__ */ u.jsxs(
          "div",
          {
            ref: V,
            className: O ? "flex size-full flex-col justify-center gap-y-2 small:gap-y-4" : "space-y-2",
            children: [
              /* @__PURE__ */ u.jsx(
                "div",
                {
                  ref: W,
                  className: ge(
                    O && "mx-auto flex min-h-0 w-full max-w-[1600px] justify-center"
                  ),
                  style: m,
                  children: /* @__PURE__ */ u.jsx(hm, { className: ge(O && "h-full min-w-0") })
                }
              ),
              i && /* @__PURE__ */ u.jsx(Hc, { className: ge(O && "my-2 shrink-0 small:my-4") })
            ]
          }
        ),
        O && /* @__PURE__ */ u.jsx(
          Ic,
          {
            className: "absolute right-2 top-2 small:right-4 small:top-4",
            onClick: M
          }
        )
      ]
    }
  );
}, vm = () => {
  const { emitEvent: i, compositionUrl: m } = St(), {
    data: s,
    status: y,
    isSuccess: C,
    error: _
  } = xp(m);
  return h.useEffect(() => {
    _ ? i(np, _) : y === "fetching" ? i(ep, m) : C && i(tp, s);
  }, [s, m, i, _, C, y]), _ ? /* @__PURE__ */ u.jsx(
    Rc,
    {
      className: "aspect-square text-foreground/70",
      text: "Player could not be loaded"
    }
  ) : C ? /* @__PURE__ */ u.jsx(Cp, { composition: s, children: /* @__PURE__ */ u.jsx(Ep, { children: /* @__PURE__ */ u.jsx(gm, {}) }) }) : /* @__PURE__ */ u.jsxs("div", { className: "flex aspect-square size-full flex-col items-center justify-center gap-y-4", children: [
    /* @__PURE__ */ u.jsx("div", { className: "animate-pulse text-xl", children: "Loading Player" }),
    /* @__PURE__ */ u.jsx(Tc, { color: "foreground" })
  ] });
}, bm = ({
  compositionUrl: i,
  hideCategories: m = !1,
  infiniteCarrousel: s = !1,
  permanentGallery: y = !1,
  mediaLoadStrategy: C = cp,
  minMediaWidth: _ = 0,
  maxMediaWidth: O = 1 / 0,
  preloadRange: M = 1,
  preventFullScreen: E = !1,
  eventPrefix: U = dp,
  reverse360: R = !1,
  children: L
  // NOTE: use to customize the player, not to display the content
}) => {
  const V = h.useRef(null), [W, x] = h.useState(0.5), [N, z] = h.useState(!1), Z = h.useCallback(
    (j, Q) => {
      const Y = U + j, q = new CustomEvent(Y, { detail: Q });
      document.dispatchEvent(q);
    },
    [U]
  );
  h.useEffect(() => {
    if (N) {
      x(1);
      return;
    }
    if (!V.current)
      return;
    const j = V.current, Q = () => {
      const Y = window.innerWidth, q = j.clientWidth;
      x(q / Y);
    };
    return Q(), addEventListener("resize", Q), () => {
      removeEventListener("resize", Q);
    };
  }, [N]), h.useEffect(() => {
    if (E)
      return;
    const j = V.current;
    if (!j)
      throw new Error("Wrapper not found");
    const Q = () => {
      const { fullscreenElement: Y } = document;
      z(
        Y === j || // NOTE: For custom element, the web browser is making the whole custom element full-screen and not only the wrapper
        Y?.localName === cl
      );
    };
    return document.addEventListener("fullscreenchange", Q), () => {
      document.removeEventListener("fullscreenchange", Q);
    };
  }, [E]);
  const X = h.useCallback(async () => {
    const j = V.current;
    if (!j)
      throw new Error("Wrapper not found");
    try {
      return await j.requestFullscreen(), !0;
    } catch {
      return !1;
    }
  }, []), H = h.useCallback(async () => {
    try {
      return await document.exitFullscreen(), !0;
    } catch {
      return !1;
    }
  }, []);
  return /* @__PURE__ */ u.jsx(
    kp,
    {
      compositionUrl: i,
      hideCategories: m,
      infiniteCarrousel: s,
      permanentGallery: y,
      mediaLoadStrategy: C,
      minMediaWidth: _,
      maxMediaWidth: O,
      preloadRange: M,
      preventFullScreen: E,
      reverse360: R,
      emitEvent: Z,
      playerInViewportWidthRatio: W,
      isFullScreen: N,
      requestFullscreen: X,
      exitFullscreen: H,
      children: /* @__PURE__ */ u.jsxs(Sp, { children: [
        /* @__PURE__ */ u.jsx(
          "div",
          {
            id: "cc-webplayer-wrapper",
            ref: V,
            className: "select-none text-foreground",
            children: /* @__PURE__ */ u.jsx(vm, {})
          }
        ),
        L
      ] })
    }
  );
}, ym = ({ children: i, index: m, thumbnailSrc: s }) => {
  const { registerCustomMedia: y, unregisterCustomMedia: C } = Zr();
  return h.useEffect(() => {
    if (!i)
      return;
    const _ = y({
      Media: i,
      index: m,
      thumbnailSrc: s
    });
    return () => {
      C(_);
    };
  }, [i, C, m, y, s]), null;
}, wm = (i) => ci() ? /* @__PURE__ */ u.jsx(ym, { ...i }) : /* @__PURE__ */ u.jsx("slot", {}), xm = ({ name: i, children: m }) => {
  const { registerIconConfig: s, unregisterIconConfig: y } = Zr();
  return h.useEffect(() => {
    if (m)
      return s(i, {
        Icon: m
      }), () => {
        y(i);
      };
  }, [m, i, s, y]), null;
}, km = (i) => ci() ? /* @__PURE__ */ u.jsx(xm, { ...i }) : /* @__PURE__ */ u.jsx("slot", {}), Cm = '*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}#cc-webplayer-wrapper{--background: var(--cc-webplayer-background, 0 0% 100%);--foreground: var(--cc-webplayer-foreground, 240 10% 3.9%);--primary: var(--cc-webplayer-primary, 216 100% 52%);--primary-foreground: var( --cc-webplayer-primary-foreground, var(--background) );--primary-light: var(--cc-webplayer-primary-light, var(--primary));--neutral: var(--cc-webplayer-neutral, 0 0% 39%);--neutral-foreground: var( --cc-webplayer-neutral-foreground, var(--foreground) );--radius-ui: var(--cc-webplayer-radius-ui, 1rem);--radius-carrousel: var(--cc-webplayer-radius-carrousel, 0);--radius-gallery: var(--cc-webplayer-radius-gallery, 0)}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }.\\!container{width:100%!important}.container{width:100%}@media (min-width: 1280px){.\\!container{max-width:1280px!important}.container{max-width:1280px}}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.\\!pointer-events-none{pointer-events:none!important}.pointer-events-none{pointer-events:none}.pointer-events-auto{pointer-events:auto}.invisible{visibility:hidden}.fixed{position:fixed}.\\!absolute{position:absolute!important}.absolute{position:absolute}.relative{position:relative}.sticky{position:sticky}.inset-0{inset:0}.inset-x-0{left:0;right:0}.inset-x-1{left:.25rem;right:.25rem}.inset-y-1{top:.25rem;bottom:.25rem}.-bottom-1{bottom:-.25rem}.-left-1{left:-.25rem}.-right-1{right:-.25rem}.-top-1{top:-.25rem}.bottom-0{bottom:0}.bottom-1{bottom:.25rem}.left-0{left:0}.left-1{left:.25rem}.left-1\\/2{left:50%}.right-1{right:.25rem}.right-2{right:.5rem}.top-0{top:0}.top-1{top:.25rem}.top-1\\/2{top:50%}.top-2{top:.5rem}.-z-10{z-index:-10}.-z-20{z-index:-20}.z-1{z-index:1}.z-hotspot{z-index:10}.z-overlay{z-index:30}.z-zoomed-image{z-index:20}.col-start-3{grid-column-start:3}.mx-1{margin-left:.25rem;margin-right:.25rem}.mx-auto{margin-left:auto;margin-right:auto}.my-2{margin-top:.5rem;margin-bottom:.5rem}.-ml-px{margin-left:-1px}.-mt-px{margin-top:-1px}.inline-block{display:inline-block}.flex{display:flex}.grid{display:grid}.hidden{display:none}.aspect-square{aspect-ratio:1 / 1}.size-1{width:.25rem;height:.25rem}.size-12{width:3rem;height:3rem}.size-20{width:5rem;height:5rem}.size-4{width:1rem;height:1rem}.size-5{width:1.25rem;height:1.25rem}.size-8{width:2rem;height:2rem}.size-full{width:100%;height:100%}.h-1{height:.25rem}.h-10{height:2.5rem}.h-20{height:5rem}.h-3\\/4{height:75%}.h-5{height:1.25rem}.h-8{height:2rem}.h-full{height:100%}.h-px{height:1px}.min-h-0{min-height:0px}.w-12{width:3rem}.w-3\\/5{width:60%}.w-8{width:2rem}.w-\\[calc\\(100\\%\\+1024px\\)\\]{width:calc(100% + 1024px)}.w-\\[calc\\(100\\%\\+2px\\)\\]{width:calc(100% + 2px)}.w-fit{width:-moz-fit-content;width:fit-content}.w-full{width:100%}.w-max{width:-moz-max-content;width:max-content}.w-px{width:1px}.min-w-0{min-width:0px}.max-w-40{max-width:10rem}.max-w-\\[1600px\\]{max-width:1600px}.shrink-0{flex-shrink:0}.origin-top-left{transform-origin:top left}.-translate-x-1\\.5{--tw-translate-x: -.375rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-translate-x-1\\/2{--tw-translate-x: -50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-translate-y-1\\/2{--tw-translate-y: -50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-x-0{--tw-translate-x: 0px;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-x-1\\.5{--tw-translate-x: .375rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-x-full{--tw-translate-x: 100%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.scale-100{--tw-scale-x: 1;--tw-scale-y: 1;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.scale-105{--tw-scale-x: 1.05;--tw-scale-y: 1.05;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-scale-x-100{--tw-scale-x: -1;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}@keyframes hotspot-ping{0%{transform:scale(0)}25%{opacity:1}75%,to{transform:scale(1.5);opacity:0}}.animate-hotspot-ping{animation:hotspot-ping 3s cubic-bezier(0,0,.2,1) infinite}@keyframes pulse{50%{opacity:1}0%,to{opacity:0}}.animate-pulse{animation:pulse 2s cubic-bezier(.4,0,.6,1) infinite}@keyframes rotation{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.animate-rotation{animation:rotation 1s linear infinite}.cursor-auto{cursor:auto}.cursor-ew-resize{cursor:ew-resize}.cursor-grab{cursor:grab}.cursor-grabbing{cursor:grabbing}.cursor-help{cursor:help}.cursor-move{cursor:move}.cursor-pointer{cursor:pointer}.resize{resize:both}.grid-cols-\\[auto\\,1fr\\,auto\\]{grid-template-columns:auto 1fr auto}.flex-col{flex-direction:column}.items-end{align-items:flex-end}.items-center{align-items:center}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.gap-1{gap:.25rem}.gap-x-1{-moz-column-gap:.25rem;column-gap:.25rem}.gap-x-2{-moz-column-gap:.5rem;column-gap:.5rem}.gap-x-4{-moz-column-gap:1rem;column-gap:1rem}.gap-y-1{row-gap:.25rem}.gap-y-2{row-gap:.5rem}.gap-y-4{row-gap:1rem}.space-x-0\\.5>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(.125rem * var(--tw-space-x-reverse));margin-left:calc(.125rem * calc(1 - var(--tw-space-x-reverse)))}.space-y-0\\.5>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.125rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(.125rem * var(--tw-space-y-reverse))}.space-y-1>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.25rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(.25rem * var(--tw-space-y-reverse))}.space-y-2>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.5rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(.5rem * var(--tw-space-y-reverse))}.overflow-hidden{overflow:hidden}.overflow-x-auto{overflow-x:auto}.overflow-x-scroll{overflow-x:scroll}.text-pretty{text-wrap:pretty}.rounded-carrousel{border-radius:var(--radius-carrousel)}.rounded-full{border-radius:9999px}.rounded-gallery{border-radius:var(--radius-gallery)}.rounded-ui{border-radius:var(--radius-ui)}.rounded-ui-md{border-radius:calc(var(--radius-ui) + .125rem)}.rounded-ui-sm{border-radius:calc(var(--radius-ui) - .125rem)}.rounded-b-none{border-bottom-right-radius:0;border-bottom-left-radius:0}.rounded-t-none{border-top-left-radius:0;border-top-right-radius:0}.border{border-width:1px}.border-2{border-width:2px}.border-4{border-width:4px}.border-background{border-color:hsl(var(--background))}.border-foreground{border-color:hsl(var(--foreground))}.border-primary{border-color:hsl(var(--primary))}.border-b-transparent{border-bottom-color:transparent}.bg-background{background-color:hsl(var(--background))}.bg-background\\/25{background-color:hsl(var(--background) / .25)}.bg-background\\/50{background-color:hsl(var(--background) / .5)}.bg-background\\/60{background-color:hsl(var(--background) / .6)}.bg-foreground\\/25{background-color:hsl(var(--foreground) / .25)}.bg-foreground\\/30{background-color:hsl(var(--foreground) / .3)}.bg-foreground\\/35{background-color:hsl(var(--foreground) / .35)}.bg-foreground\\/40{background-color:hsl(var(--foreground) / .4)}.bg-foreground\\/50{background-color:hsl(var(--foreground) / .5)}.bg-foreground\\/60{background-color:hsl(var(--foreground) / .6)}.bg-foreground\\/65{background-color:hsl(var(--foreground) / .65)}.bg-foreground\\/75{background-color:hsl(var(--foreground) / .75)}.bg-neutral\\/50{background-color:hsl(var(--neutral) / .5)}.bg-primary{background-color:hsl(var(--primary))}.bg-primary-foreground{background-color:hsl(var(--primary-foreground))}.bg-primary\\/50{background-color:hsl(var(--primary) / .5)}.bg-transparent{background-color:transparent}.bg-gradient-to-t{background-image:linear-gradient(to top,var(--tw-gradient-stops))}.from-foreground{--tw-gradient-from: hsl(var(--foreground)) var(--tw-gradient-from-position);--tw-gradient-to: hsl(var(--foreground) / 0) var(--tw-gradient-to-position);--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)}.to-transparent{--tw-gradient-to: transparent var(--tw-gradient-to-position)}.object-cover{-o-object-fit:cover;object-fit:cover}.p-0\\.5{padding:.125rem}.p-1{padding:.25rem}.p-2{padding:.5rem}.p-4{padding:1rem}.px-1\\.5{padding-left:.375rem;padding-right:.375rem}.px-2{padding-left:.5rem;padding-right:.5rem}.py-0\\.5{padding-top:.125rem;padding-bottom:.125rem}.py-1{padding-top:.25rem;padding-bottom:.25rem}.pl-6{padding-left:1.5rem}.pr-12{padding-right:3rem}.pr-4{padding-right:1rem}.pt-8{padding-top:2rem}.text-2xl{font-size:1.5rem;line-height:2rem}.text-sm{font-size:.875rem;line-height:1.25rem}.text-xl{font-size:1.25rem;line-height:1.75rem}.text-xs{font-size:.75rem;line-height:1rem}.font-bold{font-weight:700}.font-semibold{font-weight:600}.text-background{color:hsl(var(--background))}.text-background\\/75{color:hsl(var(--background) / .75)}.text-foreground{color:hsl(var(--foreground))}.text-foreground\\/65{color:hsl(var(--foreground) / .65)}.text-foreground\\/70{color:hsl(var(--foreground) / .7)}.text-neutral-foreground{color:hsl(var(--neutral-foreground))}.text-primary{color:hsl(var(--primary))}.text-primary-foreground{color:hsl(var(--primary-foreground))}.text-primary-light{color:hsl(var(--primary-light))}.opacity-0{opacity:0}.opacity-100{opacity:1}.shadow{--tw-shadow: 0 1px 3px 0 rgb(0 0 0 / .1), 0 1px 2px -1px rgb(0 0 0 / .1);--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.transition{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-\\[width\\]{transition-property:width;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-all{transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-colors{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-opacity{transition-property:opacity;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-radius{transition-property:border-radius;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-transform{transition-property:transform;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.duration-200{transition-duration:.2s}.duration-300{transition-duration:.3s}.duration-details{transition-duration:.35s}.no-scrollbar{scrollbar-width:none;-ms-overflow-style:none}.no-scrollbar::-webkit-scrollbar{display:none}.\\[mask-image\\:linear-gradient\\(to_left\\,transparent_0px\\,black_4px\\,black_calc\\(100\\%-4px\\)\\,transparent_100\\%\\)\\]{-webkit-mask-image:linear-gradient(to left,transparent 0px,black 4px,black calc(100% - 4px),transparent 100%);mask-image:linear-gradient(to left,transparent 0px,black 4px,black calc(100% - 4px),transparent 100%)}.\\*\\:pointer-events-auto>*{pointer-events:auto}.\\*\\:size-full>*{width:100%;height:100%}.\\*\\:snap-start>*{scroll-snap-align:start}.\\*\\:snap-always>*{scroll-snap-stop:always}.\\*\\:object-cover>*{-o-object-fit:cover;object-fit:cover}.after\\:absolute:after{content:var(--tw-content);position:absolute}.after\\:inset-0:after{content:var(--tw-content);inset:0}.after\\:rounded-gallery:after{content:var(--tw-content);border-radius:var(--radius-gallery)}.after\\:border-2:after{content:var(--tw-content);border-width:2px}.after\\:border-primary:after{content:var(--tw-content);border-color:hsl(var(--primary))}.after\\:opacity-0:after{content:var(--tw-content);opacity:0}.after\\:opacity-100:after{content:var(--tw-content);opacity:1}.after\\:transition-all:after{content:var(--tw-content);transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.hover\\:z-hotspot-hover:hover{z-index:11}.hover\\:bg-foreground\\/25:hover{background-color:hsl(var(--foreground) / .25)}.hover\\:bg-primary\\/25:hover{background-color:hsl(var(--primary) / .25)}.hover\\:bg-primary\\/30:hover{background-color:hsl(var(--primary) / .3)}.hover\\:opacity-80:hover{opacity:.8}.hover\\:after\\:opacity-70:hover:after{content:var(--tw-content);opacity:.7}.disabled\\:opacity-60:disabled{opacity:.6}.group:hover .group-hover\\:pointer-events-auto{pointer-events:auto}.group\\/volume:hover .group-hover\\/volume\\:opacity-100{opacity:1}.group\\/volume:hover .group-hover\\/volume\\:opacity-50{opacity:.5}.group:hover .group-hover\\:opacity-100{opacity:1}@media ((orientation: portrait) and (max-width: 767px)) or ((orientation: landscape) and (max-width: 1023px)){.max-small\\:hidden{display:none}}@media ((orientation: portrait) and (min-width: 768px)) or ((orientation: landscape) and (min-width: 1024px)){.small\\:inset-x-2{left:.5rem;right:.5rem}.small\\:inset-y-2{top:.5rem;bottom:.5rem}.small\\:bottom-2{bottom:.5rem}.small\\:left-2{left:.5rem}.small\\:right-2{right:.5rem}.small\\:right-4{right:1rem}.small\\:top-2{top:.5rem}.small\\:top-4{top:1rem}.small\\:my-4{margin-top:1rem;margin-bottom:1rem}.small\\:hidden{display:none}.small\\:h-12{height:3rem}.small\\:h-28{height:7rem}.small\\:max-w-48{max-width:12rem}.small\\:gap-2{gap:.5rem}.small\\:gap-x-2{-moz-column-gap:.5rem;column-gap:.5rem}.small\\:gap-y-2{row-gap:.5rem}.small\\:gap-y-4{row-gap:1rem}.small\\:space-x-1>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(.25rem * var(--tw-space-x-reverse));margin-left:calc(.25rem * calc(1 - var(--tw-space-x-reverse)))}.small\\:p-3{padding:.75rem}.small\\:px-2{padding-left:.5rem;padding-right:.5rem}.small\\:py-1{padding-top:.25rem;padding-bottom:.25rem}.small\\:pl-8{padding-left:2rem}.small\\:pr-6{padding-right:1.5rem}.small\\:text-base{font-size:1rem;line-height:1.5rem}.small\\:text-sm{font-size:.875rem;line-height:1.25rem}.small\\:font-bold{font-weight:700}}@media (min-width: 1280px){.large\\:h-20{height:5rem}.large\\:h-3\\/5{height:60%}.large\\:max-w-56{max-width:14rem}.large\\:gap-4{gap:1rem}.large\\:p-2{padding:.5rem}.large\\:p-4{padding:1rem}.large\\:text-base{font-size:1rem;line-height:1.5rem}.large\\:text-lg{font-size:1.125rem;line-height:1.75rem}}';
var Wc = { exports: {} }, Yr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mc;
function Sm() {
  if (mc) return Yr;
  mc = 1;
  var i = dl, m = Symbol.for("react.element"), s = Symbol.for("react.fragment"), y = Object.prototype.hasOwnProperty, C = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, _ = { key: !0, ref: !0, __self: !0, __source: !0 };
  function O(M, E, U) {
    var R, L = {}, V = null, W = null;
    U !== void 0 && (V = "" + U), E.key !== void 0 && (V = "" + E.key), E.ref !== void 0 && (W = E.ref);
    for (R in E) y.call(E, R) && !_.hasOwnProperty(R) && (L[R] = E[R]);
    if (M && M.defaultProps) for (R in E = M.defaultProps, E) L[R] === void 0 && (L[R] = E[R]);
    return { $$typeof: m, type: M, key: V, ref: W, props: L, _owner: C.current };
  }
  return Yr.Fragment = s, Yr.jsx = O, Yr.jsxs = O, Yr;
}
Wc.exports = Sm();
var rl = Wc.exports, Em = Object.defineProperty, Nm = (i, m, s) => m in i ? Em(i, m, { enumerable: !0, configurable: !0, writable: !0, value: s }) : i[m] = s, al = (i, m, s) => (Nm(i, typeof m != "symbol" ? m + "" : m, s), s);
const _m = {
  stringify: (i) => i,
  parse: (i) => i
}, Lm = {
  stringify: (i) => `${i}`,
  parse: (i) => parseFloat(i)
}, zm = {
  stringify: (i) => i ? "true" : "false",
  parse: (i) => /^[ty1-9]/i.test(i)
}, Mm = {
  stringify: (i) => i.name,
  parse: (i, m, s) => {
    const y = (() => {
      if (typeof window < "u" && i in window)
        return window[i];
      if (typeof global < "u" && i in global)
        return global[i];
    })();
    return typeof y == "function" ? y.bind(s) : void 0;
  }
}, Pm = {
  stringify: (i) => JSON.stringify(i),
  parse: (i) => JSON.parse(i)
}, ri = {
  string: _m,
  number: Lm,
  boolean: zm,
  function: Mm,
  json: Pm
};
function jm(i) {
  return i.replace(
    /([a-z0-9])([A-Z])/g,
    (m, s, y) => `${s}-${y.toLowerCase()}`
  );
}
const ll = Symbol.for("r2wc.render"), ol = Symbol.for("r2wc.connected"), Ln = Symbol.for("r2wc.context"), fn = Symbol.for("r2wc.props");
function Im(i, m, s) {
  var y, C, _;
  m.props || (m.props = i.propTypes ? Object.keys(i.propTypes) : []);
  const O = Array.isArray(m.props) ? m.props.slice() : Object.keys(m.props), M = {}, E = {}, U = {};
  for (const L of O) {
    M[L] = Array.isArray(m.props) ? "string" : m.props[L];
    const V = jm(L);
    E[L] = V, U[V] = L;
  }
  class R extends HTMLElement {
    constructor() {
      super(), al(this, y, !0), al(this, C), al(this, _, {}), al(this, "container"), m.shadow ? this.container = this.attachShadow({
        mode: m.shadow
      }) : this.container = this, this[fn].container = this.container;
      for (const V of O) {
        const W = E[V], x = this.getAttribute(W), N = M[V], z = N ? ri[N] : null;
        z != null && z.parse && x && (this[fn][V] = z.parse(x, W, this));
      }
    }
    static get observedAttributes() {
      return Object.keys(U);
    }
    connectedCallback() {
      this[ol] = !0, this[ll]();
    }
    disconnectedCallback() {
      this[ol] = !1, this[Ln] && s.unmount(this[Ln]), delete this[Ln];
    }
    attributeChangedCallback(V, W, x) {
      const N = U[V], z = M[N], Z = z ? ri[z] : null;
      N in M && Z != null && Z.parse && x && (this[fn][N] = Z.parse(x, V, this), this[ll]());
    }
    [(y = ol, C = Ln, _ = fn, ll)]() {
      this[ol] && (this[Ln] ? s.update(this[Ln], this[fn]) : this[Ln] = s.mount(
        this.container,
        i,
        this[fn]
      ));
    }
  }
  for (const L of O) {
    const V = E[L], W = M[L];
    Object.defineProperty(R.prototype, L, {
      enumerable: !0,
      configurable: !0,
      get() {
        return this[fn][L];
      },
      set(x) {
        this[fn][L] = x;
        const N = W ? ri[W] : null;
        if (N != null && N.stringify) {
          const z = N.stringify(x, V, this);
          this.getAttribute(V) !== z && this.setAttribute(V, z);
        } else
          this[ll]();
      }
    });
  }
  return R;
}
function Rm(i, m, s) {
  const y = Cc(i), C = dl.createElement(m, s);
  return y.render(C), {
    root: y,
    ReactComponent: m
  };
}
function Tm({ root: i, ReactComponent: m }, s) {
  const y = dl.createElement(m, s);
  i.render(y);
}
function Om({ root: i }) {
  i.unmount();
}
function fi(i, m = {}) {
  return Im(i, m, { mount: Rm, update: Tm, unmount: Om });
}
function Fm(i) {
  return i.replace(
    /([a-z0-9])([A-Z])/g,
    (m, s, y) => `${s}-${y.toLowerCase()}`
  );
}
function pi(i) {
  return Object.entries(i).reduce((m, [s, y]) => {
    if (y !== void 0) {
      const C = Fm(s);
      m[C] = y.toString();
    }
    return m;
  }, {});
}
const Vm = (i) => /* @__PURE__ */ rl.jsxs(rl.Fragment, { children: [
  /* @__PURE__ */ rl.jsx("style", { children: Cm }),
  /* @__PURE__ */ rl.jsx(bm, { ...i })
] }), Hm = fi(Vm, {
  shadow: "open",
  props: {
    compositionUrl: "string",
    hideCategories: "boolean",
    infiniteCarrousel: "boolean",
    permanentGallery: "boolean",
    minMediaWidth: "number",
    maxMediaWidth: "number",
    mediaLoadStrategy: "string",
    preventFullScreen: "boolean",
    eventPrefix: "string",
    reverse360: "boolean"
  }
}), $m = (i) => pi(i), Am = fi(wm, {
  shadow: "closed",
  props: {
    index: "number",
    thumbnailSrc: "string"
  }
}), Wm = (i) => pi(i), Bm = fi(km, {
  shadow: "closed",
  props: {
    name: "string"
  }
}), Dm = (i) => pi(i);
function Um() {
  return !!customElements.get(cl) && !!customElements.get(si) && !!customElements.get(ui);
}
function Ym() {
  customElements.define(cl, Hm), customElements.define(
    si,
    Am
  ), customElements.define(ui, Bm);
}
function Zm() {
  Um() || Ym();
}
const Km = /* @__PURE__ */ li({
  __name: "WebPlayer",
  props: {
    compositionUrl: {},
    hideCategories: { type: Boolean },
    infiniteCarrousel: { type: Boolean },
    permanentGallery: { type: Boolean },
    mediaLoadStrategy: {},
    minMediaWidth: {},
    maxMediaWidth: {},
    preloadRange: {},
    preventFullScreen: { type: Boolean },
    eventPrefix: {},
    reverse360: { type: Boolean },
    class: {},
    style: {}
  },
  emits: ["compositionLoading", "compositionLoaded", "compositionLoadError", "itemChange", "extendModeOn", "extendModeOff", "hotspotsOn", "hotspotsOff", "galleryOpen", "galleryClose"],
  setup(i, { emit: m }) {
    Zm();
    const s = i, { class: y, style: C, ..._ } = s, O = { display: "block", ...C ?? {} }, M = $m(_), E = m, U = s.eventPrefix ?? Gf, R = (W) => `${U}${W}`, L = {
      [Bf]: (W) => E("compositionLoading", W),
      [Df]: (W) => E("compositionLoaded", W),
      [Uf]: (W) => E("compositionLoadError", W),
      [Yf]: (W) => E("itemChange", W),
      [Zf]: () => E("extendModeOn"),
      [Qf]: () => E("extendModeOff"),
      [Xf]: () => E("hotspotsOn"),
      [Kf]: () => E("hotspotsOff"),
      [qf]: () => E("galleryOpen"),
      [Jf]: () => E("galleryClose")
    }, V = /* @__PURE__ */ new Map();
    return Object.entries(L).forEach(([W, x]) => {
      if (!x)
        return;
      const N = R(W), z = (Z) => x(Z.detail);
      V.set(N, z);
    }), Hf(() => {
      V.forEach((W, x) => {
        document.addEventListener(x, W);
      });
    }), $f(() => {
      V.forEach((W, x) => {
        document.removeEventListener(x, W);
      });
    }), (W, x) => (oi(), Af("cc-webplayer", Wf(sl(M), {
      class: sl(y),
      style: O
    }), [
      ii(W.$slots, "default")
    ], 16));
  }
}), qm = /* @__PURE__ */ li({
  __name: "WebPlayerCustomMedia",
  props: {
    index: {},
    thumbnailSrc: {}
  },
  setup(i) {
    const s = Wm(i);
    return (y, C) => {
      const _ = hc("cc-webplayer-custom-media");
      return oi(), gc(_, vc(bc(sl(s))), {
        default: yc(() => [
          ii(y.$slots, "default")
        ]),
        _: 3
      }, 16);
    };
  }
}), Jm = /* @__PURE__ */ li({
  __name: "WebPlayerIcon",
  props: {
    name: {}
  },
  setup(i) {
    const s = Dm(i);
    return (y, C) => {
      const _ = hc("cc-webplayer-icon");
      return oi(), gc(_, vc(bc(sl(s))), {
        default: yc(() => [
          ii(y.$slots, "default")
        ]),
        _: 3
      }, 16);
    };
  }
});
export {
  dp as DEFAULT_EVENT_PREFIX,
  tp as EVENT_COMPOSITION_LOADED,
  ep as EVENT_COMPOSITION_LOADING,
  np as EVENT_COMPOSITION_LOAD_ERROR,
  lp as EVENT_EXTEND_MODE_OFF,
  ap as EVENT_EXTEND_MODE_ON,
  up as EVENT_GALLERY_CLOSE,
  sp as EVENT_GALLERY_OPEN,
  ip as EVENT_HOTSPOTS_OFF,
  op as EVENT_HOTSPOTS_ON,
  rp as EVENT_ITEM_CHANGE,
  ui as WEB_PLAYER_ICON_WC_TAG,
  cl as WEB_PLAYER_WC_TAG,
  Km as WebPlayer,
  qm as WebPlayerCustomMedia,
  Jm as WebPlayerIcon,
  Xm as generateCompositionUrl
};
